import {
  Avatar,
  Button,
  Card,
  Dialog,
  FormControl,
  Grid,
  IconButton,
  MenuItem,
  Popover,
  Select,
  Stack,
  Switch,
  Typography,
  useMediaQuery,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import { makeStyles, styled } from '@mui/styles';
import { Box } from '@mui/system';
import { getApiCall } from 'api/apiService';
import { LoaderContext } from 'component/Loader/LoaderContextProvider';
import PropTypes from 'prop-types';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { toast } from 'react-toastify';
import {
  displayFlex,
  fontsize10,
  fontsize12,
  poppins400,
  poppins500,
  poppins600,
} from 'theme/common.style';
import All from './All';
// import NoData from "assets/images/nodata.png";
import LiveActivityFeed from './LiveActivityFeed';
// import { ReactComponent as RelationShipScore } from "assets/icons/meter.svg";
import { BuyerCard2Buyermatch } from 'component/BuyerCard2Buyermatch/BuyerCard2Buyermatch';
import { BuyerCard2Insights } from 'component/BuyerCard2Insights/BuyerCard2Insights';
// import { SelectChangeEvent } from '@mui/material/Select';
import Slide from '@mui/material/Slide';
import { Feedback } from 'component/BuyersCard/Feedback';
import './OwnerCard.css';
// import {custom-dropdown} from "./OwnerCard.style"
import PlaceholderImage from 'assets/svg/Placeholder.svg';
import { collectId } from 'component/ContactTab/Table';
import { ExpandedBuyersCard } from 'component/ExpandedBuyerCard/ExpandedBuyersCard';
import MessagingContainer from 'component/MessagingContainer/MessagingContainer';
import { PropertyContext } from 'component/PropertyContext/PropertyContext';
import {
  API_URL,
  APP_SCALE,
  DESKTOP_BREAKPOINT,
  GET_BINDERID,
  PROPERTYLIST_COMMON,
} from 'constant/app.config';
import moment from 'moment';
import { OwnerCardProfile } from './OwnerCardProfile';
import OwnerDetailsNavigation from './OwnerDetailsNavigation';
import Monetize from 'assets/icons/dollar.svg';
import BlueTick from 'assets/icons/blueTick.svg';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="left" ref={ref} {...props} />;
});

export const peopleIcon = () => {
  return (
    <svg
      width="32"
      height="24"
      viewBox="0 0 32 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.7273 22.0705L7.72725 22.0639C7.72492 20.42 8.05265 18.7923 8.69116 17.2752C9.10855 16.2834 9.65325 15.3519 10.3099 14.5029C9.99795 14.4599 9.68273 14.438 9.36646 14.4375C9.36625 14.4375 9.36604 14.4375 9.36582 14.4375L8.08801 14.4375M7.7273 22.0705L8.08727 13.4375M7.7273 22.0705C7.72846 22.2141 7.73548 22.3574 7.74832 22.5H1.45455C1.33021 22.5 1.21331 22.4511 1.12895 22.3677C1.04499 22.2847 1 22.1747 1 22.0625V21.4309M7.7273 22.0705L0 21.43M8.08801 14.4375H8.08727V13.4375M8.08801 14.4375C8.08836 14.4375 8.0887 14.4375 8.08905 14.4375L8.08727 13.4375M8.08801 14.4375C6.20552 14.4411 4.40349 15.1819 3.07588 16.4939C1.74864 17.8056 1.00359 19.5811 1 21.4309M8.08727 13.4375C5.94358 13.4413 3.88878 14.2846 2.37295 15.7826C0.85713 17.2807 0.00384521 19.3114 0 21.43M1 21.4309V21.43H0M1 21.4309C0.999999 21.4312 0.999999 21.4315 0.999998 21.4318L0 21.43M12.1455 13.9406C11.7911 13.8084 11.4283 13.7018 11.0599 13.6214L11.4007 14.7434C11.6355 14.4648 11.884 14.1968 12.1455 13.9406ZM31 22.0625C31 22.1747 30.955 22.2847 30.871 22.3677C30.7867 22.4511 30.6698 22.5 30.5455 22.5H13.0909C12.9666 22.5 12.8497 22.4511 12.7653 22.3677C12.6814 22.2847 12.6364 22.1747 12.6364 22.0625C12.6364 20.0441 13.4476 18.1059 14.8955 16.675C16.3437 15.2437 18.3105 14.4375 20.3636 14.4375H23.2727C25.3259 14.4375 27.2927 15.2437 28.7409 16.675C30.1888 18.1059 31 20.0441 31 22.0625ZM19.1368 2.30353C19.9295 1.78009 20.8626 1.5 21.8182 1.5C23.0998 1.5 24.3266 2.00327 25.2293 2.8954C26.1316 3.78713 26.6364 4.99405 26.6364 6.25C26.6364 7.18682 26.3553 8.10358 25.8274 8.88443C25.2994 9.66542 24.5476 10.2759 23.6659 10.6368C22.784 10.9978 21.8129 11.0925 20.876 10.9083C19.9391 10.7241 19.0801 10.2698 18.407 9.6046C17.7341 8.93952 17.2771 8.0936 17.0921 7.17446C16.9072 6.25538 17.002 5.30261 17.3652 4.43612C17.7284 3.5695 18.3443 2.82688 19.1368 2.30353ZM6.04591 2.30353C6.83858 1.78009 7.77172 1.5 8.72727 1.5C10.0089 1.5 11.2357 2.00327 12.1384 2.8954C13.0407 3.78713 13.5455 4.99405 13.5455 6.25C13.5455 7.18682 13.2644 8.10358 12.7365 8.88443C12.2085 9.66542 11.4567 10.2759 10.5749 10.6368C9.69308 10.9978 8.72204 11.0925 7.78509 10.9083C6.84821 10.7241 5.98921 10.2698 5.31612 9.6046C4.64316 8.93952 4.18622 8.0936 4.00123 7.17446C3.81624 6.25538 3.91107 5.30261 4.27424 4.43612C4.63747 3.5695 5.25337 2.82687 6.04591 2.30353Z"
        stroke="#112347"
        stroke-width="2"
      />
    </svg>
  );
};

const BackLeftArrow = () => {
  return (
    <svg
      width="16"
      height="14"
      viewBox="0 0 16 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.70689 0.293048C7.89436 0.480744 7.99968 0.735279 7.99968 1.00068C7.99968 1.26608 7.89436 1.52062 7.70689 1.70831L3.41383 6.00515H15C15.2652 6.00515 15.5196 6.1106 15.7071 6.2983C15.8946 6.48601 16 6.74059 16 7.00604C16 7.2715 15.8946 7.52608 15.7071 7.71378C15.5196 7.90148 15.2652 8.00694 15 8.00694H3.41383L7.70689 12.3038C7.88905 12.4925 7.98985 12.7454 7.98757 13.0078C7.98529 13.2702 7.88012 13.5213 7.69471 13.7068C7.5093 13.8924 7.25848 13.9977 6.99628 14C6.73408 14.0022 6.48148 13.9014 6.29287 13.719L0.292791 7.71367C0.105317 7.52598 0 7.27144 0 7.00604C0 6.74064 0.105317 6.48611 0.292791 6.29841L6.29287 0.293048C6.4804 0.10541 6.73471 0 6.99988 0C7.26505 0 7.51936 0.10541 7.70689 0.293048Z"
        fill="#6C2AD2"
      />
    </svg>
  );
};

export const ExpandIcon = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 31 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        opacity="0.1"
        x="0.863281"
        y="0.5"
        width="29"
        height="29"
        rx="4.5"
        stroke="#112347"
      />
      <path
        d="M17.6924 7.19042L23.1825 7.19042L23.1825 12.6949"
        stroke="#6C2AD2"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M22.8633 7.5L17.6133 12.75"
        stroke="#6C2AD2"
        stroke-width="2"
        stroke-linecap="round"
      />
      <path
        d="M14.0381 21.8106L8.54795 21.8106L8.54795 16.3061"
        stroke="#6C2AD2"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.1133 16.2559L8.86328 21.5059"
        stroke="#6C2AD2"
        stroke-width="2"
        stroke-linecap="round"
      />
    </svg>
  );
};
export const RightArrow = () => {
  return (
    <svg
      width="31"
      height="30"
      viewBox="0 0 31 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        opacity="0.1"
        x="0.863281"
        y="0.5"
        width="29"
        height="29"
        rx="4.5"
        stroke="#112347"
      />
      <path
        d="M14.1133 8.375L20.2061 14.4678L14.1133 20.5605"
        stroke="#6C2AD2"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const IOSSwitch = styled((props) => {
  return <Switch focusVisibleClassName=".Mui-focusVisible" {...props} />;
})(({ theme }) => ({
  width: 42,
  height: 26,
  padding: 0,
  marginLeft: 10,
  marginRight: 10,
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: 7,
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(16px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        background:
          theme.palette.mode === 'dark'
            ? '#2ECA45'
            : `linear-gradient(140.46deg, #6C2AD2 -27.13%, #77CFFE 121.57%)`,
        opacity: 1,
        border: 0,
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.5,
      },
    },
    '&.Mui-focusVisible .MuiSwitch-thumb': {
      color: 'red',
      border: '6px solid #fff',
    },
    '&.Mui-disabled .MuiSwitch-thumb': {
      color:
        theme.palette.mode === 'light'
          ? theme.palette.grey[100]
          : theme.palette.grey[600],
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      opacity: theme.palette.mode === 'light' ? 0.7 : 0.3,
    },
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: 22,
    height: 22,
  },
  '& .MuiSwitch-track': {
    borderRadius: 26 / 2,
    backgroundColor: theme.palette.mode === 'light' ? '#E9E9EA' : 'red',
    opacity: 1,
    transition: theme.transitions.create(['background-color'], {
      duration: 500,
    }),
  },
}));
export const TickMark = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.3039 5.65056L7.82391 10.7706C7.76566 10.8371 7.68247 10.8768 7.59416 10.88H7.58328C7.49816 10.88 7.41688 10.8461 7.35738 10.7859L5.43738 8.86591C5.31194 8.74109 5.31194 8.53888 5.43738 8.41344C5.56219 8.28863 5.76441 8.28863 5.88984 8.41344L7.56794 10.0915L11.8227 5.22944C11.9391 5.09631 12.1414 5.08353 12.2738 5.19934C12.407 5.31584 12.421 5.51744 12.3039 5.65056ZM16.8633 8C16.8633 7.38687 16.5094 6.84862 15.9961 6.58112C16.3686 6.13759 16.4889 5.50466 16.2547 4.93888C16.0204 4.37247 15.4879 4.01025 14.91 3.95969C15.0848 3.40737 14.9542 2.77697 14.5203 2.34306C14.0864 1.90978 13.4566 1.77731 12.9036 1.95331C12.8531 1.37541 12.4908 0.842906 11.9244 0.608688C11.358 0.375094 10.7257 0.494781 10.2822 0.86725C10.0147 0.353906 9.47641 0 8.86328 0C8.25016 0 7.71191 0.353906 7.44441 0.867188C7.00087 0.494719 6.36856 0.374375 5.80216 0.608625C5.23575 0.842875 4.87353 1.37534 4.82359 1.95325C4.26934 1.77725 3.63959 1.90972 3.20631 2.343C2.77241 2.77691 2.64184 3.40731 2.81656 3.95963C2.23866 4.01019 1.70616 4.37244 1.47194 4.93881C1.23769 5.50456 1.35803 6.13753 1.7305 6.58106C1.21719 6.84862 0.863281 7.38687 0.863281 8C0.863281 8.61313 1.21719 9.15137 1.73047 9.41887C1.358 9.86241 1.23766 10.4947 1.47191 11.0611C1.70616 11.6275 2.23863 11.9891 2.81719 12.0397C2.64181 12.5927 2.77237 13.2231 3.20631 13.657C3.63959 14.0903 4.26934 14.2221 4.82359 14.0467C4.8735 14.624 5.23575 15.1571 5.80216 15.3913C6.36984 15.6256 7.00153 15.5053 7.44441 15.1322C7.71191 15.6461 8.25016 16 8.86328 16C9.47641 16 10.0147 15.6461 10.2822 15.1322C10.725 15.5046 11.3573 15.6243 11.9244 15.3913C12.4908 15.1571 12.853 14.624 12.9036 14.0467C13.4566 14.2221 14.0863 14.0903 14.5202 13.657C14.9541 13.2231 15.0847 12.5927 14.9093 12.0397C15.4879 11.9891 16.0204 11.6275 16.2546 11.0611C16.4889 10.4947 16.3685 9.86241 15.9961 9.41887C16.5094 9.15137 16.8633 8.61313 16.8633 8Z"
        fill="url(#paint0_linear_12294_29936)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_12294_29936"
          x1="8.8633"
          y1="-2.1625e-05"
          x2="8.8633"
          y2="16"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#1AD6FD" />
          <stop offset="1" stop-color="#1D67F0" />
        </linearGradient>
      </defs>
    </svg>
  );
};
export const Dollar = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.86328 16C13.2816 16 16.8633 12.4183 16.8633 8C16.8633 3.58172 13.2816 0 8.86328 0C4.445 0 0.863281 3.58172 0.863281 8C0.863281 12.4183 4.445 16 8.86328 16Z"
        fill="url(#paint0_linear_12294_29937)"
      />
      <path
        opacity="0.49"
        d="M16.6146 9.97887L9.70577 3.07007H7.91236V3.86047C6.54071 4.10575 5.73297 4.95128 5.73297 6.25452C5.73297 6.95957 5.95332 7.44645 6.29092 7.79519L7.90446 9.40872H5.625C5.625 10.1886 5.88481 10.8266 6.3507 11.2921L10.8173 15.7587C12.2139 15.4054 13.4895 14.6821 14.5097 13.6649C15.5299 12.6478 16.257 11.3744 16.6146 9.97887Z"
        fill="url(#paint1_linear_12294_29937)"
      />
      <path
        d="M9.79031 12.0885V12.9297H7.99691V12.0935C6.5347 11.8268 5.62891 10.8649 5.62891 9.40866H7.92382C7.92382 9.95192 8.36782 10.2233 8.86462 10.2233C9.33051 10.2233 9.77447 9.98613 9.77447 9.57199C9.77447 9.06908 9.15156 8.92328 8.38782 8.73452C7.22167 8.44472 5.73687 8.08469 5.73687 6.25452C5.73687 4.95128 6.54462 4.10575 7.91627 3.86047V3.07007H9.70967V3.86869C11.0729 4.13461 11.8414 5.03295 11.8414 6.37013L9.61294 6.37516C9.61294 5.90392 9.23588 5.67375 8.77511 5.67375C8.37479 5.67375 7.99259 5.83852 7.99259 6.18575C7.99259 6.64584 8.59665 6.79666 9.36167 6.99061C10.55 7.29743 12.1018 7.68661 12.1018 9.52767C12.1017 10.9651 11.1735 11.8322 9.79031 12.0885Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_12294_29937"
          x1="0.863281"
          y1="8"
          x2="16.8633"
          y2="8"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#2BC4F3" />
          <stop offset="0.5" stop-color="#00AEEE" />
          <stop offset="1" stop-color="#0095DA" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_12294_29937"
          x1="5.90686"
          y1="5.0597"
          x2="14.5109"
          y2="13.6637"
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset="1" stop-opacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};
export const PhoneIcon = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 31 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        opacity="0.1"
        x="0.863281"
        y="0.5"
        width="29"
        height="29"
        rx="4.5"
        stroke="#112347"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.9797 11.6319C11.1506 11.349 12.092 10.32 12.7638 10.351C12.9646 10.3677 13.1422 10.4892 13.2864 10.6301C13.6176 10.9535 14.5657 12.1767 14.6195 12.434C14.7504 13.0653 13.9982 13.4292 14.2284 14.0655C14.8153 15.5017 15.8266 16.513 17.2635 17.0993C17.8992 17.3296 18.2632 16.5773 18.8945 16.7088C19.1513 16.7626 20.3751 17.7107 20.6985 18.0418C20.8389 18.1855 20.9609 18.3636 20.9776 18.5644C21.0026 19.2717 19.9097 20.2264 19.6967 20.3484C19.194 20.7079 18.5383 20.7018 17.7389 20.3301C15.5082 19.402 11.9433 15.9045 10.998 13.5896C10.6363 12.7946 10.6113 12.1345 10.9797 11.6319Z"
        stroke="#6C2AD2"
        stroke-width="0.81025"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const EmailIcon = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 31 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        opacity="0.1"
        x="0.863281"
        y="0.5"
        width="29"
        height="29"
        rx="4.5"
        stroke="#112347"
      />
      <path
        d="M8.36328 11.5C8.36328 10.3954 9.25871 9.5 10.3633 9.5H21.3633C22.4679 9.5 23.3633 10.3954 23.3633 11.5V18.125C23.3633 19.2296 22.4679 20.125 21.3633 20.125H10.3633C9.25871 20.125 8.36328 19.2296 8.36328 18.125V11.5Z"
        stroke="#6C2AD2"
        stroke-linejoin="round"
      />
      <path
        d="M9.78459 10.8029C9.28037 10.3407 9.60738 9.5 10.2914 9.5H21.4352C22.1192 9.5 22.4462 10.3407 21.942 10.8029L17.8905 14.5168C16.7435 15.5681 14.9831 15.5681 13.8361 14.5168L9.78459 10.8029Z"
        stroke="#6C2AD2"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const LocationIcon = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 31 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        opacity="0.1"
        x="0.863281"
        y="0.5"
        width="29"
        height="29"
        rx="4.5"
        stroke="#112347"
      />
      <path
        d="M15.3359 23.0613L15.3359 23.0613C15.2286 22.9418 13.8461 21.3906 12.4935 19.3661C11.8172 18.3538 11.1551 17.2331 10.6635 16.1214C10.1692 15.0035 9.86328 13.9301 9.86328 13.0027C9.86328 9.96894 12.3322 7.5 15.366 7.5C18.3997 7.5 20.8686 9.96894 20.8687 13.0027C20.8687 13.9301 20.5628 15.0035 20.0685 16.1214C19.5769 17.2331 18.9148 18.3538 18.2385 19.3661C16.8858 21.3906 15.5034 22.9418 15.3961 23.0613L15.3961 23.0613C15.3801 23.0791 15.3518 23.079 15.3359 23.0613ZM14.9638 23.3953C15.1787 23.6346 15.5537 23.6342 15.7682 23.3953C15.9969 23.1406 21.3687 17.1103 21.3687 13.0027C21.3686 9.6928 18.6759 7 15.366 7C12.0561 7 9.36328 9.6928 9.36328 13.0027C9.36328 17.1103 14.7351 23.1406 14.9638 23.3953ZM11.8459 13.0027C11.8459 14.9441 13.4245 16.5228 15.366 16.5228C17.3074 16.5228 18.886 14.9442 18.886 13.0027C18.886 11.0613 17.3074 9.4826 15.366 9.4826C13.4246 9.4826 11.8459 11.0612 11.8459 13.0027Z"
        stroke="#6C2AD2"
      />
    </svg>
  );
};
export const BedIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_12294_29983)">
        <path
          d="M2.10938 8.89211H14.6197C15.1354 8.89211 15.5533 8.47413 15.5533 7.95851C15.5533 7.44288 15.1354 7.0249 14.6197 7.0249H2.10938C1.59376 7.0249 1.17578 7.44288 1.17578 7.95851C1.17575 8.47413 1.59376 8.89211 2.10938 8.89211Z"
          fill="#6C2AD2"
        />
        <path
          d="M9.29884 5.01123C9.02635 5.01123 8.80469 5.23289 8.80469 5.50538V6.14602H12.6291V5.50538C12.6291 5.23289 12.4074 5.01123 12.1349 5.01123H9.29884Z"
          fill="#6C2AD2"
        />
        <path
          d="M3.21938 5.50547C3.21938 4.74835 3.83531 4.13241 4.59243 4.13241H7.42852C7.78881 4.13241 8.11693 4.2721 8.36212 4.49991C8.6073 4.2721 8.93543 4.13241 9.29572 4.13241H12.1318C12.8889 4.13241 13.5049 4.74835 13.5049 5.50547V6.1461H14.9313V3.11915C14.9313 2.60353 14.5133 2.18555 13.9977 2.18555H2.72657C2.21095 2.18555 1.79297 2.60353 1.79297 3.11915V6.1461H3.21938V5.50547Z"
          fill="#6C2AD2"
        />
        <path
          d="M4.59181 5.01123C4.31932 5.01123 4.09766 5.23289 4.09766 5.50538V6.14602H7.92204V5.50538C7.92204 5.23289 7.70038 5.01123 7.42789 5.01123H4.59181Z"
          fill="#6C2AD2"
        />
        <path
          d="M0.863281 9.77124V13.8147H1.74219V12.2123H14.9844V13.8147H15.8633V9.77124H0.863281Z"
          fill="#6C2AD2"
        />
      </g>
      <defs>
        <clipPath id="clip0_12294_29983">
          <rect
            width="15"
            height="15"
            fill="white"
            transform="translate(0.863281 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
export const ShowerIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_12294_29992)">
        <path
          d="M13.4883 0.5C13.0741 0.5 12.7383 0.835781 12.7383 1.25V1.5H7.23828C6.54828 1.50081 5.98909 2.06 5.98828 2.75V4H5.48828C5.07406 4 4.73828 4.33578 4.73828 4.75V5.61125C3.64931 6.28247 2.98678 7.47078 2.98828 8.75V9.046C2.68969 9.15156 2.48959 9.43331 2.48828 9.75V10.25C2.48828 10.3881 2.60022 10.5 2.73828 10.5H10.7383C10.8763 10.5 10.9883 10.3881 10.9883 10.25V9.75C10.987 9.43331 10.7869 9.15156 10.4883 9.046V8.75C10.4897 7.7545 10.0938 6.79959 9.38828 6.09725C9.19222 5.90819 8.97394 5.74356 8.73828 5.607V4.75C8.73828 4.33578 8.4025 4 7.98828 4H7.48828V3.25C7.48828 3.11194 7.60022 3 7.73828 3H12.7383V3.5C12.7383 3.91422 13.0741 4.25 13.4883 4.25H14.2383V0.5H13.4883ZM10.4883 9.75V10H2.98828V9.75C2.98828 9.61194 3.10022 9.5 3.23828 9.5H10.2383C10.3763 9.5 10.4883 9.61194 10.4883 9.75ZM9.03603 6.4515C9.64697 7.06022 9.98972 7.88756 9.98828 8.75V9H3.48828V8.75C3.48747 7.62038 4.08391 6.5745 5.05653 6H8.42178C8.64541 6.12297 8.85194 6.27475 9.03603 6.4515ZM7.98828 4.5C8.12634 4.5 8.23828 4.61194 8.23828 4.75V5.5H5.23828V4.75C5.23828 4.61194 5.35022 4.5 5.48828 4.5H7.98828ZM12.7383 2.5H7.73828C7.32406 2.5 6.98828 2.83578 6.98828 3.25V4H6.48828V2.75C6.48828 2.33578 6.82406 2 7.23828 2H12.7383V2.5ZM13.7383 3.75H13.4883C13.3502 3.75 13.2383 3.63806 13.2383 3.5V1.25C13.2383 1.11194 13.3502 1 13.4883 1H13.7383V3.75Z"
          fill="#6C2AD2"
        />
        <path
          d="M6.73828 11C6.60022 11 6.48828 11.1119 6.48828 11.25V12.25C6.48828 12.3881 6.60022 12.5 6.73828 12.5C6.87634 12.5 6.98828 12.3881 6.98828 12.25V11.25C6.98828 11.1119 6.87634 11 6.73828 11Z"
          fill="#6C2AD2"
        />
        <path
          d="M6.73828 13C6.60022 13 6.48828 13.1119 6.48828 13.25V14.25C6.48828 14.3881 6.60022 14.5 6.73828 14.5C6.87634 14.5 6.98828 14.3881 6.98828 14.25V13.25C6.98828 13.1119 6.87634 13 6.73828 13Z"
          fill="#6C2AD2"
        />
        <path
          d="M9.73828 12C9.60022 12 9.48828 12.1119 9.48828 12.25V13.25C9.48828 13.3881 9.60022 13.5 9.73828 13.5C9.87634 13.5 9.98828 13.3881 9.98828 13.25V12.25C9.98828 12.1119 9.87634 12 9.73828 12Z"
          fill="#6C2AD2"
        />
        <path
          d="M7.73828 12C7.60022 12 7.48828 12.1119 7.48828 12.25V13.25C7.48828 13.3881 7.60022 13.5 7.73828 13.5C7.87634 13.5 7.98828 13.3881 7.98828 13.25V12.25C7.98828 12.1119 7.87634 12 7.73828 12Z"
          fill="#6C2AD2"
        />
        <path
          d="M5.73828 12C5.60022 12 5.48828 12.1119 5.48828 12.25V13.25C5.48828 13.3881 5.60022 13.5 5.73828 13.5C5.87634 13.5 5.98828 13.3881 5.98828 13.25V12.25C5.98828 12.1119 5.87634 12 5.73828 12Z"
          fill="#6C2AD2"
        />
        <path
          d="M3.73828 12C3.60022 12 3.48828 12.1119 3.48828 12.25V13.25C3.48828 13.3881 3.60022 13.5 3.73828 13.5C3.87634 13.5 3.98828 13.3881 3.98828 13.25V12.25C3.98828 12.1119 3.87634 12 3.73828 12Z"
          fill="#6C2AD2"
        />
        <path
          d="M4.73828 11C4.60022 11 4.48828 11.1119 4.48828 11.25V12.25C4.48828 12.3881 4.60022 12.5 4.73828 12.5C4.87634 12.5 4.98828 12.3881 4.98828 12.25V11.25C4.98828 11.1119 4.87634 11 4.73828 11Z"
          fill="#6C2AD2"
        />
        <path
          d="M8.73828 11C8.60022 11 8.48828 11.1119 8.48828 11.25V12.25C8.48828 12.3881 8.60022 12.5 8.73828 12.5C8.87634 12.5 8.98828 12.3881 8.98828 12.25V11.25C8.98828 11.1119 8.87634 11 8.73828 11Z"
          fill="#6C2AD2"
        />
        <path
          d="M8.73828 13C8.60022 13 8.48828 13.1119 8.48828 13.25V14.25C8.48828 14.3881 8.60022 14.5 8.73828 14.5C8.87634 14.5 8.98828 14.3881 8.98828 14.25V13.25C8.98828 13.1119 8.87634 13 8.73828 13Z"
          fill="#6C2AD2"
        />
        <path
          d="M4.73828 13C4.60022 13 4.48828 13.1119 4.48828 13.25V14.25C4.48828 14.3881 4.60022 14.5 4.73828 14.5C4.87634 14.5 4.98828 14.3881 4.98828 14.25V13.25C4.98828 13.1119 4.87634 13 4.73828 13Z"
          fill="#6C2AD2"
        />
        <path
          d="M5.73828 14C5.60022 14 5.48828 14.1119 5.48828 14.25V15.25C5.48828 15.3881 5.60022 15.5 5.73828 15.5C5.87634 15.5 5.98828 15.3881 5.98828 15.25V14.25C5.98828 14.1119 5.87634 14 5.73828 14Z"
          fill="#6C2AD2"
        />
        <path
          d="M7.73828 14C7.60022 14 7.48828 14.1119 7.48828 14.25V15.25C7.48828 15.3881 7.60022 15.5 7.73828 15.5C7.87634 15.5 7.98828 15.3881 7.98828 15.25V14.25C7.98828 14.1119 7.87634 14 7.73828 14Z"
          fill="#6C2AD2"
        />
      </g>
      <defs>
        <clipPath id="clip0_12294_29992">
          <rect
            width="15"
            height="15"
            fill="white"
            transform="translate(0.863281 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
export const CarIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_12294_30034)">
        <path
          d="M11.5005 6.99815C11.4523 6.99815 11.4027 7.00509 11.3532 7.01868L10.7933 7.17291L10.212 5.7567C10.0473 5.3555 9.56046 5.02905 9.12679 5.02905H3.68596C3.25224 5.02905 2.76545 5.3555 2.60077 5.7567L2.02019 7.17093L1.46725 7.01863C1.41777 7.00503 1.36823 6.9981 1.31996 6.9981C1.05532 6.9981 0.863281 7.20026 0.863281 7.47872V7.80874C0.863281 8.13382 1.12781 8.39835 1.45288 8.39835H1.51624L1.42239 8.62693C1.26938 8.99956 1.14482 9.63066 1.14482 10.0337V12.8471C1.14482 13.1722 1.40935 13.4367 1.73442 13.4367H2.50445C2.82952 13.4367 3.09405 13.1722 3.09405 12.8471V12.1446H9.71864V12.8471C9.71864 13.1722 9.98317 13.4367 10.3082 13.4367H11.0782C11.4032 13.4367 11.6678 13.1722 11.6678 12.8471V10.0337C11.6678 9.63077 11.5432 8.99967 11.3902 8.62699L11.2963 8.3984H11.3676C11.6926 8.3984 11.9572 8.13387 11.9572 7.8088V7.47877C11.9572 7.20032 11.7651 6.99815 11.5005 6.99815ZM2.44285 8.07817L3.3223 5.93608C3.42083 5.6961 3.71365 5.49971 3.97306 5.49971H8.83969C9.0991 5.49971 9.39192 5.69604 9.49044 5.93608L10.3699 8.07817C10.4684 8.31815 10.3368 8.51454 10.0773 8.51454H2.73545C2.47599 8.51448 2.34439 8.31815 2.44285 8.07817ZM4.40601 10.7877C4.40601 10.9174 4.29984 11.0235 4.17021 11.0235H2.4996C2.36987 11.0235 2.26375 10.9174 2.26375 10.7877V9.98596C2.26375 9.85628 2.36987 9.75016 2.4996 9.75016H4.17021C4.29984 9.75016 4.40601 9.85628 4.40601 9.98596V10.7877ZM10.5331 10.7877C10.5331 10.9174 10.427 11.0235 10.2973 11.0235H8.62674C8.49711 11.0235 8.39094 10.9174 8.39094 10.7877V9.98596C8.39094 9.85628 8.49711 9.75016 8.62674 9.75016H10.2973C10.427 9.75016 10.5331 9.85628 10.5331 9.98596V10.7877Z"
          fill="#6C2AD2"
        />
        <path
          d="M15.1276 2.56323H12.3351C11.9285 2.56323 11.5977 2.89409 11.5977 3.30067V6.09325C11.5977 6.49989 11.9285 6.83074 12.3351 6.83074H13.4561V13.0984C13.4561 13.2504 13.5793 13.3736 13.7313 13.3736C13.8834 13.3736 14.0065 13.2504 14.0065 13.0984V6.8308H15.1276C15.5343 6.8308 15.8651 6.49995 15.8651 6.0933V3.30073C15.8651 2.89409 15.5343 2.56323 15.1276 2.56323ZM14.4951 4.87865C14.3345 5.02324 14.098 5.09656 13.792 5.09656H13.3877C13.3391 5.09656 13.2996 5.13613 13.2996 5.18468V5.86659C13.2996 5.94067 13.2393 6.00089 13.1652 6.00089H12.859C12.7848 6.00089 12.7246 5.94062 12.7246 5.86659V3.52761C12.7246 3.45347 12.7849 3.3932 12.859 3.3932H13.6304C14.1415 3.3932 14.3323 3.4702 14.489 3.60324C14.6544 3.74354 14.7381 3.95842 14.7381 4.24204C14.7381 4.51918 14.6564 4.73329 14.4951 4.87865Z"
          fill="#6C2AD2"
        />
        <path
          d="M14.0586 3.95803C13.984 3.90167 13.8519 3.87305 13.6662 3.87305H13.3888C13.3403 3.87305 13.3008 3.91257 13.3008 3.96106V4.52149C13.3008 4.56998 13.3403 4.6095 13.3888 4.6095H13.555C13.6161 4.6095 13.7147 4.60498 13.7749 4.59943C13.8333 4.59409 13.9981 4.5702 14.0586 4.52451C14.1312 4.46958 14.168 4.37458 14.168 4.24221C14.168 4.10857 14.1312 4.01296 14.0586 3.95803Z"
          fill="#6C2AD2"
        />
      </g>
      <defs>
        <clipPath id="clip0_12294_30034">
          <rect
            width="15"
            height="15"
            fill="white"
            transform="translate(0.863281 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Home2 = ({ color = '#000000' }) => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_15615_64182)">
        <path
          d="M21.2038 10.6716L17.3291 7.36277C17.3337 7.34013 17.3382 7.3175 17.3427 7.29034V2.96303C17.3382 2.70502 17.1345 2.4968 16.8765 2.48775H14.7128C14.4639 2.48775 14.2602 2.70955 14.2602 2.96303V4.75552L11.1596 2.11205C10.9921 1.96721 10.7431 1.96721 10.5711 2.11205L0.526864 10.6671C0.332225 10.8255 0.309593 11.1107 0.46802 11.3053C0.626446 11.5 0.911614 11.5226 1.10625 11.3642C1.11078 11.3596 1.11078 11.3596 1.11531 11.3551L10.8653 3.05356L14.3553 6.02746L16.442 7.80183L20.6199 11.3596C20.81 11.5226 21.0952 11.5 21.2581 11.3099C21.4166 11.1197 21.3939 10.8346 21.2038 10.6716ZM16.4329 6.59779L15.1655 5.52954V3.39757H16.4329V6.59779Z"
          fill={color}
        />
        <path
          d="M19.2066 11.5854L17.9346 10.4991L11.1585 4.70971C10.991 4.56486 10.742 4.56486 10.57 4.70971L3.79391 10.4991L2.52197 11.5854C2.33185 11.7484 2.30922 12.0335 2.47218 12.2237C2.6306 12.4138 2.91124 12.4364 3.09683 12.278L3.10136 12.2735L3.66717 11.7846V20.2717C3.67169 20.5252 3.87991 20.7334 4.13339 20.738H17.5906C17.8441 20.7334 18.0523 20.5297 18.0568 20.2717V11.7846L18.6226 12.2735C18.7041 12.3413 18.8037 12.3821 18.9123 12.3821C19.0436 12.3821 19.1703 12.3232 19.2564 12.2237C19.4238 12.029 19.3967 11.7439 19.2066 11.5854ZM12.6749 19.8281H9.05367V14.9395H12.6749V19.8281ZM13.5801 19.8281V14.5005C13.5801 14.2515 13.3946 14.0343 13.1456 14.0343H8.58292C8.33396 14.0343 8.14838 14.2515 8.14838 14.5005V19.8281H4.57246V11.0106L10.8643 5.65122L17.1561 11.0106V19.8281H13.5801Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_15615_64182">
          <rect
            width="21"
            height="21"
            fill="white"
            transform="translate(0.363281 0.870605)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
export const MarketIcon = ({ color = '#000000' }) => {
  return (
    <svg
      width="22"
      height="20"
      viewBox="0 0 22 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.3633 7.23476H21.3543C21.3711 7.16179 21.3633 7.08423 21.3291 7.01525L18.3906 1.09292C18.3351 0.981232 18.2213 0.910645 18.0966 0.910645H3.62997C3.50532 0.910645 3.39146 0.981273 3.33601 1.09292L0.397447 7.01525C0.36324 7.08423 0.355447 7.16179 0.372305 7.23476H0.363281C0.363281 8.18833 0.830941 9.03428 1.54855 9.55674V19.5034C1.54855 19.6846 1.69547 19.8315 1.87668 19.8315H19.8499C20.0311 19.8315 20.178 19.6846 20.178 19.5034V9.55674C20.8956 9.03428 21.3633 8.18829 21.3633 7.23476ZM18.4922 9.4496C17.357 9.4496 16.4191 8.59098 16.2924 7.48918H20.692C20.5653 8.59102 19.6274 9.4496 18.4922 9.4496ZM10.5352 6.83293H6.15936L6.96335 1.56685H10.5352V6.83293ZM11.1914 1.56689H14.7632L15.5672 6.83297H11.1914V1.56689ZM10.5201 7.48918C10.3934 8.59098 9.4555 9.4496 8.32031 9.4496C7.18512 9.4496 6.24718 8.59098 6.12052 7.48918H10.5201ZM15.606 7.48918C15.4794 8.59098 14.5414 9.4496 13.4062 9.4496C12.2711 9.4496 11.3331 8.59098 11.2065 7.48918H15.606ZM20.5061 6.83293H16.231L15.427 1.56689H17.8931L20.5061 6.83293ZM3.83341 1.56689H6.29947L5.49548 6.83297H1.22051L3.83341 1.56689ZM1.03458 7.48918H5.43417C5.30751 8.59098 4.36956 9.4496 3.23438 9.4496C2.09919 9.4496 1.16124 8.59102 1.03458 7.48918ZM9.1195 19.1752H5.28245V13.7881H9.1195V19.1752ZM19.5218 19.1752H9.77575V13.46C9.77575 13.2788 9.62883 13.1319 9.44763 13.1319H4.95437C4.77316 13.1319 4.62624 13.2788 4.62624 13.46V19.1752H2.2048V9.91423C2.52464 10.0376 2.87159 10.1059 3.23438 10.1059C4.33753 10.1059 5.29672 9.48016 5.77734 8.56531C6.25797 9.48016 7.21716 10.1059 8.32031 10.1059C9.42347 10.1059 10.3827 9.48016 10.8633 8.56531C11.3439 9.48016 12.3031 10.1059 13.4062 10.1059C14.5094 10.1059 15.4686 9.48016 15.9492 8.56531C16.4298 9.48016 17.389 10.1059 18.4922 10.1059C18.855 10.1059 19.2019 10.0376 19.5218 9.91423V19.1752ZM16.7238 11.2322H13.5738C13.3926 11.2322 13.2456 11.3791 13.2456 11.5604V14.8416C13.2456 15.0228 13.3926 15.1697 13.5738 15.1697H16.7238C16.905 15.1697 17.0519 15.0228 17.0519 14.8416V11.5604C17.0519 11.3791 16.905 11.2322 16.7238 11.2322ZM16.3956 14.5135H13.9019V11.8885H16.3956V14.5135Z"
        fill={color}
      />
    </svg>
  );
};

export const ProgressBar = () => {
  return (
    <svg
      width="109"
      height="11"
      viewBox="0 0 109 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.613281"
        y="0.370605"
        width="107.5"
        height="10"
        rx="5"
        fill="#F0F0F0"
      />
      <svg
        width="75"
        height="11"
        viewBox="0 0 75 11"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="0.613281"
          y="0.370605"
          width="74.1667"
          height="10"
          rx="5"
          fill="url(#paint0_linear_12720_8704)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_12720_8704"
            x1="2.69662"
            y1="5.37061"
            x2="74.7799"
            y2="5.37061"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#6C2AD2" />
            <stop offset="1" stop-color="#2FCDFF" />
          </linearGradient>
        </defs>
      </svg>
    </svg>
  );
};

export const PeopleIcon = () => {
  return (
    <svg
      width="22"
      height="16"
      viewBox="0 0 23 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.3633 15C22.3633 15.2652 22.2579 15.5196 22.0704 15.7071C21.8829 15.8946 21.6285 16 21.3633 16H9.36328C9.09806 16 8.84371 15.8946 8.65617 15.7071C8.46864 15.5196 8.36328 15.2652 8.36328 15C8.36328 13.4087 8.99542 11.8826 10.1206 10.7574C11.2459 9.63214 12.772 9 14.3633 9H16.3633C17.9546 9 19.4807 9.63214 20.6059 10.7574C21.7311 11.8826 22.3633 13.4087 22.3633 15ZM15.3633 0C14.5722 0 13.7988 0.234596 13.141 0.674121C12.4832 1.11365 11.9705 1.73836 11.6678 2.46927C11.365 3.20017 11.2858 4.00444 11.4401 4.78036C11.5945 5.55629 11.9754 6.26902 12.5349 6.82843C13.0943 7.38784 13.807 7.7688 14.5829 7.92314C15.3588 8.07748 16.1631 7.99827 16.894 7.69552C17.6249 7.39277 18.2496 6.88008 18.6892 6.22228C19.1287 5.56448 19.3633 4.79113 19.3633 4C19.3633 2.93913 18.9419 1.92172 18.1917 1.17157C17.4416 0.421427 16.4241 0 15.3633 0ZM6.36328 0C5.57216 0 4.7988 0.234596 4.141 0.674121C3.4832 1.11365 2.97051 1.73836 2.66776 2.46927C2.36501 3.20017 2.2858 4.00444 2.44014 4.78036C2.59448 5.55629 2.97544 6.26902 3.53485 6.82843C4.09426 7.38784 4.807 7.7688 5.58292 7.92314C6.35884 8.07748 7.16311 7.99827 7.89402 7.69552C8.62492 7.39277 9.24963 6.88008 9.68916 6.22228C10.1287 5.56448 10.3633 4.79113 10.3633 4C10.3633 2.93913 9.94185 1.92172 9.19171 1.17157C8.44156 0.421427 7.42415 0 6.36328 0ZM6.36328 15C6.36179 13.9496 6.56874 12.9094 6.97212 11.9395C7.37551 10.9697 7.96732 10.0895 8.71328 9.35C8.10282 9.11952 7.45581 9.00096 6.80328 9H5.92328C4.44949 9.00264 3.03682 9.58928 1.99469 10.6314C0.952558 11.6735 0.365925 13.0862 0.363281 14.56V15C0.363281 15.2652 0.468638 15.5196 0.656174 15.7071C0.843711 15.8946 1.09806 16 1.36328 16H6.54328C6.42686 15.6793 6.36599 15.3411 6.36328 15Z"
        fill="#666666"
      />
    </svg>
  );
};
export const Dollar1Icon = () => {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.33594 0.5C4.6417 0.5 0.835938 4.30576 0.835938 9C0.835938 13.6942 4.6417 17.5 9.33594 17.5C14.0302 17.5 17.8359 13.6942 17.8359 9C17.8359 4.30576 14.0302 0.5 9.33594 0.5ZM11.7775 12.351C11.4067 12.8023 10.924 13.1066 10.3608 13.2605C10.116 13.327 10.004 13.4564 10.018 13.7117C10.0285 13.9636 10.018 14.2119 10.0145 14.4638C10.0145 14.6877 9.89911 14.8066 9.67874 14.8136C9.53532 14.8171 9.3919 14.8206 9.24849 14.8206C9.12256 14.8206 8.99664 14.8206 8.87071 14.8171C8.63285 14.8136 8.52092 14.6772 8.52092 14.4463C8.51742 14.2644 8.51742 14.079 8.51742 13.8971C8.51392 13.4914 8.49993 13.4774 8.11166 13.4144C7.61495 13.334 7.12524 13.222 6.67051 13.0016C6.31372 12.8267 6.27524 12.7393 6.37668 12.3615C6.45363 12.0817 6.53059 11.8019 6.61804 11.5255C6.681 11.3226 6.74046 11.2317 6.8489 11.2317C6.91186 11.2317 6.99232 11.2632 7.10075 11.3191C7.60446 11.5815 8.13964 11.7284 8.70281 11.7984C8.79725 11.8088 8.8917 11.8158 8.98614 11.8158C9.24849 11.8158 9.50384 11.7669 9.75219 11.6584C10.3783 11.3856 10.4763 10.6615 9.94808 10.2278C9.76968 10.0809 9.5633 9.97243 9.34993 9.87798C8.80075 9.63663 8.23059 9.45473 7.71289 9.14342C6.87339 8.63971 6.3417 7.95062 6.40466 6.92922C6.47462 5.7749 7.12874 5.05432 8.18861 4.66955C8.62586 4.51214 8.62935 4.51564 8.62935 4.06091C8.62935 3.907 8.62586 3.75309 8.63285 3.59568C8.64334 3.25288 8.69931 3.19342 9.04211 3.18292C9.08059 3.18292 9.12256 3.18292 9.16104 3.18292C9.2275 3.18292 9.29396 3.18292 9.36042 3.18292C9.38841 3.18292 9.41639 3.18292 9.44088 3.18292C10.0915 3.18292 10.0915 3.21091 10.095 3.91399C10.0985 4.43169 10.0985 4.43169 10.6127 4.51214C11.008 4.5751 11.3822 4.69054 11.746 4.85144C11.9454 4.93889 12.0224 5.07881 11.9594 5.29218C11.8684 5.607 11.781 5.92531 11.6831 6.23663C11.6201 6.42551 11.5606 6.51296 11.4487 6.51296C11.3857 6.51296 11.3088 6.48848 11.2108 6.43951C10.7071 6.19465 10.1789 6.07572 9.62627 6.07572C9.55631 6.07572 9.48285 6.07922 9.41289 6.08272C9.24849 6.09321 9.08758 6.1142 8.93367 6.18066C8.388 6.41852 8.30055 7.02016 8.76577 7.39095C9.00014 7.57984 9.26948 7.71276 9.54581 7.82819C10.0285 8.02757 10.5112 8.21996 10.9695 8.47181C12.4106 9.27634 12.8024 11.1058 11.7775 12.351Z"
        fill="#666666"
      />
    </svg>
  );
};
export const ChatIcon = ({ color = '#666666' }) => {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.6523 0H5.02734C2.44281 0 0.308594 2.13422 0.308594 4.71875C0.308594 7.08219 2.09766 9.04234 4.37413 9.36094C4.51728 9.42822 4.85416 9.40625 5.02734 9.40625V10.8125C5.02734 10.9855 5.12256 11.1444 5.275 11.2259C5.4255 11.3066 5.61094 11.2993 5.75612 11.2025L8.4505 9.40625H10.6523C13.2369 9.40625 15.3711 7.30328 15.3711 4.71875C15.3711 2.13422 13.2369 0 10.6523 0ZM5.02734 5.65625C4.51053 5.65625 4.08984 5.23556 4.08984 4.71875C4.08984 4.20194 4.51053 3.78125 5.02734 3.78125C5.54416 3.78125 5.96484 4.20194 5.96484 4.71875C5.96484 5.23556 5.54416 5.65625 5.02734 5.65625ZM7.83984 5.65625C7.32303 5.65625 6.90234 5.23556 6.90234 4.71875C6.90234 4.20194 7.32303 3.78125 7.83984 3.78125C8.35666 3.78125 8.77734 4.20194 8.77734 4.71875C8.77734 5.23556 8.35666 5.65625 7.83984 5.65625ZM10.6523 5.65625C10.1355 5.65625 9.71484 5.23556 9.71484 4.71875C9.71484 4.20194 10.1355 3.78125 10.6523 3.78125C11.1692 3.78125 11.5898 4.20194 11.5898 4.71875C11.5898 5.23556 11.1692 5.65625 10.6523 5.65625Z"
        fill={color}
      />
      <path
        d="M15.7287 7.19043C14.8115 9.05455 12.8665 10.3436 10.6523 10.3436H8.73431L6.27612 11.9823C5.83594 12.2764 5.27894 12.2916 4.83187 12.0519C4.37456 11.8075 4.08984 11.3323 4.08984 10.8123V10.2653C3.03372 10.0873 2.05878 9.60649 1.29381 8.93105C1.27778 9.08946 1.24609 9.24487 1.24609 9.40605C1.24609 11.9906 3.38031 14.0936 5.96484 14.0936H8.16669L10.8611 15.9211C11.0062 16.0178 11.1917 16.0251 11.3422 15.9444C11.4946 15.8629 11.5898 15.7041 11.5898 15.5311V14.0936C11.7631 14.0936 12.0999 14.1155 12.2431 14.0482C14.5195 13.7296 16.3086 11.769 16.3086 9.40605C16.3086 8.61487 16.094 7.86568 15.7287 7.19043Z"
        fill={color}
      />
    </svg>
  );
};
export const WarningIcon = ({ color = '#666666' }) => {
  return (
    <svg
      width="19"
      height="17"
      viewBox="0 0 19 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.8668 12.2312L12.0936 2.2265C11.5734 1.32562 10.6123 0.770508 9.5718 0.770508C8.53136 0.770508 7.57022 1.32562 7.04999 2.2265L1.17532 12.4025C0.655101 13.3034 0.655101 14.4136 1.17532 15.3145C1.69554 16.2154 2.65669 16.7705 3.69713 16.7705H15.4465C15.4497 16.7705 15.4529 16.7705 15.4529 16.7705C17.0611 16.7705 18.3649 15.4668 18.3649 13.8585C18.3649 13.2558 18.1809 12.6944 17.8668 12.2312ZM10.8185 13.2051C10.8185 13.8934 10.2887 14.42 9.57501 14.42C8.86129 14.42 8.33155 13.8934 8.33155 13.2051V13.1765C8.33155 12.4913 8.86129 11.9616 9.57501 11.9616C10.2887 11.9616 10.8185 12.4882 10.8185 13.1765V13.2051ZM10.847 5.01476L10.2316 10.3883C10.1904 10.7753 9.93345 11.0163 9.57501 11.0163C9.21656 11.0163 8.95962 10.7721 8.91838 10.3883L8.303 5.01159C8.26176 4.59604 8.48701 4.28201 8.87397 4.28201H10.2729C10.6599 4.28518 10.8882 4.59922 10.847 5.01476Z"
        fill={color}
      />
      <path
        d="M17.8668 12.2312L12.0936 2.2265C11.5734 1.32562 10.6123 0.770508 9.5718 0.770508C8.53136 0.770508 7.57022 1.32562 7.04999 2.2265L1.17532 12.4025C0.655101 13.3034 0.655101 14.4136 1.17532 15.3145C1.69554 16.2154 2.65669 16.7705 3.69713 16.7705H15.4465C15.4497 16.7705 15.4529 16.7705 15.4529 16.7705C17.0611 16.7705 18.3649 15.4668 18.3649 13.8585C18.3649 13.2558 18.1809 12.6944 17.8668 12.2312ZM10.8185 13.2051C10.8185 13.8934 10.2887 14.42 9.57501 14.42C8.86129 14.42 8.33155 13.8934 8.33155 13.2051V13.1765C8.33155 12.4913 8.86129 11.9616 9.57501 11.9616C10.2887 11.9616 10.8185 12.4882 10.8185 13.1765V13.2051ZM10.847 5.01476L10.2316 10.3883C10.1904 10.7753 9.93345 11.0163 9.57501 11.0163C9.21656 11.0163 8.95962 10.7721 8.91838 10.3883L8.303 5.01159C8.26176 4.59604 8.48701 4.28201 8.87397 4.28201H10.2729C10.6599 4.28518 10.8882 4.59922 10.847 5.01476Z"
        fill={color}
      />
    </svg>
  );
};
export const Arrow2 = () => {
  return (
    <svg
      width="9"
      height="15"
      viewBox="0 0 9 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.11328 13.9956L7.20606 7.90283L1.11328 1.81006"
        stroke="#6C2AD2"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const Frame = () => {
  return (
    <svg
      width="184"
      height="209"
      viewBox="0 0 184 209"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M55.4647 13L53.4727 9.58H52.1527V13H51.0607V4.636H53.7607C54.3927 4.636 54.9247 4.744 55.3567 4.96C55.7967 5.176 56.1247 5.468 56.3407 5.836C56.5567 6.204 56.6647 6.624 56.6647 7.096C56.6647 7.672 56.4967 8.18 56.1607 8.62C55.8327 9.06 55.3367 9.352 54.6727 9.496L56.7727 13H55.4647ZM52.1527 8.704H53.7607C54.3527 8.704 54.7967 8.56 55.0927 8.272C55.3887 7.976 55.5367 7.584 55.5367 7.096C55.5367 6.6 55.3887 6.216 55.0927 5.944C54.8047 5.672 54.3607 5.536 53.7607 5.536H52.1527V8.704ZM64.3615 9.46C64.3615 9.668 64.3495 9.888 64.3255 10.12H59.0695C59.1095 10.768 59.3295 11.276 59.7295 11.644C60.1375 12.004 60.6295 12.184 61.2055 12.184C61.6775 12.184 62.0695 12.076 62.3815 11.86C62.7015 11.636 62.9255 11.34 63.0535 10.972H64.2295C64.0535 11.604 63.7015 12.12 63.1735 12.52C62.6455 12.912 61.9895 13.108 61.2055 13.108C60.5815 13.108 60.0215 12.968 59.5255 12.688C59.0375 12.408 58.6535 12.012 58.3735 11.5C58.0935 10.98 57.9535 10.38 57.9535 9.7C57.9535 9.02 58.0895 8.424 58.3615 7.912C58.6335 7.4 59.0135 7.008 59.5015 6.736C59.9975 6.456 60.5655 6.316 61.2055 6.316C61.8295 6.316 62.3815 6.452 62.8615 6.724C63.3415 6.996 63.7095 7.372 63.9655 7.852C64.2295 8.324 64.3615 8.86 64.3615 9.46ZM63.2335 9.232C63.2335 8.816 63.1415 8.46 62.9575 8.164C62.7735 7.86 62.5215 7.632 62.2015 7.48C61.8895 7.32 61.5415 7.24 61.1575 7.24C60.6055 7.24 60.1335 7.416 59.7415 7.768C59.3575 8.12 59.1375 8.608 59.0815 9.232H63.2335ZM65.3949 9.688C65.3949 9.016 65.5309 8.428 65.8029 7.924C66.0749 7.412 66.4469 7.016 66.9189 6.736C67.3989 6.456 67.9309 6.316 68.5149 6.316C69.0909 6.316 69.5909 6.44 70.0149 6.688C70.4389 6.936 70.7549 7.248 70.9629 7.624V6.424H72.0669V13H70.9629V11.776C70.7469 12.16 70.4229 12.48 69.9909 12.736C69.5669 12.984 69.0709 13.108 68.5029 13.108C67.9189 13.108 67.3909 12.964 66.9189 12.676C66.4469 12.388 66.0749 11.984 65.8029 11.464C65.5309 10.944 65.3949 10.352 65.3949 9.688ZM70.9629 9.7C70.9629 9.204 70.8629 8.772 70.6629 8.404C70.4629 8.036 70.1909 7.756 69.8469 7.564C69.5109 7.364 69.1389 7.264 68.7309 7.264C68.3229 7.264 67.9509 7.36 67.6149 7.552C67.2789 7.744 67.0109 8.024 66.8109 8.392C66.6109 8.76 66.5109 9.192 66.5109 9.688C66.5109 10.192 66.6109 10.632 66.8109 11.008C67.0109 11.376 67.2789 11.66 67.6149 11.86C67.9509 12.052 68.3229 12.148 68.7309 12.148C69.1389 12.148 69.5109 12.052 69.8469 11.86C70.1909 11.66 70.4629 11.376 70.6629 11.008C70.8629 10.632 70.9629 10.196 70.9629 9.7ZM73.5043 9.688C73.5043 9.016 73.6403 8.428 73.9123 7.924C74.1843 7.412 74.5563 7.016 75.0283 6.736C75.5083 6.456 76.0443 6.316 76.6363 6.316C77.1483 6.316 77.6243 6.436 78.0643 6.676C78.5043 6.908 78.8403 7.216 79.0723 7.6V4.12H80.1763V13H79.0723V11.764C78.8563 12.156 78.5363 12.48 78.1123 12.736C77.6883 12.984 77.1923 13.108 76.6243 13.108C76.0403 13.108 75.5083 12.964 75.0283 12.676C74.5563 12.388 74.1843 11.984 73.9123 11.464C73.6403 10.944 73.5043 10.352 73.5043 9.688ZM79.0723 9.7C79.0723 9.204 78.9723 8.772 78.7723 8.404C78.5723 8.036 78.3003 7.756 77.9563 7.564C77.6203 7.364 77.2483 7.264 76.8403 7.264C76.4323 7.264 76.0603 7.36 75.7243 7.552C75.3883 7.744 75.1203 8.024 74.9203 8.392C74.7203 8.76 74.6203 9.192 74.6203 9.688C74.6203 10.192 74.7203 10.632 74.9203 11.008C75.1203 11.376 75.3883 11.66 75.7243 11.86C76.0603 12.052 76.4323 12.148 76.8403 12.148C77.2483 12.148 77.6203 12.052 77.9563 11.86C78.3003 11.66 78.5723 11.376 78.7723 11.008C78.9723 10.632 79.0723 10.196 79.0723 9.7ZM87.6857 6.424L83.7257 16.096H82.5977L83.8937 12.928L81.2417 6.424H82.4537L84.5177 11.752L86.5577 6.424H87.6857ZM93.3146 7.324V11.2C93.3146 11.52 93.3826 11.748 93.5186 11.884C93.6546 12.012 93.8906 12.076 94.2266 12.076H95.0306V13H94.0466C93.4386 13 92.9826 12.86 92.6786 12.58C92.3746 12.3 92.2226 11.84 92.2226 11.2V7.324H91.3706V6.424H92.2226V4.768H93.3146V6.424H95.0306V7.324H93.3146ZM99.2217 13.108C98.6057 13.108 98.0457 12.968 97.5417 12.688C97.0457 12.408 96.6537 12.012 96.3657 11.5C96.0857 10.98 95.9457 10.38 95.9457 9.7C95.9457 9.028 96.0897 8.436 96.3777 7.924C96.6737 7.404 97.0737 7.008 97.5777 6.736C98.0817 6.456 98.6457 6.316 99.2697 6.316C99.8937 6.316 100.458 6.456 100.962 6.736C101.466 7.008 101.862 7.4 102.15 7.912C102.446 8.424 102.594 9.02 102.594 9.7C102.594 10.38 102.442 10.98 102.138 11.5C101.842 12.012 101.438 12.408 100.926 12.688C100.414 12.968 99.8457 13.108 99.2217 13.108ZM99.2217 12.148C99.6137 12.148 99.9817 12.056 100.326 11.872C100.67 11.688 100.946 11.412 101.154 11.044C101.37 10.676 101.478 10.228 101.478 9.7C101.478 9.172 101.374 8.724 101.166 8.356C100.958 7.988 100.686 7.716 100.35 7.54C100.014 7.356 99.6497 7.264 99.2577 7.264C98.8577 7.264 98.4897 7.356 98.1537 7.54C97.8257 7.716 97.5617 7.988 97.3617 8.356C97.1617 8.724 97.0617 9.172 97.0617 9.7C97.0617 10.236 97.1577 10.688 97.3497 11.056C97.5497 11.424 97.8137 11.7 98.1417 11.884C98.4697 12.06 98.8297 12.148 99.2217 12.148ZM109.881 13.084C109.329 13.084 108.833 12.988 108.393 12.796C107.961 12.596 107.621 12.324 107.373 11.98C107.125 11.628 106.997 11.224 106.989 10.768H108.153C108.193 11.16 108.353 11.492 108.633 11.764C108.921 12.028 109.337 12.16 109.881 12.16C110.401 12.16 110.809 12.032 111.105 11.776C111.409 11.512 111.561 11.176 111.561 10.768C111.561 10.448 111.473 10.188 111.297 9.988C111.121 9.788 110.901 9.636 110.637 9.532C110.373 9.428 110.017 9.316 109.569 9.196C109.017 9.052 108.573 8.908 108.237 8.764C107.909 8.62 107.625 8.396 107.385 8.092C107.153 7.78 107.037 7.364 107.037 6.844C107.037 6.388 107.153 5.984 107.385 5.632C107.617 5.28 107.941 5.008 108.357 4.816C108.781 4.624 109.265 4.528 109.809 4.528C110.593 4.528 111.233 4.724 111.729 5.116C112.233 5.508 112.517 6.028 112.581 6.676H111.381C111.341 6.356 111.173 6.076 110.877 5.836C110.581 5.588 110.189 5.464 109.701 5.464C109.245 5.464 108.873 5.584 108.585 5.824C108.297 6.056 108.153 6.384 108.153 6.808C108.153 7.112 108.237 7.36 108.405 7.552C108.581 7.744 108.793 7.892 109.041 7.996C109.297 8.092 109.653 8.204 110.109 8.332C110.661 8.484 111.105 8.636 111.441 8.788C111.777 8.932 112.065 9.16 112.305 9.472C112.545 9.776 112.665 10.192 112.665 10.72C112.665 11.128 112.557 11.512 112.341 11.872C112.125 12.232 111.805 12.524 111.381 12.748C110.957 12.972 110.457 13.084 109.881 13.084ZM120.272 9.46C120.272 9.668 120.26 9.888 120.236 10.12H114.98C115.02 10.768 115.24 11.276 115.64 11.644C116.048 12.004 116.54 12.184 117.116 12.184C117.588 12.184 117.98 12.076 118.292 11.86C118.612 11.636 118.836 11.34 118.964 10.972H120.14C119.964 11.604 119.612 12.12 119.084 12.52C118.556 12.912 117.9 13.108 117.116 13.108C116.492 13.108 115.932 12.968 115.436 12.688C114.948 12.408 114.564 12.012 114.284 11.5C114.004 10.98 113.864 10.38 113.864 9.7C113.864 9.02 114 8.424 114.272 7.912C114.544 7.4 114.924 7.008 115.412 6.736C115.908 6.456 116.476 6.316 117.116 6.316C117.74 6.316 118.292 6.452 118.772 6.724C119.252 6.996 119.62 7.372 119.876 7.852C120.14 8.324 120.272 8.86 120.272 9.46ZM119.144 9.232C119.144 8.816 119.052 8.46 118.868 8.164C118.684 7.86 118.432 7.632 118.112 7.48C117.8 7.32 117.452 7.24 117.068 7.24C116.516 7.24 116.044 7.416 115.652 7.768C115.268 8.12 115.048 8.608 114.992 9.232H119.144ZM122.805 4.12V13H121.713V4.12H122.805ZM125.758 4.12V13H124.666V4.12H125.758Z"
        fill="#585858"
      />
      <ellipse
        opacity="0.3"
        cx="36.1922"
        cy="37"
        rx="36.1922"
        ry="37"
        transform="matrix(4.4687e-08 -1 -1 -4.27571e-08 125.637 103)"
        stroke="#C4C4C4"
        stroke-width="5"
        stroke-linecap="round"
      />
      <g filter="url(#filter0_d_15964_153315)">
        <path
          d="M88.6156 30.6155C94.9424 30.6155 101.164 32.2007 106.686 35.2196C112.208 38.2386 116.846 42.5907 120.158 47.8605C123.47 53.1304 125.346 59.1421 125.606 65.322C125.865 71.502 124.501 77.6439 121.642 83.1616C118.783 88.6793 114.525 93.3887 109.275 96.8403C104.025 100.292 97.958 102.371 91.6525 102.878C85.3471 103.385 79.0138 102.305 73.2571 99.7386C67.5004 97.1726 62.5125 93.2072 58.7693 88.2207"
          stroke="url(#paint0_linear_15964_153315)"
          stroke-width="5"
          stroke-linecap="round"
        />
      </g>
      <path
        d="M77.9156 66.9627C77.5423 66.816 77.2556 66.6027 77.0556 66.3227C76.8556 66.0427 76.7556 65.7027 76.7556 65.3027C76.7556 64.9427 76.8456 64.6193 77.0256 64.3327C77.2056 64.0393 77.4723 63.8093 77.8256 63.6427C78.1856 63.4693 78.6189 63.3827 79.1256 63.3827C79.6323 63.3827 80.0623 63.4693 80.4156 63.6427C80.7756 63.8093 81.0456 64.0393 81.2256 64.3327C81.4123 64.6193 81.5056 64.9427 81.5056 65.3027C81.5056 65.6893 81.4023 66.0293 81.1956 66.3227C80.9889 66.6093 80.7056 66.8227 80.3456 66.9627C80.7589 67.0893 81.0856 67.3127 81.3256 67.6327C81.5723 67.946 81.6956 68.326 81.6956 68.7727C81.6956 69.206 81.5889 69.586 81.3756 69.9127C81.1623 70.2327 80.8589 70.4827 80.4656 70.6627C80.0789 70.836 79.6323 70.9227 79.1256 70.9227C78.6189 70.9227 78.1723 70.836 77.7856 70.6627C77.4056 70.4827 77.1089 70.2327 76.8956 69.9127C76.6823 69.586 76.5756 69.206 76.5756 68.7727C76.5756 68.326 76.6956 67.9427 76.9356 67.6227C77.1756 67.3027 77.5023 67.0827 77.9156 66.9627ZM80.6256 65.4127C80.6256 65.006 80.4923 64.6927 80.2256 64.4727C79.9589 64.2527 79.5923 64.1427 79.1256 64.1427C78.6656 64.1427 78.3023 64.2527 78.0356 64.4727C77.7689 64.6927 77.6356 65.0093 77.6356 65.4227C77.6356 65.796 77.7723 66.096 78.0456 66.3227C78.3256 66.5493 78.6856 66.6627 79.1256 66.6627C79.5723 66.6627 79.9323 66.5493 80.2056 66.3227C80.4856 66.0893 80.6256 65.786 80.6256 65.4127ZM79.1256 67.3627C78.6323 67.3627 78.2289 67.4793 77.9156 67.7127C77.6023 67.9393 77.4456 68.2827 77.4456 68.7427C77.4456 69.1693 77.5956 69.5127 77.8956 69.7727C78.2023 70.0327 78.6123 70.1627 79.1256 70.1627C79.6389 70.1627 80.0456 70.0327 80.3456 69.7727C80.6456 69.5127 80.7956 69.1693 80.7956 68.7427C80.7956 68.296 80.6423 67.956 80.3356 67.7227C80.0289 67.4827 79.6256 67.3627 79.1256 67.3627ZM82.7942 69.9927C83.6408 69.3127 84.3042 68.756 84.7842 68.3227C85.2642 67.8827 85.6675 67.426 85.9942 66.9527C86.3275 66.4727 86.4942 66.0027 86.4942 65.5427C86.4942 65.1093 86.3875 64.7693 86.1742 64.5227C85.9675 64.2693 85.6308 64.1427 85.1642 64.1427C84.7108 64.1427 84.3575 64.286 84.1042 64.5727C83.8575 64.8527 83.7242 65.2293 83.7042 65.7027H82.8242C82.8508 64.956 83.0775 64.3793 83.5042 63.9727C83.9308 63.566 84.4808 63.3627 85.1542 63.3627C85.8408 63.3627 86.3842 63.5527 86.7842 63.9327C87.1908 64.3127 87.3942 64.836 87.3942 65.5027C87.3942 66.056 87.2275 66.596 86.8942 67.1227C86.5675 67.6427 86.1942 68.1027 85.7742 68.5027C85.3542 68.896 84.8175 69.356 84.1642 69.8827H87.6042V70.6427H82.7942V69.9927ZM89.0961 70.7827C88.9228 70.7827 88.7761 70.7227 88.6561 70.6027C88.5361 70.4827 88.4761 70.336 88.4761 70.1627C88.4761 69.9893 88.5361 69.8427 88.6561 69.7227C88.7761 69.6027 88.9228 69.5427 89.0961 69.5427C89.2628 69.5427 89.4028 69.6027 89.5161 69.7227C89.6361 69.8427 89.6961 69.9893 89.6961 70.1627C89.6961 70.336 89.6361 70.4827 89.5161 70.6027C89.4028 70.7227 89.2628 70.7827 89.0961 70.7827ZM90.7357 65.3127C90.7824 64.6993 91.0191 64.2193 91.4457 63.8727C91.8724 63.526 92.4257 63.3527 93.1057 63.3527C93.5591 63.3527 93.9491 63.436 94.2757 63.6027C94.6091 63.7627 94.8591 63.9827 95.0257 64.2627C95.1991 64.5427 95.2857 64.8593 95.2857 65.2127C95.2857 65.626 95.1657 65.9827 94.9257 66.2827C94.6924 66.5827 94.3857 66.776 94.0057 66.8627V66.9127C94.4391 67.0193 94.7824 67.2293 95.0357 67.5427C95.2891 67.856 95.4157 68.266 95.4157 68.7727C95.4157 69.1527 95.3291 69.496 95.1557 69.8027C94.9824 70.1027 94.7224 70.3393 94.3757 70.5127C94.0291 70.686 93.6124 70.7727 93.1257 70.7727C92.4191 70.7727 91.8391 70.5893 91.3857 70.2227C90.9324 69.8493 90.6791 69.3227 90.6257 68.6427H91.5057C91.5524 69.0427 91.7157 69.3693 91.9957 69.6227C92.2757 69.876 92.6491 70.0027 93.1157 70.0027C93.5824 70.0027 93.9357 69.8827 94.1757 69.6427C94.4224 69.396 94.5457 69.0793 94.5457 68.6927C94.5457 68.1927 94.3791 67.8327 94.0457 67.6127C93.7124 67.3927 93.2091 67.2827 92.5357 67.2827H92.3057V66.5227H92.5457C93.1591 66.516 93.6224 66.416 93.9357 66.2227C94.2491 66.0227 94.4057 65.716 94.4057 65.3027C94.4057 64.9493 94.2891 64.666 94.0557 64.4527C93.8291 64.2393 93.5024 64.1327 93.0757 64.1327C92.6624 64.1327 92.3291 64.2393 92.0757 64.4527C91.8224 64.666 91.6724 64.9527 91.6257 65.3127H90.7357Z"
        fill="black"
      />
      <path
        opacity="0.2"
        d="M99.8187 66.0865C99.8187 65.6332 99.9554 65.2732 100.229 65.0065C100.502 64.7332 100.852 64.5965 101.279 64.5965C101.705 64.5965 102.055 64.7332 102.329 65.0065C102.602 65.2732 102.739 65.6332 102.739 66.0865C102.739 66.5465 102.602 66.9132 102.329 67.1865C102.055 67.4532 101.705 67.5865 101.279 67.5865C100.852 67.5865 100.502 67.4532 100.229 67.1865C99.9554 66.9132 99.8187 66.5465 99.8187 66.0865ZM105.659 64.7065L101.609 71.6865H100.709L104.759 64.7065H105.659ZM101.279 65.1565C101.052 65.1565 100.872 65.2365 100.739 65.3965C100.612 65.5499 100.549 65.7799 100.549 66.0865C100.549 66.3932 100.612 66.6265 100.739 66.7865C100.872 66.9465 101.052 67.0265 101.279 67.0265C101.505 67.0265 101.685 66.9465 101.819 66.7865C101.952 66.6199 102.019 66.3865 102.019 66.0865C102.019 65.7799 101.952 65.5499 101.819 65.3965C101.685 65.2365 101.505 65.1565 101.279 65.1565ZM103.649 70.3065C103.649 69.8465 103.785 69.4832 104.059 69.2165C104.332 68.9432 104.682 68.8065 105.109 68.8065C105.535 68.8065 105.882 68.9432 106.149 69.2165C106.422 69.4832 106.559 69.8465 106.559 70.3065C106.559 70.7599 106.422 71.1232 106.149 71.3965C105.882 71.6699 105.535 71.8065 105.109 71.8065C104.682 71.8065 104.332 71.6732 104.059 71.4065C103.785 71.1332 103.649 70.7665 103.649 70.3065ZM105.099 69.3765C104.872 69.3765 104.692 69.4565 104.559 69.6165C104.425 69.7699 104.359 69.9999 104.359 70.3065C104.359 70.6065 104.425 70.8365 104.559 70.9965C104.692 71.1499 104.872 71.2265 105.099 71.2265C105.325 71.2265 105.505 71.1499 105.639 70.9965C105.772 70.8365 105.839 70.6065 105.839 70.3065C105.839 69.9999 105.772 69.7699 105.639 69.6165C105.505 69.4565 105.325 69.3765 105.099 69.3765Z"
        fill="black"
      />
      <rect
        x="86.4062"
        y="28"
        width="5.3494"
        height="4.36051"
        rx="2.18026"
        fill="white"
      />
      <defs>
        <filter
          id="filter0_d_15964_153315"
          x="0.549561"
          y="20.1552"
          width="183.307"
          height="188.825"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="47.76" />
          <feGaussianBlur stdDeviation="27.86" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.203125 0 0 0 0 0.585 0 0 0 0 0.9375 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_15964_153315"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_15964_153315"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_15964_153315"
          x1="67.637"
          y1="107.826"
          x2="65.0423"
          y2="-26.088"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#6C2AD2" />
          <stop offset="1" stop-color="#5FB1DF" stop-opacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};
export const Frame3 = () => {
  return (
    <svg
      width="99"
      height="93"
      viewBox="0 0 99 93"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_10008_126110)">
        <rect
          x="4.36328"
          y="3"
          width="90"
          height="30"
          rx="5"
          fill="white"
          shape-rendering="crispEdges"
        />
        <path
          d="M20.2913 20.296H16.7993L16.1993 22H14.7713L17.7593 13.648H19.3433L22.3313 22H20.8913L20.2913 20.296ZM19.9073 19.18L18.5513 15.304L17.1833 19.18H19.9073ZM23.1745 18.688C23.1745 18.008 23.3105 17.412 23.5825 16.9C23.8625 16.38 24.2465 15.98 24.7345 15.7C25.2225 15.42 25.7825 15.28 26.4145 15.28C27.2145 15.28 27.8745 15.472 28.3945 15.856C28.9225 16.232 29.2785 16.772 29.4625 17.476H27.9865C27.8665 17.148 27.6745 16.892 27.4105 16.708C27.1465 16.524 26.8145 16.432 26.4145 16.432C25.8545 16.432 25.4065 16.632 25.0705 17.032C24.7425 17.424 24.5785 17.976 24.5785 18.688C24.5785 19.4 24.7425 19.956 25.0705 20.356C25.4065 20.756 25.8545 20.956 26.4145 20.956C27.2065 20.956 27.7305 20.608 27.9865 19.912H29.4625C29.2705 20.584 28.9105 21.12 28.3825 21.52C27.8545 21.912 27.1985 22.108 26.4145 22.108C25.7825 22.108 25.2225 21.968 24.7345 21.688C24.2465 21.4 23.8625 21 23.5825 20.488C23.3105 19.968 23.1745 19.368 23.1745 18.688ZM32.4218 16.504V20.164C32.4218 20.412 32.4778 20.592 32.5898 20.704C32.7098 20.808 32.9098 20.86 33.1898 20.86H34.0298V22H32.9498C32.3338 22 31.8618 21.856 31.5338 21.568C31.2058 21.28 31.0418 20.812 31.0418 20.164V16.504H30.2618V15.388H31.0418V13.744H32.4218V15.388H34.0298V16.504H32.4218ZM35.9866 14.512C35.7386 14.512 35.5306 14.428 35.3626 14.26C35.1946 14.092 35.1106 13.884 35.1106 13.636C35.1106 13.388 35.1946 13.18 35.3626 13.012C35.5306 12.844 35.7386 12.76 35.9866 12.76C36.2266 12.76 36.4306 12.844 36.5986 13.012C36.7666 13.18 36.8506 13.388 36.8506 13.636C36.8506 13.884 36.7666 14.092 36.5986 14.26C36.4306 14.428 36.2266 14.512 35.9866 14.512ZM36.6586 15.388V22H35.2906V15.388H36.6586ZM41.3227 22.108C40.6987 22.108 40.1347 21.968 39.6307 21.688C39.1267 21.4 38.7307 21 38.4427 20.488C38.1547 19.968 38.0107 19.368 38.0107 18.688C38.0107 18.016 38.1587 17.42 38.4547 16.9C38.7507 16.38 39.1547 15.98 39.6667 15.7C40.1787 15.42 40.7507 15.28 41.3827 15.28C42.0147 15.28 42.5867 15.42 43.0987 15.7C43.6107 15.98 44.0147 16.38 44.3107 16.9C44.6067 17.42 44.7547 18.016 44.7547 18.688C44.7547 19.36 44.6027 19.956 44.2987 20.476C43.9947 20.996 43.5787 21.4 43.0507 21.688C42.5307 21.968 41.9547 22.108 41.3227 22.108ZM41.3227 20.92C41.6747 20.92 42.0027 20.836 42.3067 20.668C42.6187 20.5 42.8707 20.248 43.0627 19.912C43.2547 19.576 43.3507 19.168 43.3507 18.688C43.3507 18.208 43.2587 17.804 43.0747 17.476C42.8907 17.14 42.6467 16.888 42.3427 16.72C42.0387 16.552 41.7107 16.468 41.3587 16.468C41.0067 16.468 40.6787 16.552 40.3747 16.72C40.0787 16.888 39.8427 17.14 39.6667 17.476C39.4907 17.804 39.4027 18.208 39.4027 18.688C39.4027 19.4 39.5827 19.952 39.9427 20.344C40.3107 20.728 40.7707 20.92 41.3227 20.92ZM49.443 15.28C49.963 15.28 50.427 15.388 50.835 15.604C51.251 15.82 51.575 16.14 51.807 16.564C52.039 16.988 52.155 17.5 52.155 18.1V22H50.799V18.304C50.799 17.712 50.651 17.26 50.355 16.948C50.059 16.628 49.655 16.468 49.143 16.468C48.631 16.468 48.223 16.628 47.919 16.948C47.623 17.26 47.475 17.712 47.475 18.304V22H46.107V15.388H47.475V16.144C47.699 15.872 47.983 15.66 48.327 15.508C48.679 15.356 49.051 15.28 49.443 15.28Z"
          fill="#112347"
        />
        <path
          d="M75.8259 15.6957C75.9842 15.5342 76.2318 15.5196 76.4064 15.6517L76.4564 15.6957L80.0286 19.3398L83.6009 15.6957C83.7592 15.5342 84.0069 15.5196 84.1814 15.6517L84.2314 15.6957C84.3897 15.8571 84.4041 16.1098 84.2746 16.2878L84.2314 16.3388L80.3439 20.3043C80.1856 20.4658 79.9379 20.4804 79.7634 20.3483L79.7134 20.3043L75.8259 16.3388C75.6518 16.1612 75.6518 15.8733 75.8259 15.6957Z"
          fill="#112347"
        />
        <rect
          x="4.86328"
          y="3.5"
          width="89"
          height="29"
          rx="4.5"
          stroke="#6C2AD2"
          shape-rendering="crispEdges"
        />
      </g>
      <rect
        x="4.36328"
        y="63"
        width="89"
        height="30"
        rx="4.05125"
        fill="#6C2AD2"
        fill-opacity="0.1"
      />
      <path
        d="M25.0153 73.636V74.524H21.3793V77.344H24.3313V78.232H21.3793V82H20.2873V73.636H25.0153ZM32.3342 78.46C32.3342 78.668 32.3222 78.888 32.2982 79.12H27.0422C27.0822 79.768 27.3022 80.276 27.7022 80.644C28.1102 81.004 28.6022 81.184 29.1782 81.184C29.6502 81.184 30.0422 81.076 30.3542 80.86C30.6742 80.636 30.8982 80.34 31.0262 79.972H32.2022C32.0262 80.604 31.6742 81.12 31.1462 81.52C30.6182 81.912 29.9622 82.108 29.1782 82.108C28.5542 82.108 27.9942 81.968 27.4982 81.688C27.0102 81.408 26.6262 81.012 26.3462 80.5C26.0662 79.98 25.9262 79.38 25.9262 78.7C25.9262 78.02 26.0622 77.424 26.3342 76.912C26.6062 76.4 26.9862 76.008 27.4742 75.736C27.9702 75.456 28.5382 75.316 29.1782 75.316C29.8022 75.316 30.3542 75.452 30.8342 75.724C31.3142 75.996 31.6822 76.372 31.9382 76.852C32.2022 77.324 32.3342 77.86 32.3342 78.46ZM31.2062 78.232C31.2062 77.816 31.1142 77.46 30.9302 77.164C30.7462 76.86 30.4942 76.632 30.1742 76.48C29.8622 76.32 29.5142 76.24 29.1302 76.24C28.5782 76.24 28.1062 76.416 27.7142 76.768C27.3302 77.12 27.1102 77.608 27.0542 78.232H31.2062ZM39.7756 78.46C39.7756 78.668 39.7636 78.888 39.7396 79.12H34.4836C34.5236 79.768 34.7436 80.276 35.1436 80.644C35.5516 81.004 36.0436 81.184 36.6196 81.184C37.0916 81.184 37.4836 81.076 37.7956 80.86C38.1156 80.636 38.3396 80.34 38.4676 79.972H39.6436C39.4676 80.604 39.1156 81.12 38.5876 81.52C38.0596 81.912 37.4036 82.108 36.6196 82.108C35.9956 82.108 35.4356 81.968 34.9396 81.688C34.4516 81.408 34.0676 81.012 33.7876 80.5C33.5076 79.98 33.3676 79.38 33.3676 78.7C33.3676 78.02 33.5036 77.424 33.7756 76.912C34.0476 76.4 34.4276 76.008 34.9156 75.736C35.4116 75.456 35.9796 75.316 36.6196 75.316C37.2436 75.316 37.7956 75.452 38.2756 75.724C38.7556 75.996 39.1236 76.372 39.3796 76.852C39.6436 77.324 39.7756 77.86 39.7756 78.46ZM38.6476 78.232C38.6476 77.816 38.5556 77.46 38.3716 77.164C38.1876 76.86 37.9356 76.632 37.6156 76.48C37.3036 76.32 36.9556 76.24 36.5716 76.24C36.0196 76.24 35.5476 76.416 35.1556 76.768C34.7716 77.12 34.5516 77.608 34.4956 78.232H38.6476ZM40.809 78.688C40.809 78.016 40.945 77.428 41.217 76.924C41.489 76.412 41.861 76.016 42.333 75.736C42.813 75.456 43.349 75.316 43.941 75.316C44.453 75.316 44.929 75.436 45.369 75.676C45.809 75.908 46.145 76.216 46.377 76.6V73.12H47.481V82H46.377V80.764C46.161 81.156 45.841 81.48 45.417 81.736C44.993 81.984 44.497 82.108 43.929 82.108C43.345 82.108 42.813 81.964 42.333 81.676C41.861 81.388 41.489 80.984 41.217 80.464C40.945 79.944 40.809 79.352 40.809 78.688ZM46.377 78.7C46.377 78.204 46.277 77.772 46.077 77.404C45.877 77.036 45.605 76.756 45.261 76.564C44.925 76.364 44.553 76.264 44.145 76.264C43.737 76.264 43.365 76.36 43.029 76.552C42.693 76.744 42.425 77.024 42.225 77.392C42.025 77.76 41.925 78.192 41.925 78.688C41.925 79.192 42.025 79.632 42.225 80.008C42.425 80.376 42.693 80.66 43.029 80.86C43.365 81.052 43.737 81.148 44.145 81.148C44.553 81.148 44.925 81.052 45.261 80.86C45.605 80.66 45.877 80.376 46.077 80.008C46.277 79.632 46.377 79.196 46.377 78.7ZM50.4183 76.648C50.6423 76.256 50.9703 75.936 51.4023 75.688C51.8343 75.44 52.3263 75.316 52.8783 75.316C53.4703 75.316 54.0023 75.456 54.4743 75.736C54.9463 76.016 55.3183 76.412 55.5903 76.924C55.8623 77.428 55.9983 78.016 55.9983 78.688C55.9983 79.352 55.8623 79.944 55.5903 80.464C55.3183 80.984 54.9423 81.388 54.4623 81.676C53.9903 81.964 53.4623 82.108 52.8783 82.108C52.3103 82.108 51.8103 81.984 51.3783 81.736C50.9543 81.488 50.6343 81.172 50.4183 80.788V82H49.3263V73.12H50.4183V76.648ZM54.8823 78.688C54.8823 78.192 54.7823 77.76 54.5823 77.392C54.3823 77.024 54.1103 76.744 53.7663 76.552C53.4303 76.36 53.0583 76.264 52.6503 76.264C52.2503 76.264 51.8783 76.364 51.5343 76.564C51.1983 76.756 50.9263 77.04 50.7183 77.416C50.5183 77.784 50.4183 78.212 50.4183 78.7C50.4183 79.196 50.5183 79.632 50.7183 80.008C50.9263 80.376 51.1983 80.66 51.5343 80.86C51.8783 81.052 52.2503 81.148 52.6503 81.148C53.0583 81.148 53.4303 81.052 53.7663 80.86C54.1103 80.66 54.3823 80.376 54.5823 80.008C54.7823 79.632 54.8823 79.192 54.8823 78.688ZM57.0277 78.688C57.0277 78.016 57.1637 77.428 57.4357 76.924C57.7077 76.412 58.0797 76.016 58.5517 75.736C59.0317 75.456 59.5637 75.316 60.1477 75.316C60.7237 75.316 61.2237 75.44 61.6477 75.688C62.0717 75.936 62.3877 76.248 62.5957 76.624V75.424H63.6997V82H62.5957V80.776C62.3797 81.16 62.0557 81.48 61.6237 81.736C61.1997 81.984 60.7037 82.108 60.1357 82.108C59.5517 82.108 59.0237 81.964 58.5517 81.676C58.0797 81.388 57.7077 80.984 57.4357 80.464C57.1637 79.944 57.0277 79.352 57.0277 78.688ZM62.5957 78.7C62.5957 78.204 62.4957 77.772 62.2957 77.404C62.0957 77.036 61.8237 76.756 61.4797 76.564C61.1437 76.364 60.7717 76.264 60.3637 76.264C59.9557 76.264 59.5837 76.36 59.2477 76.552C58.9117 76.744 58.6437 77.024 58.4437 77.392C58.2437 77.76 58.1437 78.192 58.1437 78.688C58.1437 79.192 58.2437 79.632 58.4437 80.008C58.6437 80.376 58.9117 80.66 59.2477 80.86C59.5837 81.052 59.9557 81.148 60.3637 81.148C60.7717 81.148 61.1437 81.052 61.4797 80.86C61.8237 80.66 62.0957 80.376 62.2957 80.008C62.4957 79.632 62.5957 79.196 62.5957 78.7ZM65.1371 78.7C65.1371 78.02 65.2731 77.428 65.5451 76.924C65.8171 76.412 66.1931 76.016 66.6731 75.736C67.1611 75.456 67.7171 75.316 68.3411 75.316C69.1491 75.316 69.8131 75.512 70.3331 75.904C70.8611 76.296 71.2091 76.84 71.3771 77.536H70.2011C70.0891 77.136 69.8691 76.82 69.5411 76.588C69.2211 76.356 68.8211 76.24 68.3411 76.24C67.7171 76.24 67.2131 76.456 66.8291 76.888C66.4451 77.312 66.2531 77.916 66.2531 78.7C66.2531 79.492 66.4451 80.104 66.8291 80.536C67.2131 80.968 67.7171 81.184 68.3411 81.184C68.8211 81.184 69.2211 81.072 69.5411 80.848C69.8611 80.624 70.0811 80.304 70.2011 79.888H71.3771C71.2011 80.56 70.8491 81.1 70.3211 81.508C69.7931 81.908 69.1331 82.108 68.3411 82.108C67.7171 82.108 67.1611 81.968 66.6731 81.688C66.1931 81.408 65.8171 81.012 65.5451 80.5C65.2731 79.988 65.1371 79.388 65.1371 78.7ZM76.5062 82L73.9262 79.096V82H72.8342V73.12H73.9262V78.34L76.4582 75.424H77.9822L74.8862 78.7L77.9942 82H76.5062Z"
        fill="#6C2AD2"
      />
      <defs>
        <filter
          id="filter0_d_10008_126110"
          x="0.363281"
          y="0"
          width="98"
          height="38"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_10008_126110"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_10008_126110"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};
export const Five = () => {
  return (
    <svg
      width="12"
      height="8"
      viewBox="0 0 12 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.33328 4.10061H3.20328V6.26061H2.35328V4.10061H0.233281V3.33061H2.35328V1.1606H3.20328V3.33061H5.33328V4.10061ZM11.4195 0.930605H7.90945V3.21061C8.06279 2.99727 8.28945 2.82394 8.58945 2.69061C8.88945 2.55061 9.21279 2.48061 9.55945 2.48061C10.1128 2.48061 10.5628 2.59727 10.9095 2.83061C11.2561 3.05727 11.5028 3.35394 11.6495 3.72061C11.8028 4.08061 11.8795 4.46394 11.8795 4.87061C11.8795 5.35061 11.7895 5.78061 11.6095 6.16061C11.4295 6.54061 11.1528 6.84061 10.7795 7.06061C10.4128 7.28061 9.95612 7.39061 9.40945 7.39061C8.70945 7.39061 8.14279 7.21061 7.70945 6.85061C7.27612 6.49061 7.01279 6.01061 6.91945 5.41061H7.80945C7.89612 5.79061 8.07945 6.08727 8.35945 6.30061C8.63945 6.51394 8.99279 6.62061 9.41945 6.62061C9.94612 6.62061 10.3428 6.46394 10.6095 6.15061C10.8761 5.83061 11.0095 5.41061 11.0095 4.89061C11.0095 4.37061 10.8761 3.97061 10.6095 3.69061C10.3428 3.40394 9.94945 3.26061 9.42945 3.26061C9.07612 3.26061 8.76612 3.34727 8.49945 3.52061C8.23945 3.68727 8.04945 3.91727 7.92945 4.21061H7.06945V0.130605H11.4195V0.930605Z"
        fill="#666666"
      />
    </svg>
  );
};
export const LeftArrow = () => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        opacity="0.1"
        x="0.863281"
        y="0.5"
        width="23"
        height="23"
        rx="4.5"
        stroke="#112347"
      />
      <path
        d="M12.4502 9.79605V7L7.36328 11.7533L12.4502 16.5066V13.7105C12.4502 13.7105 13.8633 13.4309 16.4068 14.5493C18.9502 15.6678 20.3633 17 20.3633 17C20.3633 17 19.7981 13.7664 17.2546 11.7533C14.7111 9.74013 12.4502 9.79605 12.4502 9.79605Z"
        fill="#6C2AD2"
      />
    </svg>
  );
};
export const DownArrowIcon = () => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        opacity="0.1"
        x="0.863281"
        y="0.5"
        width="23"
        height="23"
        rx="4.5"
        stroke="#112347"
      />
      <path
        d="M13.2815 16.006C12.7866 16.5418 11.94 16.5418 11.4451 16.006L7.3733 11.5982C6.63374 10.7976 7.20158 9.5 8.29149 9.5L16.4351 9.5C17.525 9.5 18.0928 10.7976 17.3533 11.5982L13.2815 16.006Z"
        fill="#6C2AD2"
      />
    </svg>
  );
};
export const VectorIcon = () => {
  return (
    <svg
      width="62"
      height="144"
      viewBox="0 0 62 144"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M35.8633 0L35.8633 50" stroke="#BDBDBD" stroke-dasharray="2 2" />
      <g filter="url(#filter0_d_10008_126141)">
        <circle cx="35.8633" cy="71.5" r="10.5" fill="white" />
      </g>
      <path
        d="M30.3633 69.709C30.3633 68.6044 31.2587 67.709 32.3633 67.709H39.3633C40.4679 67.709 41.3633 68.6044 41.3633 69.709V73.5007C41.3633 74.6052 40.4679 75.5007 39.3633 75.5007H32.3633C31.2587 75.5007 30.3633 74.6052 30.3633 73.5007V69.709Z"
        stroke="#666666"
        stroke-width="0.75"
        stroke-linejoin="round"
      />
      <path
        d="M31.7846 69.0119C31.2804 68.5497 31.6074 67.709 32.2914 67.709H39.4352C40.1192 67.709 40.4462 68.5497 39.942 69.0119L37.8905 70.8924C36.7435 71.9438 34.9831 71.9438 33.8361 70.8924L31.7846 69.0119Z"
        stroke="#666666"
        stroke-width="0.75"
        stroke-linejoin="round"
      />
      <path
        d="M35.8633 93L35.8633 144"
        stroke="#BDBDBD"
        stroke-dasharray="2 2"
      />
      <defs>
        <filter
          id="filter0_d_10008_126141"
          x="19.3633"
          y="56"
          width="33"
          height="33"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="3" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_10008_126141"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_10008_126141"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};
export const TwoIcon = () => {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="8.03125" cy="8" r="8" fill="#6C2AD2" fill-opacity="0.13" />
      <path
        d="M5.54125 10.27C6.38792 9.59 7.05125 9.03333 7.53125 8.6C8.01125 8.16 8.41458 7.70333 8.74125 7.23C9.07458 6.75 9.24125 6.28 9.24125 5.82C9.24125 5.38667 9.13458 5.04667 8.92125 4.8C8.71458 4.54667 8.37792 4.42 7.91125 4.42C7.45792 4.42 7.10458 4.56333 6.85125 4.85C6.60458 5.13 6.47125 5.50667 6.45125 5.98H5.57125C5.59792 5.23333 5.82458 4.65667 6.25125 4.25C6.67792 3.84333 7.22792 3.64 7.90125 3.64C8.58792 3.64 9.13125 3.83 9.53125 4.21C9.93792 4.59 10.1413 5.11333 10.1413 5.78C10.1413 6.33333 9.97458 6.87333 9.64125 7.4C9.31458 7.92 8.94125 8.38 8.52125 8.78C8.10125 9.17333 7.56458 9.63333 6.91125 10.16H10.3513V10.92H5.54125V10.27Z"
        fill="#6C2AD2"
      />
    </svg>
  );
};
export const NumberIcon = () => {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.363281"
        y="0.370605"
        width="16"
        height="16"
        rx="5"
        fill="#D9D9D9"
        fill-opacity="0.28"
      />
      <path
        d="M9.08328 6.96261C8.96595 6.37061 8.60061 6.0746 7.98728 6.0746C7.51261 6.0746 7.15795 6.25861 6.92328 6.62661C6.68861 6.98927 6.57395 7.58927 6.57928 8.42661C6.70195 8.14927 6.90461 7.93327 7.18728 7.77861C7.47528 7.61861 7.79528 7.53861 8.14728 7.53861C8.69661 7.53861 9.13395 7.70927 9.45928 8.05061C9.78995 8.39194 9.95528 8.86394 9.95528 9.46661C9.95528 9.82927 9.88328 10.1546 9.73928 10.4426C9.60061 10.7306 9.38728 10.9599 9.09928 11.1306C8.81661 11.3013 8.47261 11.3866 8.06728 11.3866C7.51795 11.3866 7.08861 11.2639 6.77928 11.0186C6.46995 10.7733 6.25395 10.4346 6.13128 10.0026C6.00861 9.57061 5.94728 9.03727 5.94728 8.40261C5.94728 6.44527 6.62995 5.46661 7.99528 5.46661C8.51795 5.46661 8.92861 5.60794 9.22728 5.8906C9.52595 6.17327 9.70195 6.53061 9.75528 6.96261H9.08328ZM7.99528 8.15461C7.76595 8.15461 7.54995 8.20261 7.34728 8.29861C7.14461 8.38927 6.97928 8.53061 6.85128 8.72261C6.72861 8.90927 6.66728 9.13861 6.66728 9.41061C6.66728 9.81594 6.78461 10.1466 7.01928 10.4026C7.25395 10.6533 7.58995 10.7786 8.02728 10.7786C8.40061 10.7786 8.69661 10.6639 8.91528 10.4346C9.13928 10.1999 9.25128 9.88527 9.25128 9.49061C9.25128 9.07461 9.14461 8.74927 8.93128 8.51461C8.71795 8.27461 8.40595 8.15461 7.99528 8.15461Z"
        fill="#666666"
      />
    </svg>
  );
};
export const ArrowIcon = () => {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.88672 3.7041L14.3648 8.37077L9.88672 13.0374"
        stroke="#585858"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <line
        x1="13.1836"
        y1="8.7251"
        x2="3.36155"
        y2="8.7251"
        stroke="#585858"
        stroke-width="2"
        stroke-linecap="round"
      />
    </svg>
  );
};
export const Spot = () => {
  return (
    <svg
      width="33"
      height="32"
      viewBox="0 0 33 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16.3991 2.66657C10.2537 2.64569 5.23414 7.53497 5.03351 13.655L5.02734 14.0348C5.12949 17.0346 6.15011 19.8941 7.94772 22.25L8.3699 22.8009C10.0857 24.9826 12.1248 26.8976 14.4144 28.476L14.9656 28.8471L15.0461 28.9102C15.8308 29.4741 16.8904 29.4741 17.6751 28.9102L17.742 28.8552C19.5587 27.677 21.234 26.2927 22.7346 24.7296C25.7855 21.5001 27.6243 17.8815 27.6937 14.2065L27.6939 14.07C27.7147 7.90907 22.8405 2.87406 16.7393 2.67276L16.3991 2.66657ZM16.3928 4.68962C21.4308 4.70684 25.5212 8.73222 25.6731 13.7451L25.6774 14.1871C25.619 17.2682 24.0058 20.4429 21.2767 23.3319C19.8851 24.7813 18.3249 26.0698 16.6326 27.1656L16.5198 27.2504C16.4287 27.3295 16.2935 27.3295 16.2024 27.2504L16.0928 27.1677C13.5718 25.5217 11.3593 23.4437 9.55636 21.0286C8.10412 19.1253 7.24355 16.8495 7.07033 14.4755L7.04488 13.9995C7.06199 8.94928 11.075 4.8463 16.0725 4.69395L16.3928 4.68962ZM16.359 9.86816C13.9745 9.86816 12.0414 11.8072 12.0414 14.1991C12.0414 16.5909 13.9745 18.5299 16.359 18.5299C18.7435 18.5299 20.6765 16.5909 20.6765 14.1991C20.6765 11.8072 18.7435 9.86816 16.359 9.86816ZM16.3595 11.8913C17.6301 11.8913 18.6601 12.9244 18.6601 14.1989C18.6601 15.4734 17.6301 16.5066 16.3595 16.5066C15.0889 16.5066 14.059 15.4734 14.059 14.1989C14.059 12.9244 15.0889 11.8913 16.3595 11.8913Z"
        fill="#112347"
      />
    </svg>
  );
};

export function TabPanel(props) {
  const { children, value, index, ...other } = props;
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Typography
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && children}
    </Typography>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export const ToggleOn = () => {
  return (
    <svg
      width="42"
      height="25"
      viewBox="0 0 42 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.460938"
        width="41.54"
        height="24.3705"
        rx="12.1852"
        fill="url(#paint0_linear_9124_97512)"
      />
      <ellipse
        cx="30.0913"
        cy="12.1852"
        rx="8.52103"
        ry="8.86199"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_9124_97512"
          x1="12.7341"
          y1="-1.66162"
          x2="18.2578"
          y2="28.3495"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#6C2AD2" />
          <stop offset="1" stop-color="#77CFFE" />
        </linearGradient>
      </defs>
    </svg>
  );
};
export const CloseLayout = ({ color = '#666666' }) => {
  return (
    <svg
      width="70"
      height="152"
      viewBox="0 0 70 152"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_9124_102024)">
        <rect
          x="8"
          y="4"
          width="53.3633"
          height="135.363"
          rx="10"
          fill="white"
          shape-rendering="crispEdges"
        />
        <line
          x1="28.0978"
          y1="21"
          x2="41.6836"
          y2="34.5858"
          stroke={color}
          stroke-width="2"
          stroke-linecap="round"
        />
        <line
          x1="27.6836"
          y1="34.5858"
          x2="41.2694"
          y2="21"
          stroke={color}
          stroke-width="2"
          stroke-linecap="round"
        />
        <path
          d="M28.5273 70.3242L34.7255 64.3387L40.711 70.5369"
          stroke="#9D9C9E"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M40.8086 110.113L34.7158 116.206L28.623 110.113"
          stroke="#6C2AD2"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <rect
          x="8.5"
          y="4.5"
          width="52.3633"
          height="134.363"
          rx="9.5"
          stroke="#C1BDBD"
          shape-rendering="crispEdges"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_9124_102024"
          x="0"
          y="0"
          width="69.3633"
          height="151.363"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="4" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9124_102024"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_9124_102024"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export const OwnerCard = (
  {
    changeToggle,
    setSelectedBuyers,
    count,
    onClose,
    dialogStates,
    setDialogStates,
    selectedBuyers,
    setSelectedBuyerId,
    openOwner,
    showBackdrop,
    buyerId,
    open,
    setOpen,
    userType,
    isModalOpen,
    setIsModalOpen,
    index,
    position,
    arrayCollection = [],
    data,
    setArrayCollection,
    setPosition,
    setBuyerId,
    setUserType,
    setOpenOwner,
    rowData,
    setFromSearch,
    activitywidth,
    fromSearch,
    catSelected,
    openBuyer,
    setOpenBuyer,
    noteSelected,
    taskId,
    taskBinderId,
    onShowChat,
    onOpenAutomatedStage,
    onOpenIncompleteDetails,
    refreshPipeline,
    isPipelineManagement,
  },
  props
) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [showGrid, setShowGrid] = useState(true);
  const [expand, setExpand] = useState(false);
  const [buyerpropertylist, setBuyerpropertylist] = useState({});
  const [proid, setProid] = useState();
  const [proUniqueId, setProUniqueId] = useState('');
  const [indexCount, setIndexCount] = useState([]);
  const [isPipelineCat, setIsPipelineCat] = useState(null);
  const [pipelineCat, setPipelineCat] = useState(null);
  const [pipelineId, setPipelineId] = useState(null);
  const [isAppraisal, setIsAppraisal] = useState(null);
  const [loading, setLoading] = useState(false);
  const [userName, setUserName] = React.useState('');
  const [feedBackData, setFeedBackData] = useState(null);
  const [userEmail, setUserEmail] = React.useState('');
  const [address, setAddress] = useState();
  // useEffect(()=>{
  //   if(fromSearch){
  //     setTimeout(() => {
  //       setExpand(true)
  //     }, 5000)
  //   }
  // },[])

  const directcomm = (userId) => {
    const data = localStorage.getItem('userDetail');
    const userDetail = JSON.parse(data);
    const agentId = userDetail?.userId;
    const userType = userDetail?.primaryUserType;

    if (userId) {
      getApiCall(
        GET_BINDERID +
          `/${agentId}` +
          `/${userId}` +
          `/${proid}` +
          `/${userType}`
      ).then((resp) => {
        onShowChat(resp?.data?.binderId);
      });
    }
  };
  useEffect(() => {
    Propertylist('default');
  }, [buyerId]);

  const Propertylist = (value) => {
    if (buyerId) {
      let url = PROPERTYLIST_COMMON + '/Vendor/' + buyerId;
      getApiCall(url).then((res) => {
        setPipelineId(res?.data?.data?.[0]?.pd_pipelineId);
        setPipelineCat(res?.data?.data?.[0]?.pd_categoryId);
        if (value == 'default') {
          setProid(res?.data?.data[0]?.pd_Id);
          setProUniqueId(res?.data?.data[0]?.pd_propertyId);
          setIsPipelineCat(res?.data?.data?.[0]?.isPipelineProperty);
          setIsAppraisal(res?.data?.data?.[0]?.pd_isAppraisal);
        }
        setBuyerpropertylist(res?.data?.data);
      });
    }
  };

  const [selectedPaAddressTwo, setSelectedPaAddressTwo] = useState('');
  const handleChangePaAddressTwo = (newAddress) => {
    setSelectedPaAddressTwo(newAddress);
  };

  const Closeicon = () => {
    return (
      <svg
        width="18"
        height="18"
        viewBox="0 0 17 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <line
          x1="2.09781"
          y1="1"
          x2="15.6836"
          y2="14.5858"
          stroke="#6C2AD2"
          stroke-width="2"
          stroke-linecap="round"
        />
        <line
          x1="1.68359"
          y1="14.5858"
          x2="15.2694"
          y2="1"
          stroke="#6C2AD2"
          stroke-width="2"
          stroke-linecap="round"
        />
      </svg>
    );
  };
  const Uparrow = () => {
    return (
      <svg
        width="21"
        height="21"
        viewBox="0 0 15 9"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1.52734 7.32446L7.72552 1.33895L13.711 7.53713"
          stroke="#9D9C9E"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    );
  };

  const Downarrow = () => {
    return (
      <svg
        width="21"
        height="21"
        viewBox="0 0 15 9"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.8086 1.11328L7.71582 7.20606L1.62305 1.11328"
          stroke="#6C2AD2"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    );
  };
  const Upactivearrow = () => {
    return (
      <svg
        width="21"
        height="21"
        viewBox="0 0 15 9"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ transform: 'rotate(180deg)' }}
      >
        <path
          d="M13.8086 1.11328L7.71582 7.20606L1.62305 1.11328"
          stroke="#6C2AD2"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    );
  };

  const Downinactivearrow = () => {
    return (
      <svg
        width="21"
        height="21"
        viewBox="0 0 15 9"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ transform: 'rotate(180deg)' }}
      >
        <path
          d="M1.52734 7.32446L7.72552 1.33895L13.711 7.53713"
          stroke="#9D9C9E"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    );
  };
  var len = arrayCollection?.length;

  var previous = arrayCollection[(position + len - 1) % len];
  var next = arrayCollection[(position + 1) % len];

  const [showExpand, setShowExpand] = useState(false);
  const [show, setShow] = useState(false);
  const [expandFeedback, setExpandFeedback] = useState(false);
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [openFeedback, setOpenFeedback] = useState(false);
  const [value, setValue] = React.useState(0);
  const [newActiveValue, setActiveValue] = React.useState(0);
  const [propertyValue, setPropertyValue] = React.useState(0);
  // const [selected, setSelected] = useState('');
  const [newAction] = useState(false);
  const [action, setAction] = useState('');
  const { setLoaderConfig } = useContext(LoaderContext);
  const [profileDetails, setProfileDetails] = useState({});
  const [expanded, setExpanded] = useState(false);
  const [isHidden, setIsHidden] = useState(false);
  const [collapsedExpanded, setCollapsedExpanded] = useState(false);
  const [opendialog, setOpendialog] = useState(false);
  const [openbuyermatch, setOpenbuyermatch] = useState(false);
  const [opendialogexpand, setOpendialogExpand] = useState(false);
  const [openbuyermatchexpand, setOpenbuyermatchExpand] = useState(false);
  const [closeownercard, setCloseownercard] = useState(false);
  const [dropdownValue, setDropdownValue] = useState('');
  const [dialogPosition, setDialogPosition] = useState({ x: 0, y: 0 });
  const [buyermatchAnchorEl, setBuyermatchAnchorEl] = useState(null);
  const [ownerDetailNavigation, setOwnerDetailNavigation] = useState('Profile');
  const [propertySelected, setPropertySelected] = useState(false);
  const [propertySelectedDetail, setPropertySeletedDetail] = useState({});
  const scrollToTopContainer = useRef(null);

  //to open expanded card view to show task/note from search results
  useEffect(() => {
    if (taskId || noteSelected) {
      setOwnerDetailNavigation('Activity');
    }
  }, []);

  const handleClose = () => {
    setAnchorEl(null);
    setOpendialog(false);
    setShowGrid(true);
    setAction('');
    if (opendialog) {
      setDialogPosition((prevPosition) => ({
        ...prevPosition,
        x: prevPosition.x - 370,
      }));
    }
  };

  const handleClosebuyermatch = () => {
    setBuyermatchAnchorEl(null);
    setOpenbuyermatch(false);
    setShowGrid(true);
    setAction('');
    if (openbuyermatch) {
      setDialogPosition((prevPosition) => ({
        ...prevPosition,
        x: prevPosition.x - 370,
      }));
    }
  };
  const handleCloseExpand = () => {
    setOpendialogExpand(false);
    setOpenbuyermatchExpand(false);
    setExpandFeedback(false);
    setCloseownercard(false);
    setButtonDisabled(false);
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  function toggleShow() {
    setShow(!show);
  }

  var buttonText = show ? (
    <Typography
      sx={{
        fontFamily: 'Poppins !important',
        fontStyle: 'normal !important',
        fontWeight: '600 !important',
        fontSize: '12px',
      }}
    >
      <Grid
        item
        sx={{
          display: 'flex',
          direction: 'row',
          spacing: '2',
          textTransform: 'capitalize',
        }}
      >
        <Grid item sx={{ pr: 1 }}>{`collapse  `}</Grid>
        <Grid item>
          <Arrow2 />
        </Grid>
      </Grid>
    </Typography>
  ) : (
    <Typography
      sx={{
        fontFamily: 'Poppins !important',
        fontStyle: 'normal !important',
        fontWeight: '600 !important',
        fontSize: '12px',
      }}
    >
      <Grid
        item
        sx={{
          display: 'flex',
          direction: 'row',
          spacing: '2',
          textTransform: 'capitalize',
        }}
      >
        {' '}
        <Grid item sx={{ pr: 1 }}>
          expand
        </Grid>{' '}
        <Grid item>
          <Arrow2 />
        </Grid>
      </Grid>
    </Typography>
  );

  const [marketShow, setMarketShow] = useState(false);
  const [propertyColor, setPropertyColor] = useState('#000000');
  const [marketColor, setMarketColor] = useState('#000000');
  const theme = useTheme();
  const isSm = useMediaQuery(theme.breakpoints.down(430));
  const Small = useMediaQuery((theme) => theme.breakpoints.only('sm'));
  const matches = useMediaQuery(theme.breakpoints.down(1200));
  const matches370 = useMediaQuery(theme.breakpoints.down(370));
  const matches400 = useMediaQuery(theme.breakpoints.down(400));
  const matches450 = useMediaQuery(theme.breakpoints.down(450));
  const matches700 = useMediaQuery(theme.breakpoints.down(700));
  const matches870 = useMediaQuery(theme.breakpoints.down(870));
  const matches1800 = useMediaQuery(theme.breakpoints.down(1800));
  const matches1200 = useMediaQuery(theme.breakpoints.down(1200));
  const matches1250 = useMediaQuery(theme.breakpoints.down(1250));
  const matches1400 = useMediaQuery(theme.breakpoints.down(1400));
  const matches1600 = useMediaQuery(theme.breakpoints.down(1600));
  const isXl = useMediaQuery(theme.breakpoints.down('xl'));
  const isLg = useMediaQuery(theme.breakpoints.down('lg'));

  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  const isDesktop = useMediaQuery(`(min-width:${DESKTOP_BREAKPOINT}px)`);
  const shrink = useMediaQuery(theme.breakpoints.down(1400));
  const { collapsed } = useContext(PropertyContext);

  const useStyles = makeStyles({
    dialogoverlay: {
      position: 'fixed !important',
      display: 'flex',
      justifyContent: 'end',
      right: '2%',
      // width: matches ? "100%" : "89%",
      // height:  "dialogHeight !important",
      height: '100%',
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      marginLeft: !collapsed
        ? isXl
          ? '170px'
          : '203px'
        : matches
        ? ''
        : isXl
        ? '70px'
        : '85px',
      marginTop: matchessm ? '0px' : isLg ? '98px' : isXl ? '80px' : '98px',
    },
    dialogoverlayCards: {
      position: 'fixed !important',
      width: '89%',
      height: matchessm ? '100%' : '90%',
      marginLeft: '16%',
      // marginTop: "4.5%",
      marginTop: matchessm ? '0px' : '34px',
    },
  });

  const classes = useStyles();
  const getListInfo = async (buyerId) => {
    if (!buyerId || !proid) return;
    setProfileDetails({});
    setLoading(true);
    setLoaderConfig({ isVisible: false });
    const url = `${API_URL}agent/userCardDetails/Owner/${buyerId}/${proid}`;
    if (buyerId !== '' && buyerId !== 'undefined' && buyerId) {
      getApiCall(url).then(async (res) => {
        setLoaderConfig({ isVisible: false });
        if (res?.data?.status == '-1') {
          toast.error(res?.data?.message, {
            position: 'top-right',
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            progress: 0,
            theme: 'light',
            style: {
              fontFamily: 'Poppins', // 👈 Inline Poppins font
            },
          });
        } else {
          await setProfileDetails(res?.data);
        }
        setLoading(false);
      });
    }
  };
  useEffect(() => {
    if (open && buyerId && proid) {
      getListInfo(buyerId);
    }
  }, [open, buyerId, proid]);

  useEffect(() => {
    setShow(false);
    setOpenbuyermatch(false);
    setOpendialog(false);
    setAction('');
  }, [expand, open]);

  const [selectedProperty, setSelectedProperty] = useState();
  const handleOptionChange = (event, property) => {
    setShow(false);
    setSelectedProperty(property);
    setAction(event.target.value);

    if (event.target.value === 10) {
      if (expand) {
        setOpenbuyermatch(false);
        setOpendialog(true);
      } else {
        setOpendialog(true);
        if (matches1250) {
          setShowGrid(false);
          setAnchorEl(document.body);
          setBuyermatchAnchorEl(null);
        }
      }
    } else if (event.target.value === 20) {
      if (expand) {
        setOpendialog(false);
        setOpenbuyermatch(true);
      } else {
        setOpenbuyermatch(true);
        if (matches1250) {
          setShowGrid(false);
          setBuyermatchAnchorEl(document.body);
          setAnchorEl(null);
        }
      }
    }
    if (!opendialog) {
      setDialogPosition((prevPosition) => ({
        ...prevPosition,
        x: prevPosition.x + 371,
      }));
    } else if (!openbuyermatch) {
      setDialogPosition((prevPosition) => ({
        ...prevPosition,
        x: prevPosition.x + 371,
      }));
    }
  };

  const handleDropdownChange = (selectedValue) => {
    setDropdownValue(selectedValue);
    {
      selectedValue === 10 && setOpenbuyermatch(true);
      setDropdownValue('');
    }
    if (!openbuyermatch) {
      setDialogPosition((prevPosition) => ({
        ...prevPosition,
        x: prevPosition.x + 370,
      }));
    }
  };

  const containerRef = useRef(null);

  useEffect(() => {
    if (
      expand &&
      matches1400 &&
      !matches870 &&
      (opendialog || openbuyermatch)
    ) {
      containerRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [opendialog, openbuyermatch]);

  const rightPosition = count * 367;

  const [anchorpopoverEl, setpopoverAnchorEl] = useState(null);
  const [popoverOpen, setPopoverOpen] = useState(false);

  const handleLeftArrowClick = (event) => {
    setPopoverOpen(true);
    setpopoverAnchorEl(event.currentTarget);
  };

  const handleClosePopover = () => {
    setPopoverOpen(false);
    setpopoverAnchorEl(null);
  };

  const isPopoverOpen = Boolean(anchorpopoverEl);
  const popoverId = isPopoverOpen ? 'expanded-buyers-card-popover' : undefined;

  const [anchorExpandEl, setExpandAnchorEl] = useState(null);

  const handleExpandClick = (event) => {
    setExpandAnchorEl(event.currentTarget);
  };

  const handleExpandClose = () => {
    setExpandAnchorEl(null);
  };

  const openExpand = Boolean(anchorExpandEl);
  const popoverExpandId = openExpand ? 'simple-popover' : undefined;

  const [anchorElInsights, setAnchorElInsights] = useState(null);
  const [anchorElBuyermatch, setAnchorElBuyermatch] = useState(null);

  const handleInsightsClose = () => {
    setAnchorElInsights(null);
    handleClose();
  };

  const handleBuyermatchClose = () => {
    setAnchorElBuyermatch(null);
    handleClosebuyermatch();
  };

  const openInsightsPopover = Boolean(anchorElInsights);
  const openBuyermatchPopover = Boolean(anchorElBuyermatch);

  const [selectedPaBlue, setSelectedPaBlue] = useState('');
  const handleBlueline = (newBlue) => {
    setSelectedPaBlue(newBlue);
  };
  const extraRightSpace = window.innerWidth > 2000 ? 40 : 0;

  return (
    <>
      <Dialog
        sx={
          showBackdrop
            ? {
                maxWidth: expand ? 'auto' : 'fit-content',
                position: 'relative',
                left: expand ? -60 : window.innerWidth - 200,
              }
            : {}
        }
        // style={{zIndex:1}}
        style={!matches700 ? { zIndex: 1 } : {}}
        onClose={onClose}
        // className={showBackdrop ? "dialogoverlayCards" : "dialogoverlay"}
        className={
          showBackdrop ? classes.dialogoverlayCards : classes.dialogoverlay
        }
        TransitionComponent={Transition}
        disableBackdropClick
        disableEnforceFocus
        PaperProps={{
          sx: {
            left: matchessm ? 0 : 'auto',
            position: 'absolute',
            top: showBackdrop ? 50 : !showBackdrop && matchessm ? 0 : 0,
            // right: 0,
            right: showBackdrop
              ? showBackdrop && changeToggle
                ? 0
                : 300 * (selectedBuyers?.length - (count + 1)) + extraRightSpace
              : 0,
            m: 0,
            height: isDesktop && `calc(90vh / ${APP_SCALE})`,

            maxHeight: isDesktop && `calc(90vh / ${APP_SCALE})`,

            minHeight: !isDesktop && '100%',
            width: matchessm
              ? '100vw'
              : expand && show && !matches1200 && !matches870
              ? '94%'
              : expand && show && matches1200 && !matches870
              ? '92%'
              : expand && !show && shrink && !matches870
              ? '92%'
              : expand && !show && !matches1200 && !matches870
              ? '100%'
              : expand && !show && matches1200 && !matches870
              ? '92%'
              : expand && matches870 && !show
              ? '367px'
              : expand && matches870 && show
              ? '367px'
              : matches370 && expand && show
              ? '350px'
              : matches370 && !expand && !show
              ? '350px'
              : showBackdrop
              ? '500px'
              : '367px',
            // expand
            //   ? expand && show && window.innerWidth > 960
            //     ? "91%"
            //     : expand && show && isSm
            //     ? "99.8%"
            //     : expand && window.innerWidth < 960
            //     ? "367px"
            //     : expand && show && window.innerWidth < 960
            //     ? "367px" :expand && !show && (opendialog || openbuyermatch) ? "91%"
            //     : "70%"
            //   : isSm && show
            //   ? "100%"
            //   : isSm && !show
            //   ? "85.1%"
            //   : "auto",
            overflow: 'unset',
            // overflowX: "scroll",
            transition: 'all 0.5s ease',
            boxShadow: 'none',
            // paddingBottom: 'calc(100px + 1em)',
            paddingBottom: matches700 ? '20px' : '10px',
            transformOrigin: !matchessm && 'top right',
            transform: matchessm && 'none',
          },
        }}
        open={open}
        maxWidth="1719px"
        minHeight={matchessm ? '100vh' : 'auto'}
        hideBackdrop
      >
        {!closeownercard && (
          <>
            {!showBackdrop && showGrid && (
              <div
                style={{
                  position: 'absolute',
                  left: matches450
                    ? 0
                    : expand &&
                      show &&
                      window.innerWidth >= 1200 &&
                      expand &&
                      show &&
                      window.innerWidth <= 1450
                    ? -60
                    : expand &&
                      window.innerWidth < 1001 &&
                      window.innerWidth > 869
                    ? -60
                    : -80,
                  top: -5,
                  cursor: 'pointer',
                  paddingBottom: matches450 && '20px',
                }}
                onClick={() => {}}
              >
                <Grid
                  container
                  position={position}
                  arrayCollection={arrayCollection}
                  data={data}
                  setBuyerId={setBuyerId}
                  setPosition={setPosition}
                  setArrayCollection={setArrayCollection}
                  setIsModalOpen={setIsModalOpen}
                  isModalOpen={isModalOpen}
                  setOpen={setOpen}
                  open={open}
                  setExpand={setExpand}
                  setUserType={setUserType}
                  userType={userType}
                  sx={{
                    marginTop: matches450 ? '-55px' : '7px',
                    height: matches450
                      ? '53.58px'
                      : ['owner', 'notes', 'task', 'ap'].includes(catSelected)
                      ? '60px'
                      : '135.38px',
                    width: matches450 ? window.innerWidth : '53.58px',
                    backgroundColor: 'white',
                    borderRadius: '5px',
                  }}
                  style={{
                    display: matchessm ? 'none' : 'flex',
                    flexdirection: matches450 ? 'row' : 'column',
                    justifyContent: matches450 ? 'flex-end' : 'center',
                    gap: matches450 && '20px',
                  }}
                >
                  {!matches450 && (
                    <Grid sx={{ marginTop: '10px' }}>
                      <IconButton
                        onClick={() => {
                          setOpen(!open);
                          setIsModalOpen(!isModalOpen);
                          setExpand(false);
                          setSelectedBuyerId('');
                          setIsHidden(false);
                          setOwnerDetailNavigation('Profile');
                          setPropertySelected(false);
                          setPropertySeletedDetail({});
                          setBuyerId('');
                          setProfileDetails({});
                          if (typeof setFromSearch === 'function') {
                            setFromSearch(false);
                          }
                        }}
                      >
                        <Closeicon />{' '}
                      </IconButton>
                    </Grid>
                  )}

                  {catSelected != 'owner' &&
                    catSelected != 'notes' &&
                    catSelected != 'task' &&
                    catSelected != 'ap' && (
                      <Grid sx={{ marginTop: matches450 ? '10px' : '5px' }}>
                        <IconButton
                          disabled={position === 0}
                          onClick={() => {
                            if (
                              position !== 0 &&
                              data[position - 1]?.userCategory[0]?.userType ===
                                'Vendor'
                            ) {
                              collectId(
                                data,
                                previous,
                                setBuyerId,
                                setPosition,
                                setArrayCollection
                                // setUserType,
                                //userType
                              );
                            } else {
                              setOpen(!open);
                              setOpenBuyer(true);
                              collectId(
                                data,
                                previous,
                                setBuyerId,
                                setPosition,
                                setArrayCollection
                                // setUserType,
                                //userType
                              );
                            }
                          }}
                        >
                          {position === 0 ? <Uparrow /> : <Upactivearrow />}{' '}
                        </IconButton>
                      </Grid>
                    )}

                  {catSelected != 'owner' &&
                    catSelected != 'notes' &&
                    catSelected != 'task' &&
                    catSelected != 'ap' && (
                      <Grid sx={{ marginTop: matches450 ? '10px' : '5px' }}>
                        <IconButton
                          disabled={position === len - 1}
                          onClick={() => {
                            if (
                              position !== len - 1 &&
                              data[position + 1]?.userCategory[0]?.userType ===
                                'Vendor'
                            ) {
                              collectId(
                                data,
                                next,
                                setBuyerId,
                                setPosition,
                                setArrayCollection
                              );
                            } else {
                              setOpen(!open);
                              setOpenBuyer(true);
                              collectId(
                                data,
                                next,
                                setBuyerId,
                                setPosition,
                                setArrayCollection
                              );
                            }
                          }}
                        >
                          {position === len - 1 ? (
                            <Downinactivearrow />
                          ) : (
                            <Downarrow />
                          )}
                        </IconButton>
                      </Grid>
                    )}
                  {matches450 && (
                    <Grid
                      sx={{
                        marginTop: '10px',
                        marginRight: matches370
                          ? '20px'
                          : matches450
                          ? '10px'
                          : '',
                      }}
                    >
                      <IconButton
                        onClick={() => {
                          setOpen(!open);
                          setIsModalOpen(!isModalOpen);
                          setExpand(false);
                          setSelectedBuyerId('');
                          setIsHidden(false);
                          setOwnerDetailNavigation('Profile');
                          setPropertySelected(false);
                          setPropertySeletedDetail({});
                          setBuyerId('');
                          setProfileDetails({});
                          if (typeof setFromSearch === 'function') {
                            setFromSearch(false);
                          }
                        }}
                      >
                        <Closeicon />{' '}
                      </IconButton>
                    </Grid>
                  )}
                </Grid>
              </div>
            )}
          </>
        )}

        <Stack
          style={{
            display: 'flex',
            //border:"1px solid blue",
            // overflow: expand ? "hidden" : "scroll",
            flexDirection: matches870 ? 'column' : 'row',
            // width: "100%",
            overflowY: 'scroll',
            '-webkit-scrollbar': {
              display: 'none',
            },
            '-ms-overflow-style': 'none',
            'scrollbar-width': 'none',
          }}
          ref={scrollToTopContainer}
        >
          {matchessm && (
            <OwnerDetailsNavigation
              ownerDetailNavigation={ownerDetailNavigation}
              setOwnerDetailNavigation={setOwnerDetailNavigation}
              setPropertySelected={setPropertySelected}
              scrollToTopContainer={scrollToTopContainer}
            />
          )}

          {matchessm && (
            <Stack
              direction="row"
              gap="8px"
              justifyContent="space-between"
              alignItems="center"
              sx={{
                width: '90%',
                margin: matchessm && 'auto',
                marginTop: '23px',
              }}
            >
              {/* Navigation Buttons */}
              <Stack direction="row" gap="8px">
                <Grid
                  sx={{
                    marginTop: '0px',
                    border: '1px solid #E7E5E5',
                    borderRadius: '5px',
                  }}
                >
                  <IconButton
                    disabled={position === 0}
                    onClick={() => {
                      if (
                        position !== 0 &&
                        data[position - 1]?.userCategory[0]?.userType ===
                          'Vendor'
                      ) {
                        collectId(
                          data,
                          previous,
                          setBuyerId,
                          setPosition,
                          setArrayCollection
                          // setUserType,
                          //userType
                        );
                      } else {
                        setOpen(!open);
                        setOpenBuyer(true);
                        collectId(
                          data,
                          previous,
                          setBuyerId,
                          setPosition,
                          setArrayCollection
                          // setUserType,
                          //userType
                        );
                      }
                    }}
                  >
                    {position === 0 ? <Uparrow /> : <Upactivearrow />}
                  </IconButton>
                </Grid>
                <Grid
                  sx={{
                    marginTop: '0px',
                    border: '1px solid #E7E5E5',
                    borderRadius: '5px',
                  }}
                >
                  <IconButton
                    disabled={position === len - 1}
                    onClick={() => {
                      if (
                        position !== len - 1 &&
                        data[position + 1]?.userCategory[0]?.userType ===
                          'Vendor'
                      ) {
                        collectId(
                          data,
                          next,
                          setBuyerId,
                          setPosition,
                          setArrayCollection
                          //  setUserType,
                          //userType
                        );
                      } else {
                        setOpen(!open);
                        setOpenBuyer(true);
                        collectId(
                          data,
                          next,
                          setBuyerId,
                          setPosition,
                          setArrayCollection
                          //  setUserType,
                          //userType
                        );
                      }
                    }}
                  >
                    {position === len - 1 ? (
                      <Downinactivearrow />
                    ) : (
                      <Downarrow />
                    )}
                  </IconButton>
                </Grid>
              </Stack>

              {userType === 'Both' && (
                <Stack
                  justifyContent="space-around"
                  direction="row"
                  alignItems="center"
                  spacing={2}
                  sx={{ marginLeft: '2px', margin: '1px', marginTop: '-1px' }}
                >
                  <Typography
                    sx={{
                      ...poppins400,
                      fontSize: '12px',
                      color: '#9C9C9C',
                      marginLeft: '90px',
                    }}
                  >
                    Buyer
                  </Typography>
                  <Typography
                    onClick={() => {
                      setOpen(!open);
                      setOpenOwner(!openOwner);
                    }}
                    style={{
                      cursor: 'pointer',
                      marginTop: '5px',
                      marginLeft: '15px',
                    }}
                  >
                    <ToggleOn />
                  </Typography>
                  <Typography
                    sx={{
                      ...poppins400,
                      fontSize: '12px',
                      color: '#112347',
                      marginLeft: '90px',
                    }}
                  >
                    Owner
                  </Typography>
                </Stack>
              )}

              {/* Close Button */}
              <Grid
                sx={{
                  border: '1px solid #E7E5E5',
                  borderRadius: '5px',
                }}
              >
                <IconButton
                  onClick={() => {
                    setOpen(!open);
                    setIsModalOpen(!isModalOpen);
                    setExpand(false);
                    setSelectedBuyerId('');
                    setIsHidden(false);
                    setOwnerDetailNavigation('Profile');
                    setPropertySelected(false);
                    setPropertySeletedDetail({});
                    setBuyerId('');
                    setProfileDetails({});
                    if (typeof setFromSearch === 'function') {
                      setFromSearch(false);
                    }
                  }}
                >
                  <Closeicon />
                </IconButton>
              </Grid>
            </Stack>
          )}

          {matchessm && ownerDetailNavigation == 'Profile' && (
            <Box
              sx={{
                padding: '0px 10px',
              }}
            >
              <OwnerCardProfile
                showBackdrop={showBackdrop}
                setSelectedBuyers={setSelectedBuyers}
                setSelectedBuyerId={setSelectedBuyerId}
                openOwner={openOwner}
                setOpenOwner={setOpenOwner}
                buyerId={buyerId}
                selectedBuyers={selectedBuyers}
                open={open}
                setOpen={setOpen}
                userType={userType}
                setExpand={setExpand}
                expand={expand}
                data={profileDetails?.OwnerDetails}
                action={action}
                handleOptionChange={handleOptionChange}
                setProfileDetails={setProfileDetails}
                buyerpropertylist={buyerpropertylist}
                loading={loading}
                profileDetails={profileDetails}
              />
              {!expand && (
                <Grid
                  item
                  xs={12}
                  sx={{
                    width: matchessm ? '100%' : '340px',
                    margin: matchessm ? '0px' : '10px 9px',
                    marginTop: '10px',
                  }}
                >
                  <Stack
                    sx={{
                      padding: '15px',
                      border: '1px solid #E7E5E5',
                      borderRadius: '10px',
                      width: '100%',
                    }}
                  >
                    <Stack
                      sx={{
                        width: '100%',
                        height: '38px',

                        // background: "#F7F8F7",
                        background: '#F7F8F7',
                      }}
                      alignItems={'start'}
                      justifyContent={'center'}
                    >
                      <Typography
                        sx={{
                          textAlign: 'center',
                          ...poppins500,
                          fontSize: '14px',
                          color: '#26344E',
                          paddingLeft: '10px',
                        }}
                      >
                        Property Ownership
                      </Typography>
                    </Stack>

                    {Array.isArray(
                      profileDetails?.OwnerDetails?.propertyDetails
                    ) &&
                      profileDetails.OwnerDetails.propertyDetails.map(
                        (property, index) => {
                          const formattedSoldDate = moment(
                            property?.property?.soldDate
                          ).format('DD-MM-YYYY');
                          const numberWithCommas = (x) => {
                            return x
                              .toString()
                              .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                          };
                          return (
                            <Card
                              key={index}
                              sx={{
                                padding: '10px',
                                marginTop: '10px',
                                minHeight: '205px',
                                width: matchessm ? 'auto' : '297px',
                                background: ' #FFFFFF',
                                boxShadow: '0px 1px 4px rgba(0, 0, 0, 0.15)',
                                borderRadius: '6px',
                              }}
                            >
                              <Grid container spacing={2}>
                                <Grid item xs={6}>
                                  <Stack spacing={2}>
                                    {property?.propertyMedia[2]
                                      ?.propertyMedia ? (
                                      <img
                                        src={
                                          property?.propertyMedia[2]
                                            ?.propertyMedia
                                        }
                                        alt=""
                                        height={'125px'}
                                        width={'100%'}
                                        style={{ borderRadius: '6px' }}
                                      />
                                    ) : (
                                      <img
                                        src={PlaceholderImage}
                                        alt="Five cats looking around a field."
                                        height={'125px'}
                                        width={'100%'}
                                        style={{ borderRadius: '6px' }}
                                      />
                                    )}
                                    <Button
                                      variant="text"
                                      sx={{
                                        border: '1px solid #9A9A9F',
                                        ...poppins400,
                                        fontSize: '12px',
                                        color: '#9A9A9F',
                                        borderRadius: '5px',
                                        textTransform: 'capitalize',
                                        height: '30px',
                                      }}
                                    >
                                      {property?.property?.status}
                                    </Button>
                                  </Stack>
                                </Grid>

                                <Grid item xs={6}>
                                  <Stack
                                    direction={'column'}
                                    spacing={2}
                                    sx={{
                                      minHeight: '170px',
                                      display: 'flex',
                                      justifyContent: 'flex-end',
                                    }}
                                  >
                                    <Stack direction={'row'} spacing={2}>
                                      <Stack
                                        direction={'row'}
                                        spacing={1}
                                        alignItems={'center'}
                                      >
                                        <BedIcon />
                                        <Typography
                                          sx={{
                                            ...poppins400,
                                            fontSize: '12px',
                                            color: '#000000',
                                          }}
                                        >
                                          {
                                            property?.propertyOtherDetails
                                              ?.bedRoomCount
                                          }
                                        </Typography>
                                      </Stack>
                                      <Stack
                                        direction={'row'}
                                        spacing={1}
                                        alignItems={'center'}
                                      >
                                        <ShowerIcon />
                                        <Typography
                                          sx={{
                                            ...poppins400,
                                            fontSize: '12px',
                                            color: '#000000',
                                          }}
                                        >
                                          {
                                            property?.propertyOtherDetails
                                              ?.bathRoomCount
                                          }
                                        </Typography>
                                      </Stack>
                                      <Stack
                                        direction={'row'}
                                        spacing={1}
                                        alignItems={'center'}
                                      >
                                        <CarIcon />
                                        <Typography
                                          sx={{
                                            ...poppins400,
                                            fontSize: '12px',
                                            color: '#000000',
                                          }}
                                        >
                                          {
                                            property?.propertyOtherDetails
                                              ?.otherCarParking
                                          }
                                        </Typography>
                                      </Stack>
                                    </Stack>
                                    <Typography
                                      sx={{
                                        ...poppins400,
                                        ...fontsize10,
                                        color: ' #666666',
                                      }}
                                    >
                                      {property?.propertyAddress?.streetName}
                                    </Typography>
                                    {property?.property?.status == 'Sold' && (
                                      <Box
                                        sx={{
                                          ...poppins400,
                                          ...fontsize12,
                                          width: '175px',
                                        }}
                                      >
                                        <Typography
                                          sx={{
                                            ...poppins400,
                                            ...fontsize10,
                                            color: '#666666',
                                          }}
                                        >
                                          Last Sold: &nbsp;
                                        </Typography>
                                        {property?.property?.soldDate !=
                                          null && (
                                          <Typography
                                            sx={{
                                              ...poppins500,
                                              ...fontsize10,
                                              color: '#000000',
                                            }}
                                          >
                                            {/* 12/01/2001 */}
                                            {formattedSoldDate}
                                          </Typography>
                                        )}
                                      </Box>
                                    )}
                                    {property?.property?.status == 'Sold' && (
                                      <Box
                                        sx={{
                                          ...poppins400,
                                          ...fontsize12,
                                          width: '175px',
                                        }}
                                      >
                                        <Typography
                                          sx={{
                                            ...poppins400,
                                            ...fontsize10,
                                            color: '#666666',
                                          }}
                                          // style={{ color: "rgba(17, 35, 71, 0.5)" }}
                                        >
                                          Price : &nbsp;
                                        </Typography>
                                        {property?.property?.soldPrice !=
                                          null && (
                                          <Typography
                                            sx={{
                                              ...poppins500,
                                              ...fontsize10,
                                              color: '#000000',
                                            }}
                                          >
                                            {/* $ 1250,000 */}
                                            {`$${numberWithCommas(
                                              property?.property?.soldPrice
                                            )}`}
                                          </Typography>
                                        )}
                                      </Box>
                                    )}

                                    <Stack>
                                      <Select
                                        id="optionlist"
                                        sx={{
                                          ...poppins500,
                                          fontSize: '12px',
                                          fontColor: '#112347',
                                          border: '1px solid #6C2AD2',
                                          width: '130px',
                                          height: '30px',
                                          borderRadius: '6px',
                                          '& .MuiOutlinedInput-notchedOutline':
                                            {
                                              border: 'none',
                                            },
                                        }}
                                        // size="medium"
                                        value={action}
                                        label="Action"
                                        onChange={(e) => {
                                          handleOptionChange(e, property);
                                        }}
                                        displayEmpty
                                        inputProps={{
                                          'aria-label': 'Without label',
                                        }}
                                      >
                                        <MenuItem
                                          value={''}
                                          sx={{
                                            ...poppins500,
                                            fontSize: '12px',
                                            color: '#112347',
                                          }}
                                        >
                                          Action
                                        </MenuItem>
                                        <MenuItem
                                          value={10}
                                          sx={{
                                            ...poppins500,
                                            fontSize: '12px',
                                            color: '#112347',
                                          }}
                                        >
                                          Insights
                                        </MenuItem>
                                        <MenuItem
                                          value={20}
                                          sx={{
                                            ...poppins500,
                                            fontSize: '12px',
                                            color: '#112347',
                                          }}
                                        >
                                          Buyer Match
                                        </MenuItem>
                                      </Select>
                                    </Stack>
                                  </Stack>
                                </Grid>
                              </Grid>
                            </Card>
                          );
                        }
                      )}
                  </Stack>
                </Grid>
              )}
              {!expand && (
                <Box
                  sx={{
                    width: matchessm ? '100%' : '340px',
                    marginTop: '10px',
                  }}
                >
                  <LiveActivityFeed
                    buyerId={buyerId}
                    agentindividual={false}
                    ownercardprop
                    proid={proid}
                    rowData={rowData}
                    expanded={expand}
                  />
                </Box>
              )}
              {!expand && (
                <Grid
                  // border={1}
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    //marginLeft: "75px",
                    padding: '20px',
                    width: matchessm ? '100%' : '209px',
                    marginBottom: '60px',
                  }}
                >
                  <Typography sx={displayFlex} style={{ gap: '20px' }}>
                    <Typography style={{ paddingRight: '10px' }}>
                      <Button
                        sx={{
                          ...poppins400,
                          fontSize: '12px',
                          color: '#6C2AD2',
                          bgcolor: 'rgba(108, 42, 210, 0.1)',
                          borderRadius: '4.05125px',
                          height: '30px',
                        }}
                        onClick={() => {
                          setOpenFeedback(true);
                        }}
                      >
                        Feedback
                      </Button>
                    </Typography>
                    <Typography>
                      <Select
                        sx={{
                          ...poppins500,
                          fontSize: '12px',
                          color: '#6C2AD2',
                          border: '1px solid #6C2AD2',
                          marginLeft: '10px',
                          height: '30px',
                          background: '#FFFFFF',
                          boxShadow: '0px 1px 4px rgba(0, 0, 0, 0.15)',
                          borderRadius: '5px',
                          '& .MuiOutlinedInput-notchedOutline': {
                            border: 'none',
                          },
                        }}
                        size="small"
                        value="10"
                        style={{
                          padding: '0px 2px',
                        }}
                        onChange={() => {}}
                        displayEmpty
                        inputProps={{ 'aria-label': 'Without label' }}
                      >
                        <MenuItem value={10}>Action</MenuItem>
                        <MenuItem value={20}>Twenty</MenuItem>
                        <MenuItem value={30}>Thirty</MenuItem>
                      </Select>
                    </Typography>
                  </Typography>
                </Grid>
              )}
            </Box>
          )}

          {matchessm && ownerDetailNavigation == 'Activity' && (
            <Box sx={{ padding: '0px 10px' }}>
              <Box
                sx={{
                  width: matchessm ? '100%' : 'auto',
                  height: '110px',
                  position: 'relative',
                }}
              >
                <Stack
                  sx={{
                    width: matchessm ? '100%' : '327px',
                    height: '67px',
                    marginTop: '20px',
                    borderRadius: '10px',
                    background: `linear-gradient(180deg, rgba(108, 42, 210, 0.5) 0%, rgba(117, 184, 247, 0.5) 100%)`,
                  }}
                  justifyContent={'center'}
                  alignItems={'center'}
                  display={'-webkit-inline-flex'}
                >
                  {profileDetails?.OwnerDetails?.user?.userProfile == '' ||
                  profileDetails?.OwnerDetails?.user?.userProfile == null ? (
                    <Avatar
                      style={{
                        height: '91px',
                        width: '91px',
                        fontFamily: 'poppins',
                        marginTop: '60px',
                        backgroundColor: '#666666',
                        border: '4px solid #FFFFFF',
                        fontSize: '40px',
                      }}
                    >
                      {`${
                        profileDetails?.OwnerDetails?.user?.userName?.[0] || ''
                      }${
                        profileDetails?.OwnerDetails?.user?.userSurName?.[0] ||
                        ''
                      }`.toUpperCase()}
                    </Avatar>
                  ) : (
                    <Avatar
                      style={{
                        height: '91px',
                        width: '91px',
                        border: '4px solid #FFFFFF',
                        marginTop: '60px',
                      }}
                      src={profileDetails?.OwnerDetails?.user?.userProfile}
                    />
                  )}
                </Stack>
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'center',
                  alignItems: 'center',
                  padding: '0px',
                  gap: '13px',
                  width: matchessm ? '100%' : '335px',
                  height: '30px',
                  marginTop: '30px',
                }}
              >
                <Typography
                  sx={{ ...poppins600, fontSize: '20px', color: '#000000' }}
                >
                  {profileDetails?.OwnerDetails?.user?.userName}
                </Typography>
                <Box>
                  <Avatar
                    alt=""
                    src={BlueTick}
                    sx={{ height: '16px', width: '16px' }}
                  />
                </Box>
                <Box>
                  <Avatar
                    alt=""
                    src={Monetize}
                    sx={{ height: '16px', width: '16px' }}
                  />
                </Box>
              </Box>
              <ExpandedBuyersCard
                ownercardprop
                buyerId={buyerId}
                isHidden={true}
                setShow={setShow}
                show={show}
                action={action}
                setAction={setAction}
                handleOptionChange={handleOptionChange}
                showowner={show}
                rowData={rowData}
                marketShow={marketShow}
                isSmall={isSm}
                buyerpropertylist={buyerpropertylist}
                proid={proid}
                setProid={setProid}
                activitywidth={activitywidth}
                userEmail={profileDetails?.OwnerDetails?.userEmail}
                userType={userType}
                proUniqueId={proUniqueId}
                setProUniqueId={setProUniqueId}
                setExpand={setExpand}
                expand={expand}
                setOpendialog={setOpendialog}
                opendialog={opendialog}
                setOpenbuyermatch={setOpenbuyermatch}
                openbuyermatch={openbuyermatch}
                shrink={shrink}
                handleClosePopover={handleClosePopover}
                ownercardpopover={true}
                selectedPaAddressTwo={selectedPaAddressTwo}
                setSelectedPaAddressTwo={setSelectedPaAddressTwo}
                username={profileDetails?.OwnerDetails?.user}
                handleBlueline={handleBlueline}
                pipelineCat={pipelineCat}
                isPipelineCat={isPipelineCat}
                setIsPipelineCat={setIsPipelineCat}
                setPipelineCat={setPipelineCat}
                Propertylist={Propertylist}
                pipelineId={pipelineId}
                setPipelineId={setPipelineId}
                isAppraisal={isAppraisal}
                setIsAppraisal={setIsAppraisal}
                fromSearch={fromSearch}
                catSelected={catSelected}
                noteSelected={noteSelected}
                taskId={taskId}
                taskBinderId={taskBinderId}
                onOpenAutomatedStage={onOpenAutomatedStage}
                onOpenIncompleteDetails={onOpenIncompleteDetails}
                refreshPipeline={refreshPipeline}
                isPipelineManagement={isPipelineManagement}
              />
            </Box>
          )}
          {matchessm &&
            ownerDetailNavigation == 'Offers' &&
            !propertySelected && (
              <Box sx={{ padding: '0px 10px' }}>
                <Box
                  sx={{
                    width: matchessm ? '100%' : 'auto',
                    height: '110px',
                    position: 'relative',
                  }}
                >
                  <Stack
                    sx={{
                      width: matchessm ? '100%' : '327px',
                      height: '67px',
                      marginTop: '20px',
                      borderRadius: '10px',
                      background: `linear-gradient(180deg, rgba(108, 42, 210, 0.5) 0%, rgba(117, 184, 247, 0.5) 100%)`,
                    }}
                    justifyContent={'center'}
                    alignItems={'center'}
                    display={'-webkit-inline-flex'}
                  >
                    {profileDetails?.OwnerDetails?.user?.userProfile == '' ||
                    profileDetails?.OwnerDetails?.user?.userProfile == null ? (
                      <Avatar
                        style={{
                          height: '91px',
                          width: '91px',
                          fontFamily: 'poppins',
                          marginTop: '60px',
                          backgroundColor: '#666666',
                          fontSize: '40px',
                          border: '4px solid #FFFFFF',
                        }}
                      >
                        {profileDetails?.OwnerDetails?.user?.userName.charAt(
                          0
                        ) +
                          profileDetails?.OwnerDetails?.user?.userSurName.charAt(
                            0
                          )}
                      </Avatar>
                    ) : (
                      <Avatar
                        style={{
                          height: '91px',
                          width: '91px',
                          border: '4px solid #FFFFFF',
                          marginTop: '60px',
                        }}
                        src={profileDetails?.OwnerDetails?.user?.userProfile}
                      />
                    )}
                  </Stack>
                </Box>
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'center',
                    alignItems: 'center',
                    padding: '0px',
                    gap: '13px',
                    width: matchessm ? '100%' : '335px',
                    height: '30px',
                    marginTop: '30px',
                  }}
                >
                  <Typography
                    sx={{ ...poppins600, fontSize: '20px', color: '#000000' }}
                  >
                    {profileDetails?.OwnerDetails?.user?.userName}
                  </Typography>
                  <Box>
                    <Avatar
                      alt=""
                      src={BlueTick}
                      sx={{ height: '16px', width: '16px' }}
                    />
                  </Box>
                  <Box>
                    <Avatar
                      alt=""
                      src={Monetize}
                      sx={{ height: '16px', width: '16px' }}
                    />
                  </Box>
                </Box>
                <Typography
                  sx={{
                    fontFamily: 'Poppins !important',
                    fontStyle: 'normal !important',
                    fontWeight: '400 !important',
                    fontSize: '16px',
                    color: '#585858',
                    width: '100%',
                    display: 'block',
                    textAlign: 'center',
                  }}
                >
                  Property Ownership
                </Typography>

                <Tabs
                  style={{
                    color: 'purpleHeart',
                    borderBottom: 'purpleheart',
                    paddingLeft: '22px',
                    display: 'false',
                  }}
                  value={value}
                  onChange={handleChange}
                  // aria-label=" tabs example"
                  variant="fullWidth"
                  aria-label="full width tabs example"
                  sx={{
                    // border:"1px solid yellow",
                    '& .MuiTabs-indicator': {
                      backgroundColor: '#6C2AD2',
                      marginBottom: '5px',
                    },
                    '& .MuiTab-root.Mui-selected': {
                      color: '#6C2AD2',
                      fontWeight: '500',
                    },
                  }}
                >
                  <Tab
                    label="All"
                    {...a11yProps(0)}
                    sx={{
                      fontFamily: 'Poppins !important',
                      fontStyle: 'normal !important',
                      fontWeight: '400 !important',
                      fontSize: '12px',
                      textTransform: 'capitalize',
                    }}
                  />

                  <Tab
                    label="Appraisals"
                    {...a11yProps(1)}
                    sx={{
                      fontFamily: 'Poppins !important',
                      fontStyle: 'normal !important',
                      fontWeight: '400 !important',
                      fontSize: '12px',
                      // color: "#9A9A9F",
                      textTransform: 'none',
                    }}
                  />

                  <Tab
                    label="Inactive"
                    {...a11yProps(2)}
                    sx={{
                      fontFamily: 'Poppins !important',
                      fontStyle: 'normal !important',
                      fontWeight: '400 !important',
                      fontSize: '12px',
                      // color: "#585858",
                      textTransform: 'none',
                    }}
                  />
                </Tabs>
                <TabPanel value={value} index={0} width="340px">
                  <All
                    scrollToTopContainer={scrollToTopContainer}
                    setPropertySeletedDetail={setPropertySeletedDetail}
                    setPropertySelected={setPropertySelected}
                    buyerId={buyerId}
                    index={0}
                    buyerpropertylist={buyerpropertylist}
                    proid={proid}
                    setProid={setProid}
                    proUniqueId={proUniqueId}
                    setProUniqueId={setProUniqueId}
                    handleChangePaAddressTwo={handleChangePaAddressTwo}
                    popover={true}
                    handleExpandClose={handleExpandClose}
                    selectedPaBlue={selectedPaBlue}
                    setSelectedPaBlue={setSelectedPaBlue}
                    isPipelineManagement={isPipelineManagement}
                  />
                </TabPanel>
                <TabPanel value={value} index={1} width="340px">
                  <All
                    scrollToTopContainer={scrollToTopContainer}
                    setPropertySeletedDetail={setPropertySeletedDetail}
                    setPropertySelected={setPropertySelected}
                    buyerId={buyerId}
                    index={1}
                    buyerpropertylist={buyerpropertylist}
                    proid={proid}
                    setProid={setProid}
                    proUniqueId={proUniqueId}
                    setProUniqueId={setProUniqueId}
                    handleChangePaAddressTwo={handleChangePaAddressTwo}
                    popover={true}
                    handleExpandClose={handleExpandClose}
                    selectedPaBlue={selectedPaBlue}
                    setSelectedPaBlue={setSelectedPaBlue}
                    isPipelineManagement={isPipelineManagement}
                  />
                </TabPanel>
                <TabPanel value={value} index={2} width="340px">
                  <All
                    scrollToTopContainer={scrollToTopContainer}
                    setPropertySeletedDetail={setPropertySeletedDetail}
                    setPropertySelected={setPropertySelected}
                    buyerId={buyerId}
                    index={2}
                    buyerpropertylist={buyerpropertylist}
                    proid={proid}
                    setProid={setProid}
                    proUniqueId={proUniqueId}
                    setProUniqueId={setProUniqueId}
                    handleChangePaAddressTwo={handleChangePaAddressTwo}
                    popover={true}
                    handleExpandClose={handleExpandClose}
                    selectedPaBlue={selectedPaBlue}
                    setSelectedPaBlue={setSelectedPaBlue}
                    isPipelineManagement={isPipelineManagement}
                  />
                </TabPanel>
              </Box>
            )}

          {matchessm &&
            ownerDetailNavigation == 'Offers' &&
            propertySelected && (
              <Box sx={{ padding: '0px 10px' }}>
                <Box
                  sx={{
                    width: matchessm ? '100%' : 'auto',
                    height: '110px',
                    position: 'relative',
                  }}
                >
                  <Stack
                    sx={{
                      width: matchessm ? '100%' : '327px',
                      height: '67px',
                      marginTop: '20px',
                      borderRadius: '10px',
                      background: `linear-gradient(180deg, rgba(108, 42, 210, 0.5) 0%, rgba(117, 184, 247, 0.5) 100%)`,
                    }}
                    justifyContent={'center'}
                    alignItems={'center'}
                    display={'-webkit-inline-flex'}
                  >
                    {profileDetails?.OwnerDetails?.user?.userProfile == '' ||
                    profileDetails?.OwnerDetails?.user?.userProfile == null ? (
                      <Avatar
                        style={{
                          height: '91px',
                          width: '91px',
                          fontFamily: 'poppins',
                          marginTop: '60px',
                          backgroundColor: '#666666',
                          fontSize: '40px',
                          border: '4px solid #FFFFFF',
                        }}
                      >
                        {profileDetails?.OwnerDetails?.user?.userName.charAt(
                          0
                        ) +
                          profileDetails?.OwnerDetails?.user?.userSurName.charAt(
                            0
                          )}
                      </Avatar>
                    ) : (
                      <Avatar
                        style={{
                          height: '91px',
                          width: '91px',
                          border: '4px solid #FFFFFF',
                          marginTop: '60px',
                        }}
                        src={profileDetails?.OwnerDetails?.user?.userProfile}
                      />
                    )}
                  </Stack>
                </Box>
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'center',
                    alignItems: 'center',
                    padding: '0px',
                    gap: '13px',
                    width: matchessm ? '100%' : '335px',
                    height: '30px',
                    marginTop: '30px',
                  }}
                >
                  <Typography
                    sx={{ ...poppins600, fontSize: '20px', color: '#000000' }}
                  >
                    {profileDetails?.OwnerDetails?.user?.userName}
                  </Typography>
                  <Box>
                    <Avatar
                      alt=""
                      src={BlueTick}
                      sx={{ height: '16px', width: '16px' }}
                    />
                  </Box>
                  <Box>
                    <Avatar
                      alt=""
                      src={Monetize}
                      sx={{ height: '16px', width: '16px' }}
                    />
                  </Box>
                </Box>
                <Stack
                  direction={'row'}
                  alignItems={'center'}
                  sx={{
                    cursor: 'pointer',
                    marginTop: '20px',
                  }}
                >
                  <BackLeftArrow />
                  <Typography
                    sx={{
                      ...poppins400,
                      fontSize: '14px',
                      color: '#6C2AD2',
                      marginLeft: '10px',
                    }}
                    onClick={() => {
                      setOwnerDetailNavigation('Offers');
                      setPropertySelected(false);
                      setPropertySeletedDetail({});
                    }}
                  >
                    Back to List
                  </Typography>
                </Stack>
                <Card
                  sx={{
                    minHeight: '138px',
                    border: '0',
                    padding: '0px',
                    boxShadow: 'rgba(0, 0, 0, 0.15)',
                    marginTop: '10px',
                    width: matchessm ? '100%' : '400px',
                    marginLeft: matchessm ? '0px' : '30px',
                  }}
                >
                  <Stack direction={'row'}>
                    <Box
                      sx={{
                        minHeight: '138px',
                        width: '8px',
                        background: '#6C2AD2',
                        borderRadius: '8px 0 0 8px',
                      }}
                    ></Box>
                    <Grid
                      container
                      direction={matchessm ? 'row' : 'row'}
                      gap={matchessm && '5px'}
                      sx={{
                        alignItems: 'center',
                        padding: '10px',
                        background: ' #FAF8F8',
                        borderRadius: '0px 8px 8px 0px',
                        flexWrap: 'nowrap',
                        display: 'flex',
                        justifyContent: 'flex-start',
                        cursor: 'pointer',
                        // border:"2px solid red"
                      }}
                    >
                      <Grid item sx={{ width: '40vw' }}>
                        <Stack spacing={2}>
                          <img
                            src={
                              propertySelectedDetail?.propertyMedia[2]
                                ?.propertyMedia
                            }
                            // src={item?.propertyMedia[2]?.propertyMedia || PlaceholderImage}
                            alt="Images"
                            height={'125px'}
                            width={'133px'}
                            style={{ borderRadius: '6px' }}
                          />
                          <Button
                            variant="text"
                            sx={{
                              border: '1px solid #9A9A9F',
                              fontFamily: 'Poppins !important',
                              fontStyle: 'normal !important',
                              fontWeight: '400 !important',
                              borderRadius: '5px',
                              fontSize: '12px',
                              textTransform: 'capitalize',
                              color: '#9A9A9F',
                              width: '130px',
                              height: '30px',
                            }}
                          >
                            {propertySelectedDetail?.property?.status}
                          </Button>
                        </Stack>
                      </Grid>

                      <Grid item sx={{ width: '40vw' }}>
                        <Stack
                          direction={'column'}
                          sx={{
                            minHeight: '173px',
                            display: 'flex',
                            justifyContent: 'space-between',
                          }}
                        >
                          <Stack direction={'row'} spacing={2}>
                            <Stack
                              direction={'row'}
                              spacing={1}
                              alignItems={'center'}
                            >
                              <BedIcon />
                              <Typography
                                sx={{
                                  fontFamily: 'Poppins !important',
                                  fontStyle: 'normal !important',
                                  fontWeight: '400 !important',
                                  fontSize: '12px',
                                  color: '#000000',
                                }}
                              >
                                {
                                  propertySelectedDetail?.propertyOtherDetails
                                    ?.bedRoomCount
                                }
                              </Typography>
                            </Stack>
                            <Stack
                              direction={'row'}
                              spacing={1}
                              alignItems={'center'}
                            >
                              <ShowerIcon />
                              <Typography
                                sx={{
                                  fontFamily: 'Poppins !important',
                                  fontStyle: 'normal !important',
                                  fontWeight: '400 !important',
                                  fontSize: '12px',
                                  color: '#000000',
                                }}
                              >
                                {
                                  propertySelectedDetail?.propertyOtherDetails
                                    ?.bathRoomCount
                                }
                              </Typography>
                            </Stack>
                            <Stack
                              direction={'row'}
                              spacing={1}
                              alignItems={'center'}
                            >
                              <CarIcon />
                              <Typography
                                sx={{
                                  fontFamily: 'Poppins !important',
                                  fontStyle: 'normal !important',
                                  fontWeight: '400 !important',
                                  fontSize: '12px',
                                  color: '#000000',
                                }}
                              >
                                {
                                  propertySelectedDetail?.propertyOtherDetails
                                    ?.otherCarParking
                                }
                              </Typography>
                            </Stack>
                          </Stack>
                          <Typography
                            sx={{
                              fontFamily: 'Poppins !important',
                              fontStyle: 'normal !important',
                              fontWeight: '400 !important',
                              fontSize: '10px',
                              color: '#666666',
                            }}
                          >
                            {
                              propertySelectedDetail?.propertyAddress
                                ?.streetName
                            }
                          </Typography>
                          <Stack direction={'row'} spacing={'1'}>
                            <Stack direction={'row'} spacing={'1'}>
                              <Typography
                                sx={{
                                  fontFamily: 'Poppins !important',
                                  fontStyle: 'normal !important',
                                  fontWeight: '400 !important',
                                  fontSize: '10px',
                                  color: '#666666',
                                }}
                              >
                                Last Sold: &nbsp;
                              </Typography>
                            </Stack>
                            <Stack direction={'row'} spacing={'1'}>
                              {propertySelectedDetail?.property?.soldDate !=
                                null && (
                                <Typography
                                  sx={{
                                    fontFamily: 'Poppins !important',
                                    fontStyle: 'normal !important',
                                    fontWeight: '500 !important',
                                    fontSize: '10px',
                                    color: '#000000',
                                  }}
                                >
                                  {moment(
                                    propertySelectedDetail?.property?.soldDate
                                  ).format('DD-MM-YYYY')}
                                </Typography>
                              )}
                            </Stack>
                          </Stack>
                          <Stack direction={'row'} spacing={'1'}>
                            <Stack>
                              <Typography
                                sx={{
                                  fontFamily: 'Poppins !important',
                                  fontStyle: 'normal !important',
                                  fontWeight: '400 !important',
                                  fontSize: '10px',
                                  color: '#666666',
                                }}
                              >
                                Price: &nbsp;
                              </Typography>
                            </Stack>
                            <Stack>
                              {propertySelectedDetail?.property?.soldPrice !=
                                null && (
                                <Typography
                                  sx={{
                                    fontFamily: 'Poppins !important',
                                    fontStyle: 'normal !important',
                                    fontWeight: '500 !important',
                                    fontSize: '10px',
                                    color: '#000000',
                                  }}
                                >
                                  {/* {`$${numberWithCommas(propertySelectedDetail?.property?.soldPrice)}`} */}
                                </Typography>
                              )}
                            </Stack>
                          </Stack>
                          <FormControl
                            sx={{
                              border: '1px solid #6C2AD2',
                              background: '#FFFFFF',
                              borderRadius: '5px',
                              marginTop: '15px',
                              fontFamily: 'Poppins !important',
                              fontStyle: 'normal !important',
                              fontWeight: '500 !important',
                              fontSize: '12px',
                              width: '140px',
                            }}
                            size="small"
                          >
                            <Select
                              sx={{
                                ...poppins500,
                                fontSize: '12px',
                                color: '#6C2AD2',
                                border: '1px solid #6C2AD2',
                                borderRadius: ' 5px',
                                height: '32px',
                                width: '140px',
                                background: '#FFFFFF',
                                boxShadow: '0px 1px 4px rgba(0, 0, 0, 0.15)',
                                '& .MuiOutlinedInput-notchedOutline': {
                                  border: 'none',
                                },
                              }}
                              size="small"
                              value="10"
                              style={{
                                padding: '0px 2px',
                              }}
                              onChange={() => {}}
                              displayEmpty
                              inputProps={{ 'aria-label': 'Without label' }}
                            >
                              <MenuItem value={10}>Action</MenuItem>
                              <MenuItem value={20}>Twenty</MenuItem>
                              <MenuItem value={30}>Thirty</MenuItem>
                            </Select>
                          </FormControl>
                        </Stack>
                      </Grid>
                    </Grid>
                  </Stack>
                </Card>
                <ExpandedBuyersCard
                  ownercardprop
                  buyerId={buyerId}
                  isHidden={true}
                  setShow={setShow}
                  show={show}
                  action={action}
                  setAction={setAction}
                  handleOptionChange={handleOptionChange}
                  showowner={show}
                  rowData={rowData}
                  marketShow={marketShow}
                  isSmall={isSm}
                  buyerpropertylist={buyerpropertylist}
                  proid={proid}
                  setProid={setProid}
                  activitywidth={activitywidth}
                  userEmail={profileDetails?.OwnerDetails?.userEmail}
                  userType={userType}
                  proUniqueId={proUniqueId}
                  setProUniqueId={setProUniqueId}
                  setExpand={setExpand}
                  expand={expand}
                  setOpendialog={setOpendialog}
                  opendialog={opendialog}
                  setOpenbuyermatch={setOpenbuyermatch}
                  openbuyermatch={openbuyermatch}
                  shrink={shrink}
                  handleClosePopover={handleClosePopover}
                  ownercardpopover={true}
                  selectedPaAddressTwo={selectedPaAddressTwo}
                  setSelectedPaAddressTwo={setSelectedPaAddressTwo}
                  username={profileDetails?.OwnerDetails?.user}
                  handleBlueline={handleBlueline}
                  isPipelineCat={isPipelineCat}
                  pipelineCat={pipelineCat}
                  setIsPipelineCat={setIsPipelineCat}
                  setPipelineCat={setPipelineCat}
                  Propertylist={Propertylist}
                  pipelineId={pipelineId}
                  setPipelineId={setPipelineId}
                  isAppraisal={isAppraisal}
                  setIsAppraisal={setIsAppraisal}
                  fromSearch={fromSearch}
                  catSelected={catSelected}
                  noteSelected={noteSelected}
                  taskId={taskId}
                  taskBinderId={taskBinderId}
                  onOpenAutomatedStage={onOpenAutomatedStage}
                  onOpenIncompleteDetails={onOpenIncompleteDetails}
                  refreshPipeline={refreshPipeline}
                  isPipelineManagement={isPipelineManagement}
                />
              </Box>
            )}

          {/* {matches870 && <Box sx={{mt:"20px", ml:"25px", mb:"-56px", zIndex:9999, width:"50px"}}  onClick={handleLeftArrowClick} ><ExpandIcon/></Box>} */}
          {/* {matches870 &&
          <>
          <Popover
        id={popoverId}
        open={isPopoverOpen}
        anchorEl={anchorpopoverEl}
        onClose={handleClosePopover}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        PaperProps={{
          style: {
            height: matches700 ? "81%" : '90%',
            minWidth: matches450?'100%':'100vw',
            marginTop:"123px",
            },
            sx: {
              right: 0,
              bottom:"unset !important",
              left:"unset !important",
              top:"unset !important",
              paddingBottom: 'calc(100px + 1em)',
            }
        }}
      >
        <Grid>
        <Box sx={{mt:"20px", ml:"25px", mb:"-56px", width:"50px"}} onClick={handleExpandClick}>
                                      <img
                                        src={Listhome}
                                        alt="ListhomeImg"
                                        height={"30px"}
                                        width={"31px"}
                                        style={{ borderRadius: "6px" }}
                                      /></Box>
        <ExpandedBuyersCard
                ownercardprop
                buyerId={buyerId}
                isHidden={true}
                setShow={setShow}
                show={show}
                action={action}
                setAction={setAction}
                handleOptionChange={handleOptionChange}
                showowner={show}
                rowData={rowData}
                marketShow={marketShow}
                isSmall={isSm}
                buyerpropertylist={buyerpropertylist}
                proid={proid}
                setProid={setProid}
                activitywidth={activitywidth}
                userEmail={profileDetails?.OwnerDetails?.userEmail}
                userType={userType}
                proUniqueId={proUniqueId}
                setProUniqueId={setProUniqueId}
                setExpand={setExpand}
                expand={expand}
                setOpendialog={setOpendialog}
                opendialog={opendialog}
                setOpenbuyermatch={setOpenbuyermatch}
                openbuyermatch={openbuyermatch}
                shrink={shrink}
                handleClosePopover={handleClosePopover}
                ownercardpopover={true}
                selectedPaAddressTwo={selectedPaAddressTwo}
                setSelectedPaAddressTwo={setSelectedPaAddressTwo}
                username={profileDetails?.OwnerDetails?.user}
                handleBlueline={handleBlueline}
              />
              </Grid>
        </Popover>
          <Popover
          id={popoverExpandId}
          open={openExpand}
          anchorEl={anchorExpandEl}
          onClose={handleExpandClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
          PaperProps={{
            style: {
              height: matches700 ? "81%" : '90%',
              minWidth: matches450?'100%':'100vw',
              marginTop:"123px",
              },
              sx: {
                right: 0,
                bottom:"unset !important",
                left:"unset !important",
                top:"unset !important",
                paddingBottom: 'calc(100px + 1em)',
              }
          }}
        >
          <Grid
                      item
                      display={"flex"}
                      justifyContent={"right"}
                      flexDirection={"column"}
                      alignItems={"center"}
                      width={"100%"}
                      right={0}
                      >
                      <Grid onClick={handleExpandClose} style={{ marginLeft: matches450 ?"90%" : 'auto', marginRight:"40px" }}>
                         <IconButton>
                   <RightArrow />
                  </IconButton>
                  </Grid>
                        <Typography
                          sx={{
                            fontFamily: "Poppins !important",
                            fontStyle: "normal !important",
                            fontWeight: "400 !important",
                            fontSize: "16px",
                            color: "#585858",
                            width:'100%',
                            display:'block',
                            textAlign:'center'
                          }}
                        >
                          Property Ownership
                        </Typography>
  
                        <Tabs
                          style={{
                            color: "purpleHeart",
                            borderBottom: "purpleheart",
                            paddingLeft:'22px',
                            display: "false",
                          }}
                          value={value}
                          onChange={handleChange}
                          // aria-label=" tabs example"
                          variant="fullWidth"
                          aria-label="full width tabs example"
                          sx={{
                            "& .MuiTabs-indicator": {
                              backgroundColor: "#6C2AD2",
                              marginBottom: "5px",
                            },
                            "& .MuiTab-root.Mui-selected": {
                              color: "#6C2AD2",
                              fontWeight: "500",
                            },
                          }}
                        >
                          <Tab
                            label="All"
                            {...a11yProps(0)}
                            sx={{
                              fontFamily: "Poppins !important",
                              fontStyle: "normal !important",
                              fontWeight: "400 !important",
                              fontSize: "12px",
                              textTransform: "capitalize",
                            }}
                          />
  
                          <Tab
                            label="Appraisals"
                            {...a11yProps(1)}
                            sx={{
                              fontFamily: "Poppins !important",
                              fontStyle: "normal !important",
                              fontWeight: "400 !important",
                              fontSize: "12px",
                              // color: "#9A9A9F",
                              textTransform: "none",
                            }}
                          />
  
                          <Tab
                            label="Inactive"
                            {...a11yProps(2)}
                            sx={{
                              fontFamily: "Poppins !important",
                              fontStyle: "normal !important",
                              fontWeight: "400 !important",
                              fontSize: "12px",
                              // color: "#585858",
                              textTransform: "none",
                            }}
                          />
                        </Tabs>
                        <TabPanel value={value} index={0} width="340px">
                          <All buyerId={buyerId} index={0} buyerpropertylist={buyerpropertylist} proid={proid} setProid={setProid} proUniqueId={proUniqueId}
          setProUniqueId={setProUniqueId} handleChangePaAddressTwo={handleChangePaAddressTwo} popover={true} handleExpandClose={handleExpandClose} selectedPaBlue={selectedPaBlue} setSelectedPaBlue={setSelectedPaBlue}/>
                        </TabPanel>
                        <TabPanel value={value} index={1} width="340px">
                          <All buyerId={buyerId} index={1} buyerpropertylist={buyerpropertylist} proid={proid} setProid={setProid} proUniqueId={proUniqueId}
          setProUniqueId={setProUniqueId} handleChangePaAddressTwo={handleChangePaAddressTwo} popover={true} handleExpandClose={handleExpandClose} selectedPaBlue={selectedPaBlue} setSelectedPaBlue={setSelectedPaBlue}/>
                        </TabPanel>
                        <TabPanel value={value} index={2} width="340px">
                          <All buyerId={buyerId} index={2} buyerpropertylist={buyerpropertylist} proid={proid} setProid={setProid} proUniqueId={proUniqueId}
          setProUniqueId={setProUniqueId} handleChangePaAddressTwo={handleChangePaAddressTwo} popover={true} handleExpandClose={handleExpandClose} selectedPaBlue={selectedPaBlue} setSelectedPaBlue={setSelectedPaBlue}/>
                        </TabPanel>
                     </Grid>
                </Popover>
                </>
                } */}

          <Grid
            style={{
              display: 'flex',
              flexDirection: expand && show && shrink ? 'column' : 'row',
            }}
          >
            {expand && show && shrink && !matchessm ? (
              <>
                <Grid
                  item
                  container
                  sx={{
                    width: '367px',
                    bgcolor: '#FFFFFF',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    overflowY: 'scroll',
                    '-webkit-scrollbar': {
                      display: 'none',
                    },
                    '-ms-overflow-style': 'none',
                    'scrollbar-width': 'none',
                  }}
                >
                  <Grid
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      marginTop: '10px',
                    }}
                  >
                    <OwnerCardProfile
                      setProfileDetails={setProfileDetails}
                      showBackdrop={showBackdrop}
                      setSelectedBuyers={setSelectedBuyers}
                      setSelectedBuyerId={setSelectedBuyerId}
                      openOwner={openOwner}
                      setOpenOwner={setOpenOwner}
                      buyerId={buyerId}
                      selectedBuyers={selectedBuyers}
                      open={open}
                      setOpen={setOpen}
                      userType={userType}
                      setExpand={setExpand}
                      expand={expand}
                      data={profileDetails?.OwnerDetails}
                      action={action}
                      handleOptionChange={handleOptionChange}
                      fromSearch={fromSearch}
                      catSelected={catSelected}
                      noteSelected={noteSelected}
                      taskId={taskId}
                      taskBinderId={taskBinderId}
                      buyerpropertylist={buyerpropertylist}
                      loading={loading}
                      profileDetails={profileDetails}
                    />
                    {!expand && (
                      <Grid
                        item
                        xs={12}
                        sx={{ width: '340px', margin: '10px 9px' }}
                      >
                        <Stack
                          sx={{
                            padding: '15px',
                            margin: '5px',
                            border: '1px solid #E7E5E5',
                            borderRadius: '10px',
                            width: '100%',
                          }}
                        >
                          <Stack
                            sx={{
                              width: '100%',
                              height: '38px',
                              background: '#F7F8F7',
                            }}
                            alignItems={'start'}
                            justifyContent={'center'}
                          >
                            <Typography
                              sx={{
                                textAlign: 'center',
                                ...poppins500,
                                fontSize: '14px',
                                color: '#26344E',
                                paddingLeft: '10px',
                              }}
                            >
                              Property Ownership
                            </Typography>
                          </Stack>

                          {Array.isArray(
                            profileDetails?.OwnerDetails?.propertyDetails
                          ) &&
                            profileDetails.OwnerDetails.propertyDetails.map(
                              (property, index) => {
                                const formattedSoldDate = moment(
                                  property?.property?.soldDate
                                ).format('DD-MM-YYYY');
                                const numberWithCommas = (x) => {
                                  return x
                                    .toString()
                                    .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                                };
                                return (
                                  <Card
                                    key={index}
                                    sx={{
                                      padding: '10px',
                                      marginTop: '10px',
                                      minHeight: '205px',
                                      width: '297px',
                                      background: ' #FFFFFF',
                                      boxShadow:
                                        '0px 1px 4px rgba(0, 0, 0, 0.15)',
                                      borderRadius: '6px',
                                    }}
                                  >
                                    <Grid container spacing={2}>
                                      <Grid item xs={6}>
                                        <Stack spacing={2}>
                                          {property?.propertyMedia[2]
                                            ?.propertyMedia ? (
                                            <img
                                              src={
                                                property?.propertyMedia[2]
                                                  ?.propertyMedia
                                              }
                                              alt="Images"
                                              height={'125px'}
                                              width={'100%'}
                                              style={{ borderRadius: '6px' }}
                                            />
                                          ) : (
                                            <img
                                              src={PlaceholderImage}
                                              alt="Five cats looking around a field."
                                              height={'125px'}
                                              width={'100%'}
                                              style={{ borderRadius: '6px' }}
                                            />
                                          )}
                                          <Button
                                            variant="text"
                                            sx={{
                                              border: '1px solid #9A9A9F',
                                              ...poppins400,
                                              fontSize: '12px',
                                              color: '#9A9A9F',
                                              borderRadius: '5px',
                                              textTransform: 'capitalize',
                                              height: '30px',
                                            }}
                                          >
                                            {property?.property?.status}
                                          </Button>
                                        </Stack>
                                      </Grid>

                                      <Grid item xs={6}>
                                        <Stack
                                          direction={'column'}
                                          spacing={2}
                                          sx={{
                                            minHeight: '170px',
                                            display: 'flex',
                                            justifyContent: 'flex-end',
                                          }}
                                        >
                                          <Stack direction={'row'} spacing={1}>
                                            <Stack
                                              direction={'row'}
                                              spacing={1}
                                              alignItems={'center'}
                                            >
                                              <BedIcon />
                                              <Typography
                                                sx={{
                                                  ...poppins400,
                                                  fontSize: '12px',
                                                  color: '#000000',
                                                }}
                                              >
                                                {
                                                  property?.propertyOtherDetails
                                                    ?.bedRoomCount
                                                }
                                              </Typography>
                                            </Stack>
                                            <Stack
                                              direction={'row'}
                                              spacing={1}
                                              alignItems={'center'}
                                            >
                                              <ShowerIcon />
                                              <Typography
                                                sx={{
                                                  ...poppins400,
                                                  fontSize: '12px',
                                                  color: '#000000',
                                                }}
                                              >
                                                {
                                                  property?.propertyOtherDetails
                                                    ?.bathRoomCount
                                                }
                                              </Typography>
                                            </Stack>
                                            <Stack
                                              direction={'row'}
                                              spacing={1}
                                              alignItems={'center'}
                                            >
                                              <CarIcon />
                                              <Typography
                                                sx={{
                                                  ...poppins400,
                                                  fontSize: '12px',
                                                  color: '#000000',
                                                }}
                                              >
                                                {
                                                  property?.propertyOtherDetails
                                                    ?.otherCarParking
                                                }
                                              </Typography>
                                            </Stack>
                                          </Stack>
                                          <Typography
                                            sx={{
                                              ...poppins400,
                                              ...fontsize10,
                                              color: ' #666666',
                                            }}
                                          >
                                            {
                                              property?.propertyAddress
                                                ?.streetName
                                            }
                                          </Typography>

                                          {property?.property?.status ==
                                            'Sold' && (
                                            <Box
                                              sx={{
                                                ...poppins400,
                                                ...fontsize12,
                                                width: '175px',
                                              }}
                                            >
                                              <Typography
                                                sx={{
                                                  ...poppins400,
                                                  ...fontsize10,
                                                  color: '#666666',
                                                }}
                                              >
                                                Last Sold: &nbsp;
                                              </Typography>
                                              {property?.property?.soldDate !=
                                                null && (
                                                <Typography
                                                  sx={{
                                                    ...poppins500,
                                                    ...fontsize10,
                                                    color: '#000000',
                                                  }}
                                                >
                                                  {formattedSoldDate}
                                                </Typography>
                                              )}
                                            </Box>
                                          )}
                                          {property?.property?.status ==
                                            'Sold' && (
                                            <Box
                                              sx={{
                                                ...poppins400,
                                                ...fontsize12,
                                                width: '175px',
                                              }}
                                            >
                                              <Typography
                                                sx={{
                                                  ...poppins400,
                                                  ...fontsize10,
                                                  color: '#666666',
                                                }}
                                              >
                                                Price : &nbsp;
                                              </Typography>
                                              {property?.property?.soldPrice !=
                                                null && (
                                                <Typography
                                                  sx={{
                                                    ...poppins500,
                                                    ...fontsize10,
                                                    color: '#000000',
                                                  }}
                                                >
                                                  {`$${numberWithCommas(
                                                    property?.property
                                                      ?.soldPrice
                                                  )}`}
                                                </Typography>
                                              )}
                                            </Box>
                                          )}

                                          <Stack>
                                            <Select
                                              id="optionlist"
                                              sx={{
                                                ...poppins500,
                                                fontSize: '12px',
                                                fontColor: '#112347',
                                                border: '1px solid #6C2AD2',
                                                width: '130px',
                                                height: '30px',
                                                borderRadius: '6px',
                                                '& .MuiOutlinedInput-notchedOutline':
                                                  {
                                                    border: 'none',
                                                  },
                                              }}
                                              value={action}
                                              label="Action"
                                              onChange={(e) => {
                                                handleOptionChange(e, property);
                                              }}
                                              displayEmpty
                                              inputProps={{
                                                'aria-label': 'Without label',
                                              }}
                                            >
                                              <MenuItem
                                                value={''}
                                                sx={{
                                                  ...poppins500,
                                                  fontSize: '12px',
                                                  color: '#112347',
                                                }}
                                              >
                                                Action
                                              </MenuItem>
                                              <MenuItem
                                                value={10}
                                                sx={{
                                                  ...poppins500,
                                                  fontSize: '12px',
                                                  color: '#112347',
                                                }}
                                              >
                                                Insights
                                              </MenuItem>
                                              <MenuItem
                                                value={20}
                                                sx={{
                                                  ...poppins500,
                                                  fontSize: '12px',
                                                  color: '#112347',
                                                }}
                                              >
                                                Buyer Match
                                              </MenuItem>
                                            </Select>
                                          </Stack>
                                        </Stack>
                                      </Grid>
                                    </Grid>
                                  </Card>
                                );
                              }
                            )}
                        </Stack>
                      </Grid>
                    )}
                    {!expand && (
                      <Box sx={{ width: '340px' }}>
                        <LiveActivityFeed
                          buyerId={buyerId}
                          agentindividual={false}
                          ownercardprop
                          proid={proid}
                          rowData={rowData}
                          expanded={expand}
                        />
                      </Box>
                    )}
                    {!expand && (
                      <Grid
                        sx={{
                          display: 'flex',
                          marginLeft: '75px',
                          padding: '20px',
                          width: '209px',
                          marginBottom: '20px',
                        }}
                      >
                        <Typography sx={displayFlex} style={{ gap: '20px' }}>
                          <Typography style={{ paddingRight: '10px' }}>
                            <Button
                              // variant="contained"
                              sx={{
                                ...poppins400,
                                fontSize: '12px',
                                color: '#6C2AD2',
                                bgcolor: 'rgba(108, 42, 210, 0.1)',
                                borderRadius: '4.05125px',
                                height: '30px',
                              }}
                            >
                              Feedback
                            </Button>
                          </Typography>
                          <Typography>
                            <Select
                              sx={{
                                ...poppins500,
                                fontSize: '12px',
                                color: '#6C2AD2',
                                border: '1px solid #6C2AD2',
                                marginLeft: '10px',
                                height: '30px',
                                background: '#FFFFFF',
                                boxShadow: '0px 1px 4px rgba(0, 0, 0, 0.15)',
                                borderRadius: '5px',
                                '& .MuiOutlinedInput-notchedOutline': {
                                  border: 'none',
                                },
                              }}
                              size="small"
                              value="10"
                              style={{
                                padding: '0px 2px',
                              }}
                              onChange={() => {}}
                              displayEmpty
                              inputProps={{ 'aria-label': 'Without label' }}
                            >
                              <MenuItem value={10}>Action</MenuItem>
                              <MenuItem value={20}>Twenty</MenuItem>
                              <MenuItem value={30}>Thirty</MenuItem>
                            </Select>
                          </Typography>
                        </Typography>
                      </Grid>
                    )}
                    {expand && (
                      <>
                        <Stack
                          sx={{
                            padding: '15px',
                            border: '1px solid #E7E5E5',
                            borderRadius: '10px',
                            marginTop: '10px',
                            width: '340px',
                            height: '218px',
                            marginLeft: '11px',
                          }}
                        >
                          <Stack
                            sx={{
                              width: '296px',
                              height: '38px',
                              background: '#F7F8F7',

                              borderRadius: '6px',

                              marginTop: '2px',
                              marginLeft: '3px',
                              marginRight: '10px',
                              padding: '8px 12px',
                            }}
                            direction="row"
                            align-items="flex-start"
                          >
                            <Typography
                              sx={{
                                textAlign: 'center',
                                fontFamily: 'Poppins !important',
                                fontStyle: 'normal !important',
                                fontWeight: '500 !important',
                                fontSize: '14px',
                                marginLeft: '15px',
                              }}
                            >
                              Activity Overview
                            </Typography>
                          </Stack>

                          <Button
                            onClick={() => {
                              setMarketShow(false);
                              setPropertyColor(
                                show === true ? '#000000' : '#6C2AD2'
                              );
                            }}
                            sx={{
                              width: '296px',
                              height: '60px',
                              borderRadius: '6px',

                              background: '#FFFFFF',
                              paddingLeft: '10px',
                              paddingRight: '50px',
                              boxShadow: '0px 1px 6px rgba(0, 0, 0, 0.15)',
                              marginTop: '10px',
                              padding: '8px 15px',
                              borderLeft: marketShow
                                ? '1px solid transparent'
                                : '5px solid #6C2AD2',
                            }}
                          >
                            <Stack>
                              <Stack
                                direction={'row'}
                                padding={'8px 15px'}
                                color={'#6C2AD2'}
                                sx={{ paddingRight: '100px' }}
                              >
                                <Home2
                                  color={
                                    marketShow !== true ? '#6C2AD2' : '#666666'
                                  }
                                />
                                <Typography
                                  sx={{
                                    fontFamily: 'Poppins !important',
                                    fontStyle: 'normal !important',
                                    fontWeight: '500 !important',
                                    fontSize: '14px',
                                    // color: "#6C2AD2",
                                    color:
                                      marketShow !== true
                                        ? '#6C2AD2'
                                        : '#666666',
                                    padding: '5px 15px',
                                    cursor: 'pointer',
                                    textTransform: 'capitalize',
                                  }}
                                >
                                  Properties
                                </Typography>
                              </Stack>
                            </Stack>
                          </Button>
                          <Button
                            onClick={() => {
                              setMarketShow(!marketShow);
                              setMarketColor(
                                marketShow === true ? '#6C2AD2' : '#666666'
                              );
                            }}
                            sx={{
                              width: '296px',
                              height: '60px',
                              borderRadius: '6px',

                              background: '#FFFFFF',
                              paddingLeft: '10px',
                              paddingRight: '10px',
                              boxShadow: '0px 1px 6px rgba(0, 0, 0, 0.15)',
                              marginTop: '10px',

                              padding: '8px 15px',
                              borderLeft: marketShow
                                ? '5px solid #6C2AD2'
                                : '1px solid transparent',
                            }}
                          >
                            <Stack>
                              <Stack
                                direction={'row'}
                                padding={'8px 15px'}
                                sx={{
                                  justifyContent: 'left',
                                  paddingRight: '115px',
                                }}
                              >
                                <MarketIcon
                                  color={
                                    marketShow == true ? '#6C2AD2' : '#666666'
                                  }
                                />
                                <Typography
                                  sx={{
                                    fontFamily: 'Poppins !important',
                                    fontStyle: 'normal !important',
                                    fontWeight: '500 !important',
                                    fontSize: '14px',
                                    color:
                                      marketShow === true
                                        ? '#6C2AD2'
                                        : '#666666',
                                    padding: '2px 15px',
                                    cursor: 'pointer',
                                    textTransform: 'capitalize',
                                  }}
                                >
                                  Market
                                </Typography>
                              </Stack>
                            </Stack>
                          </Button>
                        </Stack>
                      </>
                    )}
                    {expand && (
                      <Box
                        sx={{
                          width: '340px',
                          marginLeft: '13px',
                          marginY: '20px',
                        }}
                      >
                        <MessagingContainer
                          binders={true}
                          ContactUserCard={true}
                          userEmail={profileDetails?.OwnerDetails?.userEmail}
                          proid={proid}
                        />
                      </Box>
                    )}

                    {expand && (Small || shrink) && !matches870 && (
                      <Grid
                        item
                        sx={{ marginTop: '15px', marginLeft: '243px' }}
                      >
                        <Button
                          onClick={toggleShow}
                          sx={{
                            background: '#FFFFFF',
                            border: '1px solid #E7E5E5',
                            borderRadius: '5px',
                            color: '#6C2AD2',
                          }}
                        >
                          {buttonText}
                        </Button>
                      </Grid>
                    )}

                    {expand && (
                      <>
                        {show && !matches870 && (
                          <Grid
                            item
                            xs={2.5}
                            display={'flex'}
                            justifyContent={'flex-start'}
                            flexDirection={'column'}
                            alignItems={'center'}
                            sx={{
                              marginTop: '75px',
                              marginLeft: matches1600 ? '10px' : '20px',
                              // : isSm
                              //   ? "140px"
                              //   : expand && show && window.innerWidth < 1800
                              //   ? "140px"
                              // : matches1400 ? "none" : "20px",
                              minWidth: '364px',
                            }}
                            // sx={{ marginLeft: "32px" }}
                          >
                            <div style={{ width: '100%' }}>
                              <Typography
                                sx={{
                                  fontFamily: 'Poppins !important',
                                  fontStyle: 'normal !important',
                                  fontWeight: '400 !important',
                                  fontSize: '16px',
                                  color: '#585858',
                                  width: '100%',
                                  display: 'block',
                                  textAlign: 'center',
                                  // marginLeft: "-15px",
                                }}
                              >
                                Property Ownership
                              </Typography>

                              <Tabs
                                style={{
                                  color: 'purpleHeart',
                                  borderBottom: 'purpleheart',
                                  paddingLeft: '22px',
                                  display: 'false',
                                }}
                                value={value}
                                onChange={handleChange}
                                // aria-label=" tabs example"
                                variant="fullWidth"
                                aria-label="full width tabs example"
                                sx={{
                                  '& .MuiTabs-indicator': {
                                    backgroundColor: '#6C2AD2',
                                    marginBottom: '5px',
                                  },
                                  '& .MuiTab-root.Mui-selected': {
                                    color: '#6C2AD2',
                                    fontWeight: '500',
                                  },
                                }}
                              >
                                <Tab
                                  label="All"
                                  {...a11yProps(0)}
                                  sx={{
                                    fontFamily: 'Poppins !important',
                                    fontStyle: 'normal !important',
                                    fontWeight: '400 !important',
                                    fontSize: '12px',
                                    textTransform: 'capitalize',
                                  }}
                                />

                                <Tab
                                  label="Appraisals"
                                  {...a11yProps(1)}
                                  sx={{
                                    fontFamily: 'Poppins !important',
                                    fontStyle: 'normal !important',
                                    fontWeight: '400 !important',
                                    fontSize: '12px',
                                    // color: "#9A9A9F",
                                    textTransform: 'none',
                                  }}
                                />

                                <Tab
                                  label="Inactive"
                                  {...a11yProps(2)}
                                  sx={{
                                    fontFamily: 'Poppins !important',
                                    fontStyle: 'normal !important',
                                    fontWeight: '400 !important',
                                    fontSize: '12px',
                                    // color: "#585858",
                                    textTransform: 'none',
                                  }}
                                />
                              </Tabs>
                              <TabPanel value={value} index={0} width="340px">
                                <All
                                  scrollToTopContainer={scrollToTopContainer}
                                  setPropertySeletedDetail={
                                    setPropertySeletedDetail
                                  }
                                  setPropertySelected={setPropertySelected}
                                  buyerId={buyerId}
                                  index={0}
                                  buyerpropertylist={buyerpropertylist}
                                  proid={proid}
                                  setProid={setProid}
                                  proUniqueId={proUniqueId}
                                  setProUniqueId={setProUniqueId}
                                  handleChangePaAddressTwo={
                                    handleChangePaAddressTwo
                                  }
                                  selectedPaBlue={selectedPaBlue}
                                  setSelectedPaBlue={setSelectedPaBlue}
                                  isPipelineManagement={isPipelineManagement}
                                />
                              </TabPanel>
                              <TabPanel value={value} index={1}>
                                {/* <Appraisal /> */}
                                <All
                                  scrollToTopContainer={scrollToTopContainer}
                                  setPropertySeletedDetail={
                                    setPropertySeletedDetail
                                  }
                                  setPropertySelected={setPropertySelected}
                                  buyerId={buyerId}
                                  index={1}
                                  buyerpropertylist={buyerpropertylist}
                                  proid={proid}
                                  setProid={setProid}
                                  proUniqueId={proUniqueId}
                                  setProUniqueId={setProUniqueId}
                                  handleChangePaAddressTwo={
                                    handleChangePaAddressTwo
                                  }
                                  selectedPaBlue={selectedPaBlue}
                                  setSelectedPaBlue={setSelectedPaBlue}
                                  isPipelineManagement={isPipelineManagement}
                                />
                              </TabPanel>
                              <TabPanel value={value} index={2}>
                                {/* <Inspected /> */}
                                <All
                                  scrollToTopContainer={scrollToTopContainer}
                                  setPropertySeletedDetail={
                                    setPropertySeletedDetail
                                  }
                                  setPropertySelected={setPropertySelected}
                                  buyerId={buyerId}
                                  index={2}
                                  buyerpropertylist={buyerpropertylist}
                                  proid={proid}
                                  setProid={setProid}
                                  proUniqueId={proUniqueId}
                                  setProUniqueId={setProUniqueId}
                                  handleChangePaAddressTwo={
                                    handleChangePaAddressTwo
                                  }
                                  selectedPaBlue={selectedPaBlue}
                                  setSelectedPaBlue={setSelectedPaBlue}
                                  isPipelineManagement={isPipelineManagement}
                                />
                              </TabPanel>
                            </div>
                          </Grid>
                        )}
                      </>
                    )}
                  </Grid>
                </Grid>
              </>
            ) : (
              <>
                {showGrid && !matchessm && (
                  <Grid
                    item
                    container
                    sx={{
                      width: matches450 ? '100%' : '364px',
                      // height: "1655px",
                      // Top: "175px",
                      bgcolor: '#FFFFFF',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      overflowY: 'scroll',
                      '-webkit-scrollbar': {
                        display: 'none',
                      },
                      '-ms-overflow-style': 'none' /* IE and Edge */,
                      'scrollbar-width': 'none',
                    }}
                  >
                    <Grid
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        marginTop: '10px',
                      }}
                    >
                      <OwnerCardProfile
                        setProfileDetails={setProfileDetails}
                        showBackdrop={showBackdrop}
                        setSelectedBuyers={setSelectedBuyers}
                        setSelectedBuyerId={setSelectedBuyerId}
                        openOwner={openOwner}
                        setOpenOwner={setOpenOwner}
                        buyerId={buyerId}
                        selectedBuyers={selectedBuyers}
                        open={open}
                        setOpen={setOpen}
                        userType={userType}
                        setExpand={setExpand}
                        expand={expand}
                        data={profileDetails?.OwnerDetails}
                        action={action}
                        handleOptionChange={handleOptionChange}
                        fromSearch={fromSearch}
                        catSelected={catSelected}
                        noteSelected={noteSelected}
                        taskId={taskId}
                        taskBinderId={taskBinderId}
                        buyerpropertylist={buyerpropertylist}
                        loading={loading}
                        profileDetails={profileDetails}
                      />
                      {!expand && (
                        <Grid
                          item
                          xs={12}
                          sx={{ width: '340px', margin: '10px 9px' }}
                        >
                          <Stack
                            sx={{
                              padding: '15px',
                              margin: '5px',
                              border: '1px solid #E7E5E5',
                              borderRadius: '10px',
                              width: '100%',
                              // marginTop: "10px",
                            }}
                          >
                            <Stack
                              sx={{
                                width: '100%',
                                height: '38px',

                                // background: "#F7F8F7",
                                background: '#F7F8F7',
                              }}
                              alignItems={'start'}
                              justifyContent={'center'}
                            >
                              <Typography
                                sx={{
                                  textAlign: 'center',
                                  ...poppins500,
                                  fontSize: '14px',
                                  color: '#26344E',
                                  paddingLeft: '10px',
                                }}
                              >
                                Property Ownership
                              </Typography>
                            </Stack>
                            {Array.isArray(
                              profileDetails?.OwnerDetails?.propertyDetails
                            ) &&
                            profileDetails.OwnerDetails.propertyDetails.length >
                              0 ? (
                              profileDetails.OwnerDetails.propertyDetails.map(
                                (property, index) => {
                                  const formattedSoldDate = moment(
                                    property?.property?.soldDate
                                  ).format('DD-MM-YYYY');
                                  const numberWithCommas = (x) => {
                                    return x
                                      .toString()
                                      .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                                  };
                                  return (
                                    <Card
                                      key={index}
                                      sx={{
                                        padding: '10px',
                                        marginTop: '10px',
                                        minHeight: '205px',
                                        width: '297px',
                                        background: ' #FFFFFF',
                                        boxShadow:
                                          '0px 1px 4px rgba(0, 0, 0, 0.15)',
                                        borderRadius: '6px',
                                      }}
                                    >
                                      <Grid
                                        container
                                        spacing={2}
                                        alignItems="flex-end"
                                        justifyContent="space-between"
                                      >
                                        <Grid item xs={6}>
                                          <Stack spacing={2}>
                                            {property?.propertyMedia?.find(
                                              (media) =>
                                                media.mediaType === 'Image' &&
                                                media.propertyMedia
                                            ) ? (
                                              <img
                                                src={
                                                  property?.propertyMedia?.find(
                                                    (media) =>
                                                      media.mediaType ===
                                                        'Image' &&
                                                      media.propertyMedia
                                                  )?.propertyMedia
                                                }
                                                alt="Image"
                                                height={'125px'}
                                                width={'133px'}
                                                style={{ borderRadius: '6px' }}
                                              />
                                            ) : (
                                              <img
                                                src={PlaceholderImage}
                                                alt="Five cats looking around a field."
                                                height={'125px'}
                                                width={'133px'}
                                                style={{ borderRadius: '6px' }}
                                              />
                                            )}
                                            <Button
                                              variant="text"
                                              sx={{
                                                border: '1px solid #9A9A9F',
                                                ...poppins400,
                                                fontSize: '12px',
                                                color: '#9A9A9F',
                                                borderRadius: '5px',
                                                textTransform: 'capitalize',
                                                height: '30px',
                                              }}
                                            >
                                              {/* {property?.property?.status} */}
                                              {property?.property
                                                ?.isAppraisal == 0 &&
                                              property?.property?.isPipeline ==
                                                1
                                                ? 'Not listed'
                                                : property?.property
                                                    ?.isAppraisal == 1 &&
                                                  property?.property
                                                    ?.isPipeline == 1
                                                ? 'Appraisal'
                                                : property?.property?.status}
                                            </Button>
                                          </Stack>
                                        </Grid>

                                        <Grid item xs={6}>
                                          <Stack
                                            direction={'column'}
                                            spacing={2}
                                            sx={{
                                              minHeight: '170px',
                                              display: 'flex',
                                              justifyContent: 'flex-end',
                                            }}
                                          >
                                            <Stack
                                              direction={'row'}
                                              spacing={2}
                                            >
                                              <Stack
                                                direction={'row'}
                                                spacing={1}
                                                alignItems={'center'}
                                              >
                                                <BedIcon />
                                                <Typography
                                                  sx={{
                                                    ...poppins400,
                                                    fontSize: '12px',
                                                    color: '#000000',
                                                  }}
                                                >
                                                  {
                                                    property
                                                      ?.propertyOtherDetails
                                                      ?.bedRoomCount
                                                  }
                                                </Typography>
                                              </Stack>
                                              <Stack
                                                direction={'row'}
                                                spacing={1}
                                                alignItems={'center'}
                                              >
                                                <ShowerIcon />
                                                <Typography
                                                  sx={{
                                                    ...poppins400,
                                                    fontSize: '12px',
                                                    color: '#000000',
                                                  }}
                                                >
                                                  {
                                                    property
                                                      ?.propertyOtherDetails
                                                      ?.bathRoomCount
                                                  }
                                                </Typography>
                                              </Stack>
                                              <Stack
                                                direction={'row'}
                                                spacing={1}
                                                alignItems={'center'}
                                              >
                                                <CarIcon />
                                                <Typography
                                                  sx={{
                                                    ...poppins400,
                                                    fontSize: '12px',
                                                    color: '#000000',
                                                  }}
                                                >
                                                  {
                                                    property
                                                      ?.propertyOtherDetails
                                                      ?.otherCarParking
                                                  }
                                                </Typography>
                                              </Stack>
                                            </Stack>
                                            <Typography
                                              sx={{
                                                ...poppins400,
                                                ...fontsize10,
                                                color: ' #666666',
                                              }}
                                            >
                                              {
                                                property?.propertyAddress
                                                  ?.streetName
                                              }
                                            </Typography>

                                            {property?.property?.status ==
                                              'Sold' && (
                                              <Box
                                                sx={{
                                                  ...poppins400,
                                                  ...fontsize12,
                                                  width: '175px',
                                                }}
                                              >
                                                <Typography
                                                  sx={{
                                                    ...poppins400,
                                                    ...fontsize10,
                                                    color: '#666666',
                                                  }}
                                                >
                                                  Last Sold: &nbsp;
                                                </Typography>
                                                {property?.property?.soldDate !=
                                                  null && (
                                                  <Typography
                                                    sx={{
                                                      ...poppins500,
                                                      ...fontsize10,
                                                      color: '#000000',
                                                    }}
                                                  >
                                                    {/* 12/01/2001 */}
                                                    {formattedSoldDate}
                                                  </Typography>
                                                )}
                                              </Box>
                                            )}
                                            {property?.property?.status ==
                                              'Sold' && (
                                              <Box
                                                sx={{
                                                  ...poppins400,
                                                  ...fontsize12,
                                                  width: '175px',
                                                }}
                                              >
                                                <Typography
                                                  sx={{
                                                    ...poppins400,
                                                    ...fontsize10,
                                                    color: '#666666',
                                                  }}
                                                  // style={{ color: "rgba(17, 35, 71, 0.5)" }}
                                                >
                                                  Price : &nbsp;
                                                </Typography>
                                                {property?.property
                                                  ?.soldPrice != null && (
                                                  <Typography
                                                    sx={{
                                                      ...poppins500,
                                                      ...fontsize10,
                                                      color: '#000000',
                                                    }}
                                                  >
                                                    {/* $ 1250,000 */}
                                                    {`$${numberWithCommas(
                                                      property?.property
                                                        ?.soldPrice
                                                    )}`}
                                                  </Typography>
                                                )}
                                              </Box>
                                            )}

                                            <Stack>
                                              <Select
                                                id="optionlist"
                                                sx={{
                                                  ...poppins500,
                                                  fontSize: '12px',
                                                  fontColor: '#112347',
                                                  border: '1px solid #6C2AD2',
                                                  width: '130px',
                                                  height: '30px',
                                                  borderRadius: '6px',
                                                  '& .MuiOutlinedInput-notchedOutline':
                                                    {
                                                      border: 'none',
                                                    },
                                                }}
                                                // size="medium"
                                                value={action}
                                                label="Action"
                                                onChange={(e) => {
                                                  handleOptionChange(
                                                    e,
                                                    property
                                                  );
                                                }}
                                                displayEmpty
                                                inputProps={{
                                                  'aria-label': 'Without label',
                                                }}
                                              >
                                                <MenuItem
                                                  value={''}
                                                  sx={{
                                                    ...poppins500,
                                                    fontSize: '12px',
                                                    color: '#112347',
                                                  }}
                                                >
                                                  Action
                                                </MenuItem>
                                                <MenuItem
                                                  value={10}
                                                  sx={{
                                                    ...poppins500,
                                                    fontSize: '12px',
                                                    color: '#112347',
                                                  }}
                                                >
                                                  Insights
                                                </MenuItem>
                                                <MenuItem
                                                  value={20}
                                                  sx={{
                                                    ...poppins500,
                                                    fontSize: '12px',
                                                    color: '#112347',
                                                  }}
                                                >
                                                  Buyer Match
                                                </MenuItem>
                                              </Select>
                                            </Stack>
                                          </Stack>
                                        </Grid>
                                      </Grid>
                                    </Card>
                                  );
                                }
                              )
                            ) : (
                              <Typography
                                sx={{
                                  textAlign: 'center',
                                  ...poppins400,
                                  fontSize: '14px',
                                  color: ' #666666',
                                  marginTop: '10px',
                                }}
                              >
                                {typeof profileDetails?.OwnerDetails
                                  ?.propertyDetails === 'string'
                                  ? profileDetails.OwnerDetails.propertyDetails // Display API message if it is a string
                                  : 'No property found'}
                              </Typography>
                            )}
                          </Stack>
                        </Grid>
                      )}
                      {!expand && (
                        <Box sx={{ width: '340px' }}>
                          <LiveActivityFeed
                            buyerId={buyerId}
                            agentindividual={false}
                            ownercardprop
                            proid={proid}
                            rowData={rowData}
                            expanded={expand}
                          />
                        </Box>
                      )}
                      {!expand && (
                        <Grid
                          sx={{
                            display: 'flex',
                            marginLeft: '75px',
                            padding: '20px',
                            width: '209px',
                            marginBottom: '20px',
                          }}
                        >
                          <Typography sx={displayFlex} style={{ gap: '20px' }}>
                            <Typography style={{ paddingRight: '10px' }}>
                              <Button
                                // variant="contained"
                                sx={{
                                  ...poppins400,
                                  fontSize: '12px',
                                  color: '#6C2AD2',
                                  bgcolor: 'rgba(108, 42, 210, 0.1)',
                                  borderRadius: '4.05125px',
                                  height: '30px',
                                }}
                                onClick={() => {
                                  setOpenFeedback(true);
                                }}
                              >
                                Feedback
                              </Button>
                            </Typography>
                            <Typography>
                              <Select
                                sx={{
                                  ...poppins500,
                                  fontSize: '12px',
                                  color: '#6C2AD2',
                                  border: '1px solid #6C2AD2',
                                  marginLeft: '10px',
                                  height: '30px',
                                  background: '#FFFFFF',
                                  boxShadow: '0px 1px 4px rgba(0, 0, 0, 0.15)',
                                  borderRadius: '5px',
                                  '& .MuiOutlinedInput-notchedOutline': {
                                    border: 'none',
                                  },
                                }}
                                size="small"
                                value="10"
                                style={{
                                  padding: '0px 2px',
                                }}
                                onChange={() => {}}
                                displayEmpty
                                inputProps={{ 'aria-label': 'Without label' }}
                              >
                                <MenuItem value={10}>Action</MenuItem>
                                <MenuItem value={20}>Twenty</MenuItem>
                                <MenuItem value={30}>Thirty</MenuItem>
                              </Select>
                            </Typography>
                          </Typography>
                        </Grid>
                      )}
                      {expand && (
                        <>
                          <Stack
                            sx={{
                              padding: '15px',
                              border: '1px solid #E7E5E5',
                              borderRadius: '10px',
                              marginTop: '10px',
                              width: '340px',
                              height: '218px',
                              marginLeft: '11px',
                            }}
                          >
                            <Stack
                              sx={{
                                width: '296px',
                                height: '38px',
                                background: '#F7F8F7',

                                borderRadius: '6px',

                                marginTop: '2px',
                                marginLeft: '3px',
                                marginRight: '10px',
                                padding: '8px 12px',
                              }}
                              direction="row"
                              align-items="flex-start"
                            >
                              <Typography
                                sx={{
                                  textAlign: 'center',
                                  fontFamily: 'Poppins !important',
                                  fontStyle: 'normal !important',
                                  fontWeight: '500 !important',
                                  fontSize: '14px',
                                  marginLeft: '15px',
                                }}
                              >
                                Activity Overview
                              </Typography>
                            </Stack>

                            <Button
                              onClick={() => {
                                setMarketShow(false);
                                setPropertyColor(
                                  show === true ? '#000000' : '#6C2AD2'
                                );
                              }}
                              sx={{
                                width: '296px',
                                height: '60px',
                                borderRadius: '6px',

                                background: '#FFFFFF',
                                paddingLeft: '10px',
                                paddingRight: '50px',
                                boxShadow: '0px 1px 6px rgba(0, 0, 0, 0.15)',
                                marginTop: '10px',
                                padding: '8px 15px',
                                borderLeft: marketShow
                                  ? '1px solid transparent'
                                  : '5px solid #6C2AD2',
                              }}
                            >
                              <Stack>
                                <Stack
                                  direction={'row'}
                                  padding={'8px 15px'}
                                  color={'#6C2AD2'}
                                  sx={{ paddingRight: '100px' }}
                                >
                                  <Home2
                                    color={
                                      marketShow !== true
                                        ? '#6C2AD2'
                                        : '#666666'
                                    }
                                  />
                                  <Typography
                                    sx={{
                                      fontFamily: 'Poppins !important',
                                      fontStyle: 'normal !important',
                                      fontWeight: '500 !important',
                                      fontSize: '14px',
                                      // color: "#6C2AD2",
                                      color:
                                        marketShow !== true
                                          ? '#6C2AD2'
                                          : '#666666',
                                      padding: '5px 15px',
                                      cursor: 'pointer',
                                      textTransform: 'capitalize',
                                    }}
                                  >
                                    Properties
                                  </Typography>
                                </Stack>
                              </Stack>
                            </Button>
                            <Button
                              onClick={() => {
                                setMarketShow(!marketShow);
                                setMarketColor(
                                  marketShow === true ? '#6C2AD2' : '#666666'
                                );
                              }}
                              sx={{
                                width: '296px',
                                height: '60px',
                                borderRadius: '6px',

                                background: '#FFFFFF',
                                paddingLeft: '10px',
                                paddingRight: '10px',
                                boxShadow: '0px 1px 6px rgba(0, 0, 0, 0.15)',
                                marginTop: '10px',

                                padding: '8px 15px',
                                borderLeft: marketShow
                                  ? '5px solid #6C2AD2'
                                  : '1px solid transparent',
                              }}
                            >
                              <Stack>
                                <Stack
                                  direction={'row'}
                                  padding={'8px 15px'}
                                  sx={{
                                    justifyContent: 'left',
                                    paddingRight: '115px',
                                  }}
                                >
                                  <MarketIcon
                                    color={
                                      marketShow == true ? '#6C2AD2' : '#666666'
                                    }
                                  />
                                  <Typography
                                    sx={{
                                      fontFamily: 'Poppins !important',
                                      fontStyle: 'normal !important',
                                      fontWeight: '500 !important',
                                      fontSize: '14px',
                                      color:
                                        marketShow === true
                                          ? '#6C2AD2'
                                          : '#666666',
                                      padding: '2px 15px',
                                      cursor: 'pointer',
                                      textTransform: 'capitalize',
                                    }}
                                  >
                                    Market
                                  </Typography>
                                </Stack>
                              </Stack>
                            </Button>
                          </Stack>
                        </>
                      )}
                      {expand && (
                        <Box
                          sx={{
                            width: '340px',
                            marginLeft: '13px',
                            marginY: '20px',
                          }}
                        >
                          <MessagingContainer
                            binders={true}
                            ContactUserCard={true}
                            userEmail={profileDetails?.OwnerDetails?.userEmail}
                            proid={proid}
                          />
                        </Box>
                      )}
                      {expand &&
                        (Small || shrink) &&
                        !matches870 &&
                        (openbuyermatch || opendialog) && (
                          <>
                            {opendialog && (
                              <Grid
                                item
                                ref={containerRef}
                                style={{
                                  overflowY: 'scroll',
                                  '-webkit-scrollbar': {
                                    display: 'none',
                                  },
                                  '-ms-overflow-style':
                                    'none' /* IE and Edge */,
                                  'scrollbar-width': 'none',
                                  marginTop: '34px',
                                  marginLeft: matchessm ? '0px' : '20px',
                                }}
                              >
                                <BuyerCard2Insights
                                  ownercardpropaction={true}
                                  onClose={handleClose}
                                  dropdownValue={dropdownValue}
                                  onDropdownChange={handleDropdownChange}
                                />
                              </Grid>
                            )}

                            {openbuyermatch && (
                              <Grid
                                item
                                ref={containerRef}
                                style={{
                                  overflowY: 'scroll',
                                  '-webkit-scrollbar': {
                                    display: 'none',
                                  },
                                  '-ms-overflow-style':
                                    'none' /* IE and Edge */,
                                  'scrollbar-width': 'none',
                                  marginTop: '34px',
                                  marginLeft: '20px',
                                }}
                              >
                                <BuyerCard2Buyermatch
                                  ownercardpropaction={true}
                                  onClose={handleClosebuyermatch}
                                  buyerId={buyerId}
                                  selectedProperty={selectedProperty}
                                />
                              </Grid>
                            )}
                          </>
                        )}
                      {expand && (Small || shrink) && !matches870 && (
                        <Grid
                          item
                          sx={{ marginTop: '15px', marginLeft: '243px' }}
                        >
                          <Button
                            onClick={toggleShow}
                            sx={{
                              background: '#FFFFFF',
                              border: '1px solid #E7E5E5',
                              borderRadius: '5px',
                              color: '#6C2AD2',
                            }}
                          >
                            {buttonText}
                          </Button>
                        </Grid>
                      )}
                    </Grid>
                  </Grid>
                )}
                {expand && (
                  <>
                    {show && (
                      <Grid
                        item
                        xs={2.5}
                        display={'flex'}
                        justifyContent={'flex-start'}
                        flexDirection={'column'}
                        alignItems={'center'}
                        sx={{
                          marginTop: '75px',
                          minWidth: '364px',
                          marginLeft: '20px',
                          overflowY: 'scroll',
                          '-webkit-scrollbar': {
                            display: 'none',
                          },
                          '-ms-overflow-style': 'none' /* IE and Edge */,
                          'scrollbar-width': 'none',
                        }}
                        // sx={{ marginLeft: "32px" }}
                      >
                        <div style={{ width: '100%' }}>
                          <Typography
                            sx={{
                              fontFamily: 'Poppins !important',
                              fontStyle: 'normal !important',
                              fontWeight: '400 !important',
                              fontSize: '16px',
                              color: '#585858',
                              width: '85%',
                              display: 'block',
                              textAlign: 'center',
                              // marginLeft: "-15px",
                            }}
                          >
                            Property Ownership
                          </Typography>

                          <Tabs
                            style={{
                              color: 'purpleHeart',
                              borderBottom: 'purpleheart',
                              paddingLeft: '22px',
                              display: 'false',
                              width: '85%',
                            }}
                            value={value}
                            onChange={handleChange}
                            // aria-label=" tabs example"
                            variant="fullWidth"
                            aria-label="full width tabs example"
                            sx={{
                              '& .MuiTabs-indicator': {
                                backgroundColor: '#6C2AD2',
                                marginBottom: '5px',
                              },
                              '& .MuiTab-root.Mui-selected': {
                                color: '#6C2AD2',
                                fontWeight: '500',
                              },
                            }}
                          >
                            <Tab
                              label="All"
                              {...a11yProps(0)}
                              sx={{
                                fontFamily: 'Poppins !important',
                                fontStyle: 'normal !important',
                                fontWeight: '400 !important',
                                fontSize: '12px',
                                textTransform: 'capitalize',
                              }}
                            />

                            <Tab
                              label="Appraisals"
                              {...a11yProps(1)}
                              sx={{
                                fontFamily: 'Poppins !important',
                                fontStyle: 'normal !important',
                                fontWeight: '400 !important',
                                fontSize: '12px',
                                // color: "#9A9A9F",
                                textTransform: 'none',
                              }}
                            />

                            <Tab
                              label="Inactive"
                              {...a11yProps(2)}
                              sx={{
                                fontFamily: 'Poppins !important',
                                fontStyle: 'normal !important',
                                fontWeight: '400 !important',
                                fontSize: '12px',
                                // color: "#585858",
                                textTransform: 'none',
                              }}
                            />
                          </Tabs>
                          <TabPanel value={value} index={0} width="400px">
                            <All
                              scrollToTopContainer={scrollToTopContainer}
                              setPropertySeletedDetail={
                                setPropertySeletedDetail
                              }
                              setPropertySelected={setPropertySelected}
                              buyerId={buyerId}
                              index={0}
                              buyerpropertylist={buyerpropertylist}
                              proid={proid}
                              setProid={setProid}
                              proUniqueId={proUniqueId}
                              setProUniqueId={setProUniqueId}
                              handleChangePaAddressTwo={
                                handleChangePaAddressTwo
                              }
                              selectedPaBlue={selectedPaBlue}
                              setSelectedPaBlue={setSelectedPaBlue}
                              isPipelineManagement={isPipelineManagement}
                            />
                          </TabPanel>
                          <TabPanel value={value} index={1}>
                            {/* <Appraisal /> */}
                            <All
                              scrollToTopContainer={scrollToTopContainer}
                              setPropertySeletedDetail={
                                setPropertySeletedDetail
                              }
                              setPropertySelected={setPropertySelected}
                              buyerId={buyerId}
                              index={1}
                              buyerpropertylist={buyerpropertylist}
                              proid={proid}
                              setProid={setProid}
                              proUniqueId={proUniqueId}
                              setProUniqueId={setProUniqueId}
                              handleChangePaAddressTwo={
                                handleChangePaAddressTwo
                              }
                              selectedPaBlue={selectedPaBlue}
                              setSelectedPaBlue={setSelectedPaBlue}
                              isPipelineManagement={isPipelineManagement}
                            />
                          </TabPanel>
                          <TabPanel value={value} index={2}>
                            {/* <Inspected /> */}
                            <All
                              scrollToTopContainer={scrollToTopContainer}
                              setPropertySeletedDetail={
                                setPropertySeletedDetail
                              }
                              setPropertySelected={setPropertySelected}
                              buyerId={buyerId}
                              index={2}
                              buyerpropertylist={buyerpropertylist}
                              proid={proid}
                              setProid={setProid}
                              proUniqueId={proUniqueId}
                              setProUniqueId={setProUniqueId}
                              handleChangePaAddressTwo={
                                handleChangePaAddressTwo
                              }
                              selectedPaBlue={selectedPaBlue}
                              setSelectedPaBlue={setSelectedPaBlue}
                              isPipelineManagement={isPipelineManagement}
                            />
                          </TabPanel>
                        </div>
                      </Grid>
                    )}
                  </>
                )}
              </>
            )}
          </Grid>

          {expand && !isSm && (
            <Grid
              item={8}
              flexGrow={1}
              sx={{
                overflowY: 'scroll',
                '-webkit-scrollbar': {
                  display: 'none',
                },
                '-ms-overflow-style': 'none' /* IE and Edge */,
                'scrollbar-width': 'none',
                width:
                  matches1600 && (openbuyermatch || opendialog)
                    ? '30%'
                    : matches1800 && (openbuyermatch || opendialog)
                    ? '50%'
                    : 'auto',
                marginLeft: expand && show && !matches1400 && '-50px',
              }}
            >
              <ExpandedBuyersCard
                ownercardprop
                buyerId={buyerId}
                isHidden={true}
                setShow={setShow}
                show={show}
                action={action}
                setAction={setAction}
                handleOptionChange={handleOptionChange}
                showowner={show}
                rowData={rowData}
                marketShow={marketShow}
                isSmall={isSm}
                buyerpropertylist={buyerpropertylist}
                proid={proid}
                setProid={setProid}
                activitywidth={activitywidth}
                userEmail={profileDetails?.OwnerDetails?.userEmail}
                userType={userType}
                proUniqueId={proUniqueId}
                setProUniqueId={setProUniqueId}
                setExpand={setExpand}
                expand={expand}
                setOpendialog={setOpendialog}
                opendialog={opendialog}
                setOpenbuyermatch={setOpenbuyermatch}
                openbuyermatch={openbuyermatch}
                shrink={shrink}
                selectedPaAddressTwo={selectedPaAddressTwo}
                setSelectedPaAddressTwo={setSelectedPaAddressTwo}
                handleBlueline={handleBlueline}
                isPipelineCat={isPipelineCat}
                pipelineCat={pipelineCat}
                setIsPipelineCat={setIsPipelineCat}
                setPipelineCat={setPipelineCat}
                Propertylist={Propertylist}
                pipelineId={pipelineId}
                setPipelineId={setPipelineId}
                isAppraisal={isAppraisal}
                setIsAppraisal={setIsAppraisal}
                fromSearch={fromSearch}
                catSelected={catSelected}
                noteSelected={noteSelected}
                taskId={taskId}
                taskBinderId={taskBinderId}
                onOpenAutomatedStage={onOpenAutomatedStage}
                onOpenIncompleteDetails={onOpenIncompleteDetails}
                refreshPipeline={refreshPipeline}
                isPipelineManagement={isPipelineManagement}
              />
            </Grid>
          )}

          {matches1250 ? (
            <>
              <Popover
                open={Boolean(anchorEl)}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorReference="none"
                PaperProps={{
                  style: {
                    position: 'absolute',
                    top: matchessm ? 0 : 125,
                    right: 0,
                    transform: 'translate(0, 0)',
                    width: matchessm ? '100vw' : 'auto',
                    maxWidth: matchessm && '100vw',
                    maxHeight: matchessm
                      ? 'calc(100%)'
                      : matches700
                      ? 'calc(81%)'
                      : 'calc(98%)',
                  },
                  sx: { paddingBottom: 'calc(100px + 1em)' },
                }}

                //  anchorOrigin={{
                //    vertical: 'bottom',
                //    horizontal: 'left',
                //  }}
                //  transformOrigin={{
                //    vertical: 'top',
                //    horizontal: 'left',
                //  }}
              >
                {opendialog && (
                  <Grid
                    item
                    style={{
                      overflowY: 'scroll',
                      marginTop: '34px',
                      width: '100%',
                    }}
                  >
                    <BuyerCard2Insights
                      onClose={handleClose}
                      dropdownValue={dropdownValue}
                      onDropdownChange={handleDropdownChange}
                      popover={true}
                      buyerId={buyerId}
                      selectedProperty={selectedProperty}
                    />
                  </Grid>
                )}
              </Popover>
              <Popover
                open={Boolean(buyermatchAnchorEl)}
                anchorEl={buyermatchAnchorEl}
                onClose={handleClosebuyermatch}
                anchorReference="none"
                PaperProps={{
                  style: {
                    position: 'absolute',
                    top: matchessm ? 0 : 125,
                    right: 0,
                    transform: 'translate(0, 0)',
                    width: matchessm ? '100vw' : 'auto',
                    maxWidth: matchessm && 'none',
                    height: '100%',
                    maxHeight: matchessm
                      ? 'calc(100%)'
                      : matches700
                      ? 'calc(81%)'
                      : 'calc(98%)',
                  },
                  sx: { paddingBottom: 'calc(100px + 1em)' },
                }}
              >
                {openbuyermatch && (
                  <Grid
                    item
                    style={{
                      overflowY: 'scroll',
                      marginTop: '34px',
                      width: '100%',
                    }}
                  >
                    <BuyerCard2Buyermatch
                      onClose={handleClosebuyermatch}
                      buyerId={buyerId}
                      selectedProperty={selectedProperty}
                      popover={true}
                      fromInsight={true}
                    />
                  </Grid>
                )}
              </Popover>
            </>
          ) : (
            <>
              {opendialog && !matches1400 && (
                <Grid
                  item
                  style={{
                    overflowY: 'scroll',
                    marginTop: '34px',
                    marginRight: '10px',
                  }}
                >
                  <BuyerCard2Insights
                    onClose={handleClose}
                    dropdownValue={dropdownValue}
                    onDropdownChange={handleDropdownChange}
                  />
                </Grid>
              )}

              {openbuyermatch && !matches1400 && (
                <Grid
                  item
                  style={{
                    overflowY: 'scroll',
                    marginTop: '34px',
                    marginRight: '10px',
                  }}
                >
                  <BuyerCard2Buyermatch
                    onClose={handleClosebuyermatch}
                    buyerId={buyerId}
                    selectedProperty={selectedProperty}
                  />
                </Grid>
              )}
            </>
          )}
        </Stack>
      </Dialog>

      {expand && opendialogexpand && (
        <Grid sx={{ overflow: 'scroll', marginLeft: '20px' }}>
          <BuyerCard2Insights
            onClose={handleCloseExpand}
            propertyOwner={true}
          />
        </Grid>
      )}
      {expand && openbuyermatchexpand && (
        <Grid sx={{ overflow: 'scroll', marginLeft: '20px' }}>
          <BuyerCard2Buyermatch
            onClose={handleCloseExpand}
            propertyBuyer={true}
          />
        </Grid>
      )}

      {(expandFeedback || openFeedback) && (
        <Grid sx={{ marginLeft: '20px' }}>
          <Feedback
            buyerCardOpen={userType === 'Buyer' ? open : openOwner}
            setBuyerCardOpen={userType === 'Buyer' ? setOpen : setOpenOwner}
            userEmail={rowData?.userEmail}
            userType={rowData?.userCategory[0]?.userType}
            address={address}
            data={rowData}
            userName={`${rowData?.user?.userName} ${rowData?.user?.userSurName}`}
            buyerId={buyerId}
            proid={proid}
            expandFeedback={expandFeedback}
            setExpandFeedback={setExpandFeedback}
            openFeedback={openFeedback}
            setOpenFeedback={setOpenFeedback}
            open={open}
            setOpen={setOpen}
            proUniqueId={proid}
            propertyUniqueId={proUniqueId}
            buyerpropertylist={buyerpropertylist}
            marketShow={false}
            row={rowData}
            ownercardprop={userType == 'Vendor' ? true : false}
            directcomm={directcomm}
            index={null}
            setAddress={setAddress}
            userInitial={`${rowData?.user?.userName?.trim()?.charAt(0) || ''}${
              rowData?.user?.userSurName?.trim()?.charAt(0) || ''
            }`.toUpperCase()}
          />
        </Grid>
      )}
    </>
  );
};
export default OwnerCard;
